import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { preRender } from '@syncfusion/ej2-angular-buttons';
import {  Diagram, DiagramTooltipModel, LayerModel, NodeConstraints, NodeModel } from '@syncfusion/ej2-angular-diagrams';
import { zIndex } from 'html2canvas/dist/types/css/property-descriptors/z-index';
import * as JSPDF from 'jspdf';
import { ApiService } from 'src/app/_services/api.service';
import { ImpiantiremotiService } from 'src/app/_services/impiantiremoti.service';
import { DropindataService } from 'src/app/_services/dropindata.service';
import * as FileSaver from 'file-saver';
import { LanguageService } from 'src/app/_services/language.service';
import * as uuid from 'uuid';
import { FreeblocksdataService } from 'src/app/_services/freeblocksdata.service';
import { GlobalService } from 'src/app/_services/global.service';
import { SetprofilodivisorioService } from 'src/app/_services/setprofilodivisorio.service';
import { LunghezzeAngolariService } from 'src/app/_services/lunghezze-angolari.service';
import { file } from '@rxweb/reactive-form-validators';

const marginYTitle=40;
const fontTitleSize=18;
const fontLabelSize=12;
const fattore=50;
const marginLeft=20;
const marginRight=20;

@Injectable({
  providedIn: 'root'
})

export class ModelService  {
  constructor( 
    private lunghezzeAngolariService: LunghezzeAngolariService,
    public globalService:GlobalService,
    private router: Router,    
    private apiService: ApiService,
    private http: HttpClient,
    private impiantiremotiService:ImpiantiremotiService,
    private dropindataService:DropindataService,
    private freeBlocksdataService:FreeblocksdataService,
    private setProfiloDivisorio:SetprofilodivisorioService,
    langService: LanguageService
   
   ) {
    this.lang = langService;
   }
  
  celleConfig:any=null;
  lang:any=undefined;
  
  isSaving:boolean=false;
  
  distintaData:any[]=[];
  // DAGARD DIAGRAMMA INIZIALE CELLE PRECONF

  operazioneInCorso:boolean=false;

  cellaDati:any={};

  /** Riferimento al diagramma Syncfusion di model-design (nodi celle). */
  diagram: Diagram | any = null;

  /**
   * Registro compensatori divisorio tra passate (drawConfigurazione / getObj).
   * Chiave: `${cellaId}::${lato}` → quote locali sul lato.
   */
  compensoDivisorioReg: Map<string, number[]> = new Map();

  objCella:any={};
  objVespaio:any={};
  objTravi:any={};
  objSoffitto:any={};
  objPavimento:any={};
  objLatSin:any={};
  objDivisori:any=[];
  objLatDs:any={};
  objFronte:any={};
  objRetro:any={};

  startLeft:number=0;
  codiciPertendeAStrisce:any[]=[];

  colorPortaHex=0xAAA88A;
  pannelloAzzurroHex=0x7ACEE8;
  pannelloPannaHex=0xFFFEE5;
  colorevespaioHex=0x00FF21;
  coloreSfondoCella='#FFF9EF';
  
  colorPorta='#AAA88A';
  pannelloAzzurro='#7ACEE8';
  pannelloPanna='#D6D38F';
  angolarePanna='#CCC';
  colorevespaio='#00FF21';
  coloreDivisorio='#EEDC00';
  


  public currCellaInd=-1; 
  public cellaCollegataInd=-1; 
  public currPortaId=''; 
  public currPortaInd=-1; 
  public currPortaScollegataInd=-1; 
  public currCellaSucc=-1;
  public currLatoDivisorio='';
  public cellaCombinataInd=-1;
  public cellaCombinataLatoCollegato:any='';
  public cellaCombinataDiverseMisure:boolean=false;
  public currFreeBlockInd=-1;
  public currrFreeBlockCellaInd=-1;
  public currrFreeBlockCellaLato='';
  public currDropinInd=-1;
  public currVespaio:any=null;
  
  public currImpiantoInd=-1;
  public currimpiantiRemotiTipo='';
  public currCollegamento:any=null;
  public currPannelloInd=-1;
  public currPannelloCellaInd=-1;
  public currPannelloCellaLato='';
  public currScaffaleInd=-1;
  public currScaffaleCellaInd=-1;
  public portaDivisorio=false;
  public currAngolareCellaInd=-1;
  public currAngolareAngolo='';
  public portaConfigurataOpzioni:any=[];
  public portaConfigurataMandatory:any=[];
  public impiantoRemotoOpzioni:any=[];
  public impiantoRemotoTipiOpt:any=[];
  public freeblocksTipiOpt:any[]=[];
  public dropinTipiOpt:any[]=[];

  public impiantoRemotoMandatory:any=[];
  public impiantoRemotoOpzioniData:any={
    gruppi:[],
    opzioni:[]
  };
  public irData:any=[]; // dati del servizio locale
  public message='';
    
  
  public nodes: NodeModel[] = [];

  public impiantoNumerotubiList=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20];
  public tipoCollegamentoCellaOptions:any=[];
  public tipoCollegamentoCellaOptions2:any=[];  
  public pannelloPlasticContent='<div style="width:100%;height:100%;border:2px solid #ddd;background-color:Red"></div>' ;
  public pannelloInoxContent='<div style="width:100%;height:100%;border:2px solid #ddd;background-color:Red"></div>' ;
  public pannelloPortaContent='<div style="width:100%;height:100%;border:2px solid #ddd;background-color:Red"></div>' ;

  
  public angolarePlasticContent='<div style="width:100%;height:100%;border:2px solid #ddd;background-color:Red"></div>' ;
  public angolareInoxContent='<div style="width:100%;height:100%;border:2px solid #ddd;background-color:Red"></div>' ;

  public tooltipNode: DiagramTooltipModel= {
        content: '',
        relativeMode: 'Object'
  }
  public nodeMiniCella:NodeModel={
          id :'minicella',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          width: 320,
          height: 320,
          zIndex:0,
          addInfo:{
            type:'cella',
            isMiniCella:true,
            customClient:'',
            title:'320x320',
            nodeWidth:320,
            nodeHeight:320
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;text-align:center;">DIMENSIONI</div>' 
          }
        };

  public nodeCella:NodeModel={
          id :'cella',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate,
          // Size of the node
          width: 320,
          height: 320,
          zIndex:1000,
          addInfo:{
            type:'cella',
            title:'320x320',
            isMiniCella:false,
            customClient:'',
            nodeWidth:320,
            nodeHeight:320
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="margin:-6px;width:100%;height:100%;border:3px solid #ddd;"></div>' 
          },
          annotations:[{content:'', horizontalAlignment:'Center',style:{
            color:'Blue'  
            }
          }]
        };
  public nodeCellaCombinataTop:NodeModel={
          id :'cellacombinatatop',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.ResizeNorth 
          & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeNorthWest,
          // Size of the node
          width: 320,
          height: 320,
          zIndex:1,
          addInfo:{
            type:'cella',
            subtype:'cellacombinatatop',
            title:'320x320',
            nodeWidth:320,
            nodeHeight:320,
            collegamento:'top'
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:3px solid #ddd;border-top:none;"></div>' 
          },
          annotations:[{content:'', horizontalAlignment:'Center',style:{
            color:'Blue'  
            }
          }]
        };
  public nodeCellaCombinataBottom:NodeModel={
          id :'cellacombinatabottom',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.ResizeSouth 
          & ~NodeConstraints.ResizeSouthWest & ~NodeConstraints.ResizeSouthEast,
          // Size of the node
          width: 320,
          height: 320,
          zIndex:1,
          addInfo:{
            type:'cella',
            subtype:'cellacombinatabottom',
            title:'320x320',
            nodeWidth:320,
            nodeHeight:320,
            collegamento:'bottom'
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:3px solid #ddd;border-bottom:none;"></div>' 
          },
          annotations:[{content:'', horizontalAlignment:'Center',style:{
            color:'Blue'  
            }
          }]
        };
    public nodeCellaCombinataLeft:NodeModel={
          id :'cellacombinataleft',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.ResizeWest 
          & ~NodeConstraints.ResizeSouthWest & ~NodeConstraints.ResizeNorthWest,
          // Size of the node
          width: 320,
          height: 320,
          zIndex:1,
          addInfo:{
            type:'cella',
            subtype:'cellacombinataleft',
            title:'320x320',
            nodeWidth:320,
            nodeHeight:320,
            collegamento:'left'
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:3px solid #ddd;border-left:none;"></div>' 
          },
          annotations:[{content:'', horizontalAlignment:'Center',style:{
            color:'Blue'  
            }
          }]
        };
    public nodeCellaCombinataRight:NodeModel={
          id :'cellacombinataright',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate& ~NodeConstraints.ResizeEast 
          & ~NodeConstraints.ResizeSouthEast & ~NodeConstraints.ResizeNorthEast,
          // Size of the node
          width: 320,
          height: 320,
          zIndex:1,
          addInfo:{
            type:'cella',
            subtype:'cellacombinataright',
            title:'320x320',
            nodeWidth:320,
            nodeHeight:320,
            collegamento:'right'
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:3px solid #ddd;border-right:none;"></div>' 
          },
          annotations:[{content:'', horizontalAlignment:'Center',style:{
            color:'Blue'  
            }
          }]
        };
       
  public nodeAngolare:any={
          id :'angolare',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.ResizeNorth & ~NodeConstraints.ResizeSouth,
          // Size of the node
          width: 15,
          height: 15,
          zIndex:10,
          addInfo:{
            type:'angolare',
            nodeWidth:15,
            nodeHeight:15
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:2px solid #ddd;background-color:Red"></div>' 
          }
        };
  public nodePannello:any={
          id :'pannello',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          width: 10,
          height: 120,
          zIndex:-100,
          addInfo:{
            type:'pareti',
            nodeWidth:10,
            nodeHeight:120
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:2px solid #ddd;background-color:Red"></div>' 
          }
        };
        
  public nodePannelloOrizz:any={
          id :'pannelloorizz',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          height: 10,
          width: 120,
          zIndex:-100,
          addInfo:{
            type:'pareti',
            nodeWidth:120,
            nodeHeight:10
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:2px solid #ddd;background-color:Red"></div>' 
          }
        };  
        public nodePannelloOrizzPorta:any={
          id :'pannelloorizzporta',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          height: 10,
          width: 120,
          zIndex:-100,
          addInfo:{
            type:'pareti',
            nodeWidth:120,
            nodeHeight:10
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:2px solid #ddd;background-color:Red"></div>' 
          }
        };  
  public nodeMISAERM:any={
          id :'impiantoRemotoMISAERM',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          height: 120,
          width: 120,
          addInfo:{
            type:'impiantoRemoto',
            nodeWidth:120,
            nodeHeight:120,
            title:'MISAERM',
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:2px solid #aaa;"></div>' 
          },
          annotations:[{content:'MISAERM', horizontalAlignment:'Center',style:{
            color:'Blue'  
           }}]
        };  
  public nodeMS:any={
          id :'impiantoRemotoMS',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          height: 120,
          width: 120,
          addInfo:{
            type:'impiantoRemoto',
            nodeWidth:120,
            nodeHeight:120,
            title:'MS'
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:2px solid #aaa;"></div>' 
          },
          annotations:[{content:'MS', horizontalAlignment:'Center',style:{
            color:'Blue'  
            }}]
        };  
  public nodeMSG:any={
          id :'impiantoRemotoMSG',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          height: 120,
          width: 120,
          addInfo:{
            type:'impiantoRemoto',
            nodeWidth:120,
            nodeHeight:120,
            title:'MSG'
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:2px solid #aaa;"></div>' 
          },
          annotations:[{content:'MSG', horizontalAlignment:'Center',style:{
            color:'Blue'  
           }}]
        };  
  public nodeREFREEX:any={
          id :'impiantoRemotoREFREEX',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          height: 120,
          width: 120,
          addInfo:{
            type:'impiantoRemoto',
            nodeWidth:120,
            nodeHeight:120,
            title:'REFREEX'
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:2px solid #aaa;"></div>' 
          },
          annotations:[{content:'REFREEX', horizontalAlignment:'Center',style:{
            color:'Blue'  
           }}]
        };  
    public nodeS_CAR:any={
          id :'impiantoRemotoS_CAR',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          height: 120,
          width: 120,
          addInfo:{
            type:'impiantoRemoto',
            nodeWidth:120,
            nodeHeight:120,
            title:'S_CAR'
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:2px solid #aaa;"></div>' 
          },
          annotations:[{content:'S-CAR', horizontalAlignment:'Center',style:{
            color:'Blue'  
         }}]
        };  
     public nodeSEE:any={
          id :'impiantoRemotoSEE',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          height: 120,
          width: 120,
          addInfo:{
            type:'impiantoRemoto',
            nodeWidth:120,
            nodeHeight:120,
            title:'SEE'
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:2px solid #aaa;"></div>' 
          },
          annotations:[{content:'SEE', horizontalAlignment:'Center',style:{
            color:'Blue'  
            }}]
        };  
      
    public nodeSEEW:any={
          id :'impiantoRemotoSEEW',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          height: 120,
          width: 120,
          addInfo:{
            type:'impiantoRemoto',
            nodeWidth:120,
            nodeHeight:120,
            title:'SEEW'
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:2px solid #aaa;"></div>' 
          },
          annotations:[{content:'SEEW', horizontalAlignment:'Center',style:{
            color:'Blue'  
           }}]
        };  
  public nodeSILENT:any={
          id :'impiantoRemotoSILENT',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          height: 120,
          width: 120,
          addInfo:{
            type:'impiantoRemoto',
            nodeWidth:120,
            nodeHeight:120,
            title:'SILENT'
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="width:100%;height:100%;border:2px solid #aaa;"></div>' 
          },
          annotations:[{content:'SILENT', horizontalAlignment:'Center',style:{
            color:'Blue'  
           }}]
        };  

  public nodeDivisorioOrizz:any={
          id :'divisorioorizz',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          height: 120,
          width: 10,
          addInfo:{
            type:'divisorioorizz',
            nodeWidth:120,
            nodeHeight:10,
            title:'DIVISORIO'
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="margin-top:45%;width:100%;height:10%;border:2px solid #999;"></div>' 
          }
         
        };  
     public nodeDivisorioVert:any={
          id :'divisoriovert',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          height: 120,
          width: 10,
          addInfo:{
            type:'divisoriovert',
            nodeWidth:10,
            nodeHeight:120,
            title:'DIVISORIO'
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="margin-left:45%;width:10%;height:100%;border:2px solid #999;"></div>' 
          }
         
        };  
  public divisirioVertContent='<div style="width:100%;height:100%;border:2px solid #999;"></div>' ;
  public divisirioOrizzContent='<div style="width:100%;height:100%;border:2px solid #999;"></div>' ;
  public portaScorrContent='<div style="margin-top:80%;width:100%;height:20%;border:2px solid #999;"></div>' ;
  
  public scaffaleContent=`<div style="overflow:hidden;width:100%;height:100%;border:3px solid #999;
  background-image: repeating-linear-gradient(to bottom, transparent, transparent 2px, #ccc 2px, #ccc 5px),
                    repeating-linear-gradient(to right, #617ca2, #617ca2 2px, #ccc 5px, #ccc 5px);"></div>`;      

                    
 public scaffaleContentIcon=`<div style="margin-top:20%;overflow:hidden;width:100%;height:60%;border:3px solid #999;
  background-image: repeating-linear-gradient(to bottom, transparent, transparent 2px, #ccc 2px, #ccc 5px),
                    repeating-linear-gradient(to right, #617ca2, #617ca2 2px, #ccc 5px, #ccc 5px);"></div>`;      
 public scaffaleContentIconVert=`<div style="margin-left:20%;ooverflow:hidden;width:40%;height:100%;border:3px solid #999;
  background-image: repeating-linear-gradient(to bottom, transparent, transparent 2px, #ccc 2px, #ccc 5px),
                    repeating-linear-gradient(to right, #617ca2, #617ca2 2px, #ccc 5px, #ccc 5px);"></div>`;      


  public nodeScaffale37130:any={
          id :'scaffale37130',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeNorth & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeNorthWest 
          & ~NodeConstraints.ResizeSouth & ~NodeConstraints.ResizeSouthEast & ~NodeConstraints.ResizeSouthWest ,     // Size of the node
          height: 37,
          width: 130,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeWidth:130,
            id :'scaffale37130',
            title:'37x130',
            nodeHeight:37
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  }; 
  
  public nodeScaffale3765:any={
          id :'scaffale3765',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeNorth & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeNorthWest 
          & ~NodeConstraints.ResizeSouth & ~NodeConstraints.ResizeSouthEast & ~NodeConstraints.ResizeSouthWest ,     // Size of the node
          height: 37,
          width: 65,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeWidth:65,
            id :'scaffale3765',
            title:'37x65',
            nodeHeight:37
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  }; 

  public nodeScaffale37118:any={
          id :'scaffale37118',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeNorth & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeNorthWest 
          & ~NodeConstraints.ResizeSouth & ~NodeConstraints.ResizeSouthEast & ~NodeConstraints.ResizeSouthWest ,     // Size of the node
          height: 37,
          width: 118,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeWidth:118,
            id :'scaffale37118',
            title:'37x118',
            nodeHeight:37
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  }; 
  public nodeScaffale4765:any={
          id :'scaffale4765',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeNorth & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeNorthWest 
          & ~NodeConstraints.ResizeSouth & ~NodeConstraints.ResizeSouthEast & ~NodeConstraints.ResizeSouthWest ,     // Size of the node
          height: 47,
          width: 65,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeWidth:65,
            id :'scaffale4765',
            title:'47x65',
            nodeHeight:47
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  }; 
  public nodeScaffale5671:any={
          id :'scaffale5671',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeNorth & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeNorthWest 
          & ~NodeConstraints.ResizeSouth & ~NodeConstraints.ResizeSouthEast & ~NodeConstraints.ResizeSouthWest ,     // Size of the node
          height: 56,
          width: 71,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeWidth:71,
            id :'scaffale5671',
            title:'56',
            nodeHeight:56
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  }; 
  
  public nodeScaffale5671R:any={
          id :'scaffale5671R',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeEast & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeSouthEast 
          & ~NodeConstraints.ResizeWest & ~NodeConstraints.ResizeSouthWest & ~NodeConstraints.ResizeNorthWest ,     // Size of the node
          width: 56,
          height: 71,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeHeight:71,
            id :'scaffale3771R',
            title:'56x71 R',
            nodeWidth:56
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  }; 
  public nodeScaffale37118R:any={
          id :'scaffale37118R',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeEast & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeSouthEast 
          & ~NodeConstraints.ResizeWest & ~NodeConstraints.ResizeSouthWest & ~NodeConstraints.ResizeNorthWest ,     // Size of the node
          width: 37,
          height: 118,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeHeight:118,
            id :'scaffale37118R',
            title:'37x118 R',
            nodeWidth:37
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  }; 

  public nodeScaffale4765R:any={
          id :'scaffale4765R',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeEast & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeSouthEast 
          & ~NodeConstraints.ResizeWest & ~NodeConstraints.ResizeSouthWest & ~NodeConstraints.ResizeNorthWest ,     // Size of the node
          width: 47,
          height: 65,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeHeight:65,
            id :'scaffale4765R',
            title:'47x65 R',
            nodeWidth:47
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  }; 


  public nodeScaffale3765R:any={
          id :'scaffale3765R',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeEast & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeSouthEast 
          & ~NodeConstraints.ResizeWest & ~NodeConstraints.ResizeSouthWest & ~NodeConstraints.ResizeNorthWest ,     // Size of the node
          width: 37,
          height: 65,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeHeight:65,
            id :'scaffale3765R',
            title:'37x65 R',
            nodeWidth:37
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  }; 
  
  public nodeScaffale37130R:any={
          id :'scaffale37130R',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
         & ~NodeConstraints.ResizeEast & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeSouthEast 
          & ~NodeConstraints.ResizeWest & ~NodeConstraints.ResizeSouthWest & ~NodeConstraints.ResizeNorthWest ,     // Size of the node
          height: 130,
          width: 37,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeWidth:37,
            id :'scaffale37130R',
            title:'37x130 R',
            nodeHeight:130
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  };     

  public nodeScaffale47130:any={
          id :'scaffale47130',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeNorth & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeNorthWest 
          & ~NodeConstraints.ResizeSouth & ~NodeConstraints.ResizeSouthEast & ~NodeConstraints.ResizeSouthWest ,    // Size of the node
          height: 47,
          width: 130,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeWidth:130,
            id :'scaffale47130',
            title:'47x130',
            nodeHeight:47
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  };   
  public nodeScaffale47118:any={
          id :'scaffale47118',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeNorth & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeNorthWest 
          & ~NodeConstraints.ResizeSouth & ~NodeConstraints.ResizeSouthEast & ~NodeConstraints.ResizeSouthWest ,    // Size of the node
          height: 47,
          width: 118,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeWidth:118,
            id :'scaffale47118',
            title:'47x118',
            nodeHeight:47
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  };   
  public nodeScaffale47118R:any={
          id :'scaffale47118R',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
         & ~NodeConstraints.ResizeEast & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeSouthEast 
          & ~NodeConstraints.ResizeWest & ~NodeConstraints.ResizeSouthWest & ~NodeConstraints.ResizeNorthWest ,     // Size of the node
           height: 118,
          width: 47,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeWidth:47,
            id :'scaffale47118R',
            title:'47x118 R',
            nodeHeight:118
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  };   

  public nodeScaffale47130R:any={
          id :'scaffale47130R',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
         & ~NodeConstraints.ResizeEast & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeSouthEast 
          & ~NodeConstraints.ResizeWest & ~NodeConstraints.ResizeSouthWest & ~NodeConstraints.ResizeNorthWest ,     // Size of the node
            height: 130,
          width: 47,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeWidth:47,
            id :'scaffale47130R',
            title:'47x130R',
            nodeHeight:130
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  };   

  public nodeScaffale56136:any={
          id :'scaffale56136',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeNorth & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeNorthWest 
          & ~NodeConstraints.ResizeSouth & ~NodeConstraints.ResizeSouthEast & ~NodeConstraints.ResizeSouthWest ,
          // Size of the node
          height: 56,
          width: 136.5,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeWidth:136.5,
            id :'scaffale56136',
            title:'56x136.5',
            nodeHeight:56
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  };   

  public nodeScaffale56125:any={
          id :'scaffale56125',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeNorth & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeNorthWest 
          & ~NodeConstraints.ResizeSouth & ~NodeConstraints.ResizeSouthEast & ~NodeConstraints.ResizeSouthWest ,    // Size of the node
      
          // Size of the node
          height: 56,
          width: 125.5,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeWidth:125.5,
            id :'scaffale56125',
            title:'56x125.5',
            nodeHeight:56
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  };   

  public nodeScaffale56125R:any={
          id :'scaffale56125R',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
        & ~NodeConstraints.ResizeEast & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeSouthEast 
          & ~NodeConstraints.ResizeWest & ~NodeConstraints.ResizeSouthWest & ~NodeConstraints.ResizeNorthWest ,     // Size of the node
           // Size of the node
          height: 125.5,
          width: 56,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeWidth:56,
            id :'scaffale56125R',
            title:'56x125.5 R',
            nodeHeight:125.5
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  };   

  public nodeScaffale56136R:any={
          id :'scaffale56136R',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate 
          & ~NodeConstraints.ResizeEast & ~NodeConstraints.ResizeNorthEast & ~NodeConstraints.ResizeSouthEast 
          & ~NodeConstraints.ResizeWest & ~NodeConstraints.ResizeSouthWest & ~NodeConstraints.ResizeNorthWest ,     // Size of the node
             // Size of the node
          width: 56,
          height: 136.5,
          zIndex:.9999,
          addInfo:{
            type:'scaffale',
            nodeHeight:136.5,
            id :'scaffale56136R',
            title:'56x136.5 R',
            nodeWidth:56
          },
          shape:{ 
            type : 'HTML', 
            content:''
          }
  };    


  public nodeDropIn:NodeModel={ 
        id:'Dropin',
          width:90,
          height:90,
          dragSize:{width:30,height:30},
          addInfo:{
            type:'dropin',
            nodeWidth:90,
            title:'DI',
            nodeHeight:90
          },
          tooltip:{content:'Dropin'},
           constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          shape :{ type: 'HTML', 
              content:'<div style="width:100%;height:100%;border:2px solid black;"></div>' 
          },
          annotations:[{content:'DROPIN', horizontalAlignment:'Center',style:{
            color:'Blue'  
           }}]
        };

  public nodeFreeBlock1:NodeModel={
      id :'freeblock1',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          width: 80,
          height: 80,
          addInfo:{
            type:'freeblock',
            title:'80x40',
            dimensione:'80x40',
            nodeWidth:80,
            nodeHeight:80
          },
          shape:{ 
            type: 'HTML', 
            content:`<div style="width:100%;height:100%;"><div style="width:100%;height:50%;border:2px solid Black;background-color:White;"></div>
            <div style="margin-left: 20%;margin-right: auto;width:100%;height:100%;">       
             <div style="width:60%;height:50%;margin-top:-2px;border-bottom:2px solid Black;border-right:2px solid Black;border-left:2px solid Black;background-color:White;"></div>
             </div>
             </div>   `
          }
          

  };
  
  public nodeFreeBlockUniversal:NodeModel={
    id :'nodeFreeBlockUniversal',
        constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
        // Size of the node
        width: 80,
        height: 80,
        addInfo:{
          type:'freeblock',
          title:'UNIVERSAL',
          dimensione:'80x40',
          subType:'Universal',
          nodeWidth:80,
          nodeHeight:80
        },
        shape:{ 
          type: 'HTML', 
          content:`<div style="width:100%;height:100%;"><div style="width:100%;height:50%;border:2px solid Blue;background-color:White;"></div>
          <div style="margin-left: 20%;margin-right: auto;width:100%;height:100%;">       
           <div style="width:60%;height:50%;margin-top:-2px;border-bottom:2px solid Black;border-right:2px solid Blue;border-left:2px solid Blue;background-color:White;"></div>
           </div>
           </div>   `
        }
        

  };

  public nodeFreeBlock2:any={
          id :'nodeFreeBlock2',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          height: 80,
          width: 80,
          addInfo:{
            type:'freeblock',
            dimensione:'40x80',
            title:'40x80',
            nodeWidth:80,
            nodeHeight:80
          },
          shape:{ 
            type : 'HTML', 
            content:  `<div style="width:100%;height:100%;margin-left:25%;">
            <div style="width:50%;height:100%;border:2px solid Black;background-color:White"></div>
            </div> `
          }
          
        };      
            
  public nodePortaSN:NodeModel={
          id :'portaSN',
          constraints:(NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize),
          // Size of the node
          width: 80,
          height: 80,
          zIndex:.9999,
          addInfo:{
            type:'porta',
            title:'L',
            apertura:2,
            nodeWidth:80,
            nodeHeight:80
          },
          shape:{ 
            type : 'HTML', 
            content:`<div class="portaSN"></div>`
          
          }
          
  };
   /*
   type : 'HTML', 
            content:`<div class="containerpannelloPorta">
            <div class="colonnapannelloPorta pannelloPorta"></div><div class="colonnapannelloPorta portaSN"></div><div class="colonnapannelloPorta pannelloPorta"></div>
            </div>`
  */
  public nodePortaDS:NodeModel={
          id :'portaDs',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          offsetX: 200,
          offsetY:200,
          // Size of the node
          width: 80,
          height: 80,
          addInfo:{
            type:'porta',
            title:'R',
            apertura:1,
            nodeWidth:80,
            nodeHeight:80
          },
          shape:{ 
            type : 'HTML', 
            content:`<div class="portaDX"></div>`
          }
       
          
  };
  public nodePortaScorrIndSN:any={
          id :'portaScorrIndSN',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          width: 80,
          height: 80,
          addInfo:{
            type:'porta',
            title:'SC IND L',
            apertura:2,
            nodeWidth:80,
            nodeHeight:80
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="margin-top:80%;width:100%;height:20%;border:2px solid #999;"><div class="arrow-left"></div></div>' 
          }
         
  };
  public nodePortaScorrIndDs:any={
          id :'portaScorrIndDx',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          width: 80,
          height: 80,
          addInfo:{
            type:'porta',
            title:'SC IND R',
            apertura:1,
            nodeWidth:80,
            nodeHeight:80
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="margin-top:80%;width:100%;height:20%;border:2px solid #999;"><div class="arrow-right"></div></div>' 
          }
         
  };
  public nodePortaScorrSn:any={
          id :'portaScorrSn',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          width: 80,
          height: 80,
          addInfo:{
            type:'porta',
            title:'SC L',
            apertura:2,
            nodeWidth:80,
            nodeHeight:80
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="margin-top:80%;width:100%;height:20%;border:2px solid #999;"><div class="arrow-left"></div></div>' 
          }
         
  };
  public nodePortaScorrDs:any={
          id :'portaScorrDs',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          width: 80,
          height: 80,
          addInfo:{
            type:'porta',
            title:'SC R',
            apertura:1,
            nodeWidth:80,
            nodeHeight:80
          },
          shape:{ 
            type : 'HTML', 
            content:'<div style="margin-top:80%;width:100%;height:20%;border:2px solid #999;"><div class="arrow-right"></div></div>' 
          }
         
  };
    
  public nodePortaSNInd:NodeModel={
          id :'portaSNInd',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          // Size of the node
          width: 80,
          height: 80,
          addInfo:{
            type:'porta',
            title:'IND L',
            apertura:2,
            nodeWidth:80,
            nodeHeight:80
          },
          shape:{ 
            type : 'HTML', 
            content:`<div class="portaSN"></div>`
          }
       
  };
  public nodePortaDSInd:NodeModel={
          id :'portaDsInd',
          constraints:NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize,
          offsetX: 200,
          offsetY:200,
          // Size of the node
          width: 80,
          height: 80,
          addInfo:{
            type:'porta',
            title:'IND R',
            apertura:1,
            nodeWidth:80,
            nodeHeight:80
          },
          shape:{ 
            type : 'HTML', 
            content:`<div class="portaDX"></div>`
          }
       
       
          
  };

  scaffLlargh37:any[]=[
    65,
    77,
    89,
    94,
    106,
    118,
    130,
    148,
    160,
  ]; 
  scaffLlargh56:any[]=[
    71,
    82,
    93,
    103.5,
    114.5,
    125.5,
    136.5,
    147,
    158,
  ]; 
  scaffLlargh47:any[]=[
    65,
    77,
    89,
    94,
    106,
    118,
    130,
    148,
    160,
  ]    
  scaffAltezze:any[]=[
    170,200
  ];

 public scaffaliPreCof_L:any[]=[];
 public scaffaliPreCof_LU:any[]=[];
 
  

  tipo1PortaOptions:any[]=[
    {value:'MODULO',label:'MODULO'},
    {value:'DAGARD',label:'MISTRAL'},
    {value:'ELX',label:'ELX'}
    
  ];

  divisorioPortaOptions:any[]=[
    {value:1,label:'Si'}
  ];
  pavimentoPortaOptions:any[]=[
    {value:1,label:'Si'},
    {value:0,label:'NO'}
  ];
  versoaperturaPortaOptions:any[]=[
    {value:1,label:'Dx'},
    {value:2,label:'Sx'}
  ];
  divisorioCellaOptions:any[]=[];
  dropInOptions:any={
    IdTemperaturaInterna:[],
    IdTemperaturaEsterna:[]
  }
  freeBlockOptions:any={
    IdTemperaturaInterna:[],
    IdTemperaturaEsterna:[]
  }
  impiantiRemotiOptions:any={
    MS:{
      IdTemperaturaInterna:[],
      IdTemperaturaEsterna:[],
      Volume:[],
    },
     MISAERM:{
      IdTemperaturaInterna:[],
      IdTemperaturaEsterna:[],
      Volume:[],
    },
    MSG:{
      IdTemperaturaInterna:[],
      IdTemperaturaEsterna:[],
      Volume:[],
    },    
    REFREEX:{
      IdTemperaturaInterna:[],
      IdTemperaturaEsterna:[],
      Volume:[],
    },    
    S_CAR:{
      IdTemperaturaInterna:[],
      IdTemperaturaEsterna:[],
      Volume:[],
    },    
    SEE:{
      IdTemperaturaInterna:[],
      IdTemperaturaEsterna:[],
      Volume:[],
    },
    SEEW:{
      IdTemperaturaInterna:[],
      IdTemperaturaEsterna:[],
      Volume:[],
    },
    SILENT:{
      IdTemperaturaInterna:[],
      IdTemperaturaEsterna:[],
      Volume:[],
    },
  };
  distSnPortaOptions=[0];

  tipologiaPortaOptions=[
    {
      value:'STANDARD',
      label:'STANDARD'
    },
    {
      value:'SCORREVOLI',
      label:'SCORREVOLI'
    },
    {
      value:'INDUSTRIALI BATTENTE',
      label:'INDUSTRIALI BATTENTE'
    },
    {
      value:'INDUSTRIALI SCORREVOLI',
      label:'INDUSTRIALI SCORREVOLI'
    }
  ];
  
  
  tipoPortaOptions=[
    'STANDARD',
    'INOX_INT',
    'INOX_EST',
    'INOX_IE'
  ];
  
  altezzaOptions=[200, 220, 240, 260,280,300,320];
  altezzaOptionsAll=[200, 220, 240, 260,280,300,320];
  altezzaOptionsSp13=[200, 240, 280,320];

  altezzaMiniCelleOptions=[200, 240];
  altezzaMiniCelleOptionsElectrolux=[200];
  impiantiMiniCelleOptions:any[]=[];

  
  freeBlockElectrolux=['XC0449931','XC0449932','XC0449933','XC0449934','XC0450031','XC0450032','XC0450033','XC0450034']
  impiantiRemotiMSElectrolux=['XMS073990','XMS073991','XMS073992','XMS073993','XMS073994','XMS073995','XMS073996']
  impiantiRemotiMSGElectrolux=['XC0450131','XC0450132','XC0450133','XC0450134','XC0450231','XC0450232','XC0450233']

  passoOptions=[20,40];
  altezzaOrizzOptions=[4, 7, 8, 11];
  tipoCellaOptions:any[]=[];
  finituraOptions=['STANDARD', 'INOX_INT', 'INOX_EST','INOX_IE'];
  finituraOrizzOptions=['STANDARD', 'INOX_INT', 'INOX_EST','INOX_IE'];
  spessoreOptions=[6,10,13];
  spessoreOptionsCombinate=[6,10];
  spessoreDroInOptions=[6,10];
  tempInt=[
     '-2/+8',
    '-18/-20'
  ];
  tempIntSp6=[
     '-2/+8'
  ];
  tempEst=[
    32,
    43
  ];
  controlloreOptions=[
     'Carel',
     'Eliwell'
  ];

  finituraAngolariOptions=[
    {
      value:'STANDARD',
      label:'STANDARD'
    },
    {
      value:'INOX_INT',
      label:'INOX'
    }
  ];

  finituraPavimentoOptions=[
    {
      value:'CAR_PL',
      label:'Pavimento carrabile P400'
    },
    {
      value:'CAR_IXI',
      label:'Pavimento carrabile inox interno P400 IX I'
    },
    {
      value:'CAR_IXE',
      label:'Pavimento carrabile inox esterno P400 IX E'
    },
    {
      value:'PED_PL',
      label:'Pavimento pedonabile PED'
    },
    {
      value:'P1000',
      label:'Pavimento P1000 ST'
    },
    {
      value:'P1000IX',
      label:'Pavimento stratificato fenolico inox interno P1000 IX'
    },
    {
      value:'P1000IXE',
      label:'Pavimento carrabile rinforzato inox esterno P1000 IX E'
    },
    {
      value:'WALL_PANEL',
      label:'Pannello plastificato'
    }
  ];

  finituraDivisoriOptions=['STANDARD', 'INOX_INT', 'INOX_EST','INOX_IE'];
  divisoriSpessoreOptions=[6,10,13];
  scaffaliAltezzeOptions=[167,200];
  scaffaliRipianiOptions=[1,2,3,4,5,6,7,8,9,10];
  collegamentoCellaOptions:any[]=[];

  model:any={};
  pdf:any;

  


  line(x1:number,y1:number,x2:number,y2:number,label='',labelPosition=''){
    const spaziotop= 1;
    const spazioleft= 2;
    this.pdf.line(x1,y1 ,x2, y2);
    if(label!=''){
      this.pdf.setFontSize(fontLabelSize);
      if(labelPosition=='left'){
        this.pdf.text(label,x1+spazioleft,y1+Math.round((y2-y1)/2),{
          align: 'center',
          angle:90
        });
      }
      if(labelPosition=='leftTop'){
        this.pdf.text(label,x1+spazioleft,y2,{
          align: 'center',
          angle:90
        });
      }
      if(labelPosition=='top'){
        this.pdf.text(label,x1+Math.round((x2-x1)/2),y1-spaziotop,{
          align: 'center'
        });
      }
      if(labelPosition=='topRight'){
        this.pdf.text(label,x2-spazioleft,y1-spaziotop,{
          align: 'center'
        });
      }

    }
  }

  drawBox(x:number,y:number,w:number,l:number,dir:string){
    if(dir=='h'){
     this.pdf.rect(x,y,w,l);
    }
    if(dir=='v'){
      this.pdf.rect(x,y,l,w);
    }
  }



  pdf_soffitto(){
  
    this.pdf= new JSPDF.jsPDF('p','mm','a4');
    this.pdf.setFont("helvetica");
   // this.pdf.setFontType("bold");
   
    this.pdf.setLineWidth(.05);
 

    let center={
        x:Math.round(this.pdf.internal.pageSize.getWidth()/2),
        y:Math.round(this.pdf.internal.pageSize.getHeight()/2),
    }
    
    let disegnoLung=0;
    let disegnoLarg=0;
    let frameLargX=this.model.frameLarg/fattore;
    let frameLargY=this.model.frameLarg/fattore;
   
    

    this.model.soffitto.forEach((p:any)=>{
      disegnoLung=p.lung/fattore;
      disegnoLarg+=p.larg/fattore;
    });
    frameLargY=Math.round(frameLargY*disegnoLung/disegnoLarg);
    
    
  
    let leftTop={
      x:Math.round(center.x-disegnoLung/2),
      y:Math.round(center.y-disegnoLarg/2),
    }
    let rightTop={
      x:Math.round(center.x+disegnoLung/2),
      y:Math.round(center.y-disegnoLarg/2),
    }
    let leftBottom={
      x:Math.round(center.x-disegnoLung/2),
      y:Math.round(center.y+disegnoLarg/2),
    }
    let rightBottom={
      x:Math.round(center.x+disegnoLung/2),
      y:Math.round(center.y+disegnoLarg/2),
    }
    
    let model={
      w:220,
      h:330,
      spessore:6
    }
    
    let margineX=50;
    let margineY=50;
    let boxSingolo={
      x:margineX,
      y:margineY,
      w:this.pdf.internal.pageSize.getWidth()-2*margineX,
      h:this.pdf.internal.pageSize.getHeight()-2*margineY
    }
    let ratio=boxSingolo.w/boxSingolo.h;
    let box:any=boxSingolo;
    box.margineLeft=box.w/4;
    box.margineTop=box.h/6;
    box.xDraw=box.x+box.margineLeft;
    box.yDraw=box.y+box.margineTop;
    box.wDraw=box.w-box.margineLeft;

    box.hDraw=box.wDraw/model.w*model.h;
    box.spDrawO=model.spessore*box.wDraw/model.w;
    box.spDrawV=box.spDrawO;

    this.drawTitolo('titolo',box.x+box.w/2,box.y);

    

    this.drawBox(
      box.xDraw+box.spDrawV, 
      box.yDraw, 
      box.wDraw,
      box.spDrawO,'h');

    this.drawBox(
      box.xDraw+box.spDrawV+box.wDraw, 
      box.yDraw+box.spDrawO, 
      box.hDraw-box.spDrawO,
      box.spDrawV,'v');
 
   this.drawBox(
      box.xDraw, 
      box.yDraw+box.spDrawO, 
      box.hDraw-box.spDrawO,
      box.spDrawO,'v');

    this.drawBox(
      box.xDraw+box.spDrawV, 
      box.yDraw+box.hDraw, 
      box.wDraw,
      box.spDrawO,'h');

    let txt={
      H:(model.h*10).toString(),
      h:(model.h*10-model.spessore*2*10).toString(),
      sp:(model.spessore*10).toString(),
      W:(model.w*10).toString(),
      w:(model.w*10-model.spessore*2*10).toString(),
    }
    this.drawMisure(
      boxSingolo.x,
      boxSingolo.y+box.margineTop,
      box.margineLeft/2,
      box.hDraw+box.spDrawO,
      box.spDrawO,txt);

    this.drawMisureO(
      box.xDraw,
      boxSingolo.y+boxSingolo.h,
      box.wDraw+box.spDrawO*2,
      box.margineTop,
      box.spDrawO,txt);
/*  

    this.line(leftTop.x-frameLargX, leftTop.y, rightTop.x+frameLargX,  rightTop.y);
    this.line(leftBottom.x-frameLargX, leftBottom.y, rightBottom.x+frameLargX, rightBottom.y);
    
    this.line(leftTop.x-frameLargX, leftTop.y, leftBottom.x-frameLargX, leftBottom.y);
    this.line(rightTop.x+frameLargX, rightTop.y, rightBottom.x+frameLargX,  rightBottom.y);
    let currentX=0;
    
    this.model.soffitto.forEach((p:any,ind:number)=>{
      if(ind==0){
        currentX=leftTop.x;
        this.line(leftTop.x, leftTop.y-p.frameLarg/fattore, leftBottom.x, leftBottom.y+p.frameLarg/fattore,);
      }
     
      this.line(currentX, leftTop.y-p.frameLarg/fattore, currentX+p.larg/fattore,  rightTop.y-p.frameLarg/fattore);
      
      this.line(currentX, leftBottom.y+p.frameLarg/fattore, currentX+p.larg/fattore, rightBottom.y+p.frameLarg/fattore);
      currentX+=p.larg/fattore;

      if(ind==this.model.soffitto.length-1){
         this.line(rightTop.x, rightTop.y-p.frameLarg/fattore, rightBottom.x, rightBottom.y+p.frameLarg/fattore);
      }
    });
    this.freccia(marginLeft,leftTop.y-frameLargY,'up');
    this.line(marginLeft, leftTop.y-frameLargY, marginLeft, rightBottom.y+frameLargY,'3200');
    this.line(marginLeft-5, leftTop.y-frameLargY, marginLeft+20+5, leftTop.y-frameLargY);
    this.freccia(marginLeft,rightBottom.y+frameLargY,'down');


    this.freccia(marginLeft+20,leftTop.y,'up');
    this.line(marginLeft+20, leftTop.y, marginLeft+20, rightBottom.y);
    this.line(marginLeft-5, leftBottom.y+frameLargY, marginLeft+20+5, leftBottom.y+frameLargY);
    this.freccia(marginLeft+20,leftBottom.y,'down');
    this.freccia(marginLeft+20,leftBottom.y+frameLargY,'up');
    this.line(marginLeft+20, leftBottom.y+frameLargY, marginLeft+20, leftBottom.y+frameLargY+10);
    
    this.freccia(marginLeft+20,leftTop.y-frameLargY,'down');
    this.line(marginLeft+20, leftTop.y-frameLargY-10, marginLeft+20, leftTop.y-frameLargY);
  
    this.line(marginLeft+20-2, leftBottom.y, marginLeft+20+5, leftBottom.y);
    this.line(marginLeft+20-2, leftTop.y, marginLeft+20+5, leftTop.y);
 
    this.pdf.setFontSize(fontTitleSize);
    this.pdf.text('PIANTA SOFFITTO',center.x,marginYTitle,{
        align: 'center',
    })
   */
    this.pdf.save('sample-file.pdf');
  //  doc.text('hello world',30, 30, {  align: 'center',    angle: 90   });
    
    this.pdf.save('Tavole soffitto.pdf');
      
      
  }
   riempiLato3(target: number,segments: number[]) {
    

    function getFirstComb(target: number,segments: number[]){
      let comb=[];
      for(let j=segments.length-1;j>=0;j--){
        let t=1;
        while(t*segments[j]<=target){
          t++;
        }
        if(t>1){
          t--;
          comb.push({segment1:segments[j], count1:t,mod:target-t*segments[j]});
        }

      }
      // 
      return comb;
    }
    function getBestSecond(target: number,segments: number[]){
     
      for(let j=segments.length-1;j>=0;j--){
        let t=1;
        while(t*segments[j]<=target){
          if(t*segments[j]==target){
            return {segment:segments[j],count:t,mod:0};
          }
          t++;
        }
      }
      for(let j=segments.length-1;j>=0;j--){
        let t=1;
        while(t*segments[j]<=target){
          t++;
        }
      
        if(t>1){
            t--;
            return {segment:segments[j],count:t,mod:target-t*segments[j]};
        }
      }
      // 
      return null;
    }

    let comb:any=getFirstComb(target,segments);
    comb.forEach((c:any)=>{
      if(c.mod>0){
       let res:any= getBestSecond(c.mod,segments);
       if(res){
          c.segment2=res.segment;
          c.count2=res.count;
          c.mod=res.mod;
       }
     
      }
    })
    
    // cerca la migliore
    if(comb){
     let re=  comb.filter((x:any)=> x.mod==0).sort((a:any, b:any) => ( a.count1+(a.count2? a.count2:0) < (b.count1+(b.count2? b.count2:0) ? -1 : 1)) );
     let minc=re[0].count1+( re[0].count2?  re[0].count2:0);
     let ref=re.filter((x:any)=>x.count1==minc && !x.count2);
     if(ref.length>0){
        return [{segment:ref[0].segment1,count:ref[0].count1}];
     } else 
        return [
          {segment:re[0].segment1,count:re[0].count1},
          {segment:re[0].segment2,count:re[0].count2},
        ];
    } else { 
      return null;
    }

  }

  /**
   * Soffitto MAXI: spezza `target` in pannelli (100–440, passo 20) il più possibile
   * uguali, così la trave cade circa a metà (es. 940 → 320+320+300, non 440+360+140).
   */
  combSoffittoMaxiBilanciata(target: number): number[] {
    const minP = 100;
    const maxP = 440;
    const step = 20;
    if (!target || target < minP || target % step !== 0) {
      return [];
    }
    if (target <= maxP) {
      return [target];
    }
    let n = Math.ceil(target / maxP);
    const nMax = Math.floor(target / minP);
    while (n <= nMax) {
      let base = Math.floor(target / n / step) * step;
      if (base < minP || base > maxP) {
        n++;
        continue;
      }
      let rem = target - base * n;
      const parts: number[] = Array(n).fill(base);
      let i = 0;
      let guard = 0;
      while (rem >= step && guard < n * 2) {
        if (parts[i % n] + step <= maxP) {
          parts[i % n] += step;
          rem -= step;
        }
        i++;
        guard++;
      }
      if (rem === 0 && parts.every((p) => p >= minP && p <= maxP)) {
        // lunghezze simili: ordina desc così i pezzi maggiori sono in testa
        return parts.sort((a, b) => b - a);
      }
      n++;
    }
    return [];
  }

  riempiLatoCombFisse(target: number,tipo:string) {
    // SOLO soffitto MAXI: combinazione bilanciata (trave circa in mezzo)
    if (this.cellaDati.soffittoMAXI && tipo === 'soffitto') {
      const comb = this.combSoffittoMaxiBilanciata(target);
      if (comb.length) {
        const res: any[] = [];
        const dist: number[] = [];
        comb.forEach((x: number) => {
          if (!dist.includes(x)) {
            res.push({
              segment: x,
              count: comb.filter((z: number) => z === x).length,
            });
            dist.push(x);
          }
        });
        return res;
      }
    }

    let lunghezzePannelli:any=[
    {lungh:100,comb:[100]},			
    {lungh:120,comb:[120]},			
    {lungh:140,comb:[140]},						
    {lungh:160,comb:[160]},					
    {lungh:180,comb:[180]},					
    {lungh:200,comb:[200]},					
    {lungh:220,comb:[220]},					
    {lungh:240,comb:[240]},				
    {lungh:260,comb:[260]},				
    {lungh:280,comb:[280]},						
    {lungh:300,comb:[300]},					
    {lungh:320,comb:[320]},				

    {lungh:340,comb:[160,180]},			
    {lungh:360,comb:[160,200]},					
    {lungh:380,comb:[200,180]},				
    {lungh:400,comb:[200,200]},					
    {lungh:420,comb:[240,180]},					
    {lungh:440,comb:[240,200]},					

    {lungh:460,comb:[240,220]},
    {lungh:480,comb:[240,240]},
    {lungh:500,comb:[280,220]},
    {lungh:520,comb:[280,240]},
    {lungh:540,comb:[280,260]},
    {lungh:560,comb:[280,280]},
    {lungh:580,comb:[320,260]},
    {lungh:600,comb:[320,280]},
    {lungh:620,comb:[320,300]},
    {lungh:640,comb:[320,320]},
    {lungh:660,comb:[240,240,180]},
    {lungh:680,comb:[240,240,200]},
    {lungh:700,comb:[240,240,220]},
    {lungh:720,comb:[240,240,240]},
    {lungh:740,comb:[280,280,180]},
    {lungh:760,comb:[280,280,200]},
    {lungh:780,comb:[280,280,220]},
    {lungh:800,comb:[280,280,240]},
    {lungh:820,comb:[280,280,260]},
    {lungh:840,comb:[280,280,280]},
    {lungh:860,comb:[320,320,220]},
    {lungh:880,comb:[320,320,240]},
    {lungh:900,comb:[320,320,260]},
    {lungh:920,comb:[320,320,280]},
    {lungh:940,comb:[320,320,300]},
    {lungh:960,comb:[320,320,320]},
    {lungh:980,comb:[280,280,280,140]},
    {lungh:1000,comb:[280,280,280,160]},
    {lungh:1020,comb:[280,280,280,180]},
    {lungh:1040,comb:[280,280,280,200]},
    {lungh:1060,comb:[280,280,280,220]},
    {lungh:1080,comb:[280,280,280,240]},
    {lungh:1100,comb:[280,280,280,260]},
    {lungh:1120,comb:[280,280,280,280]},
    {lungh:1140,comb:[320,320,320,180]},
    {lungh:1160,comb:[320,320,320,200]},
    {lungh:1180,comb:[320,320,320,220]},
    {lungh:1200,comb:[320,320,320,240]}
    ];
  
    let res:any=[];
    lunghezzePannelli.forEach((l:any)=>{
        if(l.lungh==target){ 
          let dist:any=[];
          l.comb.forEach((x:any)=>{
            if(!dist.includes(x)){
              res.push({
                segment:x,
                count:l.comb.filter((z:any)=>z==x).length
              });
              dist.push(x);
            }
          });
        }
    });
    return res;
  }



  
  riempiLato( lato: number): any {
    // moduli lunghezze con valori decrescenti 1
    // riempe con i numeri la lista nuemri

    //nota bene
    //usaimo i moduli
    //120
    //100
    //90
    //60

    let d120: number = 0, d100: number = 0, d80: number = 0, d60: number = 0, d40: number = 0, d20: number = 0;
    let m: number;

    if (lato >= 240) {
        m = lato - Math.floor(lato / 120) * 120;

        switch (m) {
            case 0:
                d120 = Math.floor(lato / 120);
                break;
            case 20:
                d120 = Math.floor(lato / 120) - 2;
                d100 = 1;
                d80 = 2;
                break;
            case 40:
                d120 = Math.floor(lato / 120) - 1;
                d80 = 2;
                break;
            case 60:
                d120 = Math.floor(lato / 120) - 1;
                d100 = 1;
                d80 = 1;
                break;
            case 80:
                d120 = Math.floor(lato / 120);
                d80 = 1;
                break;
            case 100:
                d120 = Math.floor(lato / 120);
                d100 = 1;
                break;
        }
    } else {
        switch (lato) {
            case 0:
                break;
            case 20:
                d20 = 1;
                break;
            case 40:
                d40 = 1;
                break;
            case 60:
                d60 = 1;
                break;
            case 80:
                d80 = 1;
                break;
            case 100:
                d100 = 1;
                break;
            case 120:
                d120 = 1;
                break;
            case 140:
                d80 = 1;
                d60 = 1;
                break;
            case 160:
                d80 = 2;
                break;
            case 180:
                d100 = 1;
                d80 = 1;
                break;
            case 200:
                d120 = 1;
                d80 = 1;
                break;
            case 220:
                d120 = 1;
                d100 = 1;
                break;
            default:
                d120 = 0;
                d100 = 0;
                d80 = 0;
                d60 = 0;
        }
    }

    return {
      d120:d120,
      d100:d100,
      d80:d80,
      d60:d60, 
      d40:d40, 
      d20:d20
    }; 
  }

  fillSide( sideLength: number):any {
    // moduli lunghezze con valori decrescenti 1
    // riempe con i numeri la lista nuemri

    //nota bene
    //usaimo i moduli
    //120
    //100
    //90
    //60
    let count120: number = 0;
    let count100: number = 0;
    let count80: number = 0;
    let count60: number = 0;
    let count40: number = 0;
    let count20: number = 0;
    let m: number;

 
    if (sideLength >= 240) {
        m = sideLength - Math.floor(sideLength / 120) * 120;

        switch (m) {
            case 0:
                count120 = Math.floor(sideLength / 120);
                break;
            case 20:
                count120 = Math.floor(sideLength / 120) - 2;
                count100 = 1;
                count80 = 2;
                break;
            case 40:
                count120 = Math.floor(sideLength / 120) - 1;
                count80 = 2;
                break;
            case 60:
                count120 = Math.floor(sideLength / 120) - 1;
                count100 = 1;
                count80 = 1;
                break;
            case 80:
                count120 = Math.floor(sideLength / 120);
                count80 = 1;
                break;
            case 100:
                count120 = Math.floor(sideLength / 120);
                count100 = 1;
                break;
        }
    } else {
        switch (sideLength) {
            case 0:
                count120 = 0;
                count100 = 0;
                count80 = 0;
                count60 = 0;
                break;
            case 20:
                count20 = 1;
                break;
            case 40:
                count40 = 1;
                break;
            case 60:
                count60 = 1;
                break;
            case 80:
                count80 = 1;
                break;
            case 100:
                count100 = 1;
                break;
            case 120:
                count120 = 1;
                break;
            case 140:
                count80 = 1;
                count60 = 1;
                break;
            case 160:
                count80 = 2;
                break;
            case 180:
                count100 = 1;
                count80 = 1;
                break;
            case 200:
                count120 = 1;
                count80 = 1;
                break;
            case 220:
                count120 = 1;
                count100 = 1;
                break;
            default:
                // MsgBox ("MUSURA LATO NON VALIDA")
                count120 = 0;
                count100 = 0;
                count80 = 0;
                count60 = 0;
                break;
        }
    }

    return {
      count120:count120,
      count100:count100,
      count80:count80,
      count60:count60,
      count40:count40,
      count20:count20
    }; 
  }

  freccia(x:number,y:number,dir:string){
    const base=1.5;
    const altezza=4;
    let p1,p2,p3;
    this.pdf.setDrawColor(0, 0, 0);    
    this.pdf.setFillColor(0, 0, 0);   
    if(dir=='up'){
      p1={
        x: x,
        y: y
      } 
      p2={
        x: Math.round(x+base/2),
        y:y+altezza
      } 
      p3={
        x: Math.round(x-base/2),
        y:y+altezza
      } 
      this.pdf.triangle(p1.x, p1.y, p2.x, p2.y,  p3.x, p3.y, 'FD');    
    }
    if(dir=='down'){
      p1={
        x: x,
        y: y
      } 
      p2={
        x: Math.round(x+base/2),
        y:y-altezza
      } 
      p3={
        x: Math.round(x-base/2),
        y:y-altezza
      } 
      this.pdf.triangle(p1.x, p1.y, p2.x, p2.y,  p3.x, p3.y, 'FD');    
    }
    if(dir=='left'){
      p1={
        x: x,
        y: y
      } 
      p2={
        x: x+altezza,
        y: Math.round(y+base/2)
      } 
      p3={
        x: x+altezza,
        y: Math.round(y-base/2)
      } 
      this.pdf.triangle(p1.x, p1.y, p2.x, p2.y,  p3.x, p3.y, 'FD');    
    }
    if(dir=='right'){
      p1={
        x: x,
        y: y
      } 
      p2={
        x: x-altezza,
        y: Math.round(y+base/2)
      } 
      p3={
        x: x-altezza,
        y: Math.round(y-base/2)
      } 
      this.pdf.triangle(p1.x, p1.y, p2.x, p2.y,  p3.x, p3.y, 'FD');    
    }
  }

  drawTitolo(p0: string, x: number, y: number){
     this.pdf.setFontSize(fontTitleSize);
    this.pdf.text('PIANTA SOFFITTO',x,y,{
        align: 'center',
    })
  }
  drawMisureO(x:number,y:number,w:number,h:number,sp:number,txt:any){
    let initx=2;
    let deltay:number=h/2;
    this.line(x,y,x,y-deltay);
    this.line(x+sp,y-deltay/2,x+sp,y-deltay);

    this.line(x+w,y,x+w,y-deltay);
    this.line(x-sp+w,y-deltay/2,x-sp+w,y-deltay);

    this.line(x,y-initx,x+w,y-initx,txt.W,'top');
    this.freccia(x,y-initx,'left');
    this.freccia(x+w,y-initx,'right');

    this.line(x+sp,y-initx-deltay/2,x+w-sp,y-initx-deltay/2,txt.w,'top');
    this.freccia(x+sp,y-initx-deltay/2,'left');
    this.freccia(x+w-sp,y-initx-deltay/2,'right');
    this.line(x,y-initx-deltay/2,x-deltay,y-initx-deltay/2);
    this.freccia(x,y-initx-deltay/2,'right');
    
    this.line(x+w,y-initx-deltay/2,x+w+deltay,y-initx-deltay/2,txt.sp,'topRight');
    this.freccia(x+w,y-initx-deltay/2,'left');
    
  }

  drawMisure(x:number,y:number,w:number,h:number,sp:number,txt:any){
    let initx=2;
    let deltax:number=w/2;

    this.line(x,y,x+w,y);
    this.line(x+deltax,y+sp,x+w,y+sp);
  
    this.line(x,y+h,x+w,y+h);
    this.line(x+deltax,y+h-sp,x+w,y+h-sp);
    
    this.line(x+initx,y,x+initx,y+h,txt.H,'left');
    this.freccia(x+initx,y,'up');
    this.freccia(x+initx,y+h,'down');

    this.line(
      x+initx+deltax,
      y+sp,
      x+initx+deltax,
      y-sp+h,txt.h,'left');
    this.freccia(x+initx+deltax,y+sp,'up');
    this.freccia(x+initx+deltax,y-sp+h,'down');

    this.line(
      x+initx+deltax,
      y,
      x+initx+deltax,
      y-deltax,txt.sp,'leftTop');
    this.freccia(x+initx+deltax,y,'down');

    this.line(
      x+initx+deltax,
      y-sp+h,
      x+initx+deltax,
      y-sp+h-deltax,txt.sp,'leftTop');
    this.freccia(x+initx+deltax,y+h,'up');
    this.line(
      x+initx+deltax,
      y+h,
      x+initx+deltax,
      y+h+deltax);

  }

getCopriFilo(obj:any){

  let ls:any[]=[];

  // spessore 6 standard
  if(this.cellaDati.finitura=='STANDARD' && this.cellaDati.spessore==6){
    ls.push({
        codice:'G306000000',
        qty:this.cellaDati.numCoprifilo
      });
  }

  // spessore 6 inox
  if(this.cellaDati.finitura!='STANDARD' && this.cellaDati.spessore==6){
    ls.push({
        codice:'G406000000',
        qty:this.cellaDati.numCoprifilo
      });
  }

  // spessore 10 standard
 if(this.cellaDati.finitura=='STANDARD' && this.cellaDati.spessore==10){
    ls.push({
        codice:'G310000000',
        qty:this.cellaDati.numCoprifilo
      });
  }

  // spessore 10 inox
  if(this.cellaDati.finitura!='STANDARD' && this.cellaDati.spessore==10){
    ls.push({
        codice:'G410000000',
        qty:this.cellaDati.numCoprifilo
      });
  }

  // spessore 13 standard
  if(this.cellaDati.finitura=='STANDARD' && this.cellaDati.spessore==13){
    ls.push({
        codice:'MS096117',
        qty:this.cellaDati.numCoprifilo
      });
  }

  // spessore 13 inox
  if(this.cellaDati.finitura!='STANDARD' && this.cellaDati.spessore==13){
    ls.push({
        codice:'MS096117',
        qty:this.cellaDati.numCoprifilo
      });
  }
  return ls;

}

bestCombination(target: number,measures: number[],  tolerance = 0.5) {

  const min = target * (1 - tolerance);
  const max = target;

  let best: any= null;

  const maxDepth = Math.ceil(target / Math.min(...measures)) + 1;

  const dfs = (
    current: number[],
    sum: number,
    startIndex: number
  ) => {
    if (sum > max) return;

    if (sum >= min) {
      const delta = Math.abs(target - sum);

      const candidate:any = {
        sum,
        delta,
        elements: [...current]
      };

      if (
        !best ||
        delta < best.delta ||
        (delta === best.delta &&  this.distinctCount(candidate.elements) <  this.distinctCount(best.elements))
      ) {
        best = candidate;
      }
    }

    if (current.length >= maxDepth) return;

    for (let i = startIndex; i < measures.length; i++) {
      current.push(measures[i]);
      dfs(current, sum + measures[i], i); // i → ripetizione consentita
      current.pop();
    }
  }

  dfs([], 0, 0);
  if(best){
    return best.elements;
  }
  return null;
}

findBestScaffaleCombination(
  target: number,
  shelves: { lung: number; larghezzaReale: number }[],
  larghezzaSpalla: number
): number[] {
  if (!shelves.length) {
    return [];
  }

  let bestCombo: number[] = [];
  let bestDelta = Infinity;
  const minReale = Math.min(...shelves.map((s) => s.larghezzaReale));
  const maxDepth = Math.max(1, Math.ceil(Math.max(0, target - larghezzaSpalla) / minReale) + 1);

  const evaluate = (combo: number[], sumReale: number) => {
    const total = sumReale + larghezzaSpalla;
    if (total > target) {
      return;
    }
    const delta = target - total;
    if (
      delta < bestDelta ||
      (delta === bestDelta && combo.length < bestCombo.length)
    ) {
      bestDelta = delta;
      bestCombo = [...combo];
    }
  };

  const dfs = (combo: number[], sumReale: number, depth: number) => {
    if (combo.length > 0) {
      evaluate(combo, sumReale);
      if (bestDelta === 0) {
        return;
      }
    }
    if (depth >= maxDepth) {
      return;
    }
    for (const shelf of shelves) {
      const newSumReale = sumReale + shelf.larghezzaReale;
      const newTotal = newSumReale + larghezzaSpalla;
      if (newTotal > target) {
        continue;
      }
      combo.push(shelf.lung);
      dfs(combo, newSumReale, depth + 1);
      combo.pop();
    }
  };

  dfs([], 0, 0);

  if (bestCombo.length === 0) {
    let bestSingle: number | null = null;
    let bestTotal = -1;
    for (const shelf of shelves) {
      const total = shelf.larghezzaReale + larghezzaSpalla;
      if (total <= target && total > bestTotal) {
        bestTotal = total;
        bestSingle = shelf.lung;
      }
    }
    return bestSingle !== null ? [bestSingle] : [];
  }

  return bestCombo;
}

distinctCount(arr: number[]) {
  return new Set(arr).size;
}

trovaCombinazioneMigliore(target: number, arr: number[]): number[] {
    let miglioreCombinazione: number[] = [];
    let sommaMigliore = -1;
    
    // Funzione per trovare tutte le combinazioni
    function combina(startIndex: number, currentCombination: number[], currentSum: number): void {
        // Se la somma corrente è più vicina al target, aggiorniamo la miglior combinazione
        if (Math.abs(currentSum - target) < Math.abs(sommaMigliore - target)) {
            miglioreCombinazione = [...currentCombination];
            sommaMigliore = currentSum;
        } 
        

        // Esploriamo tutte le combinazioni a partire dall'indice corrente
        for (let i = startIndex; i < arr.length; i++) {
            currentCombination.push(arr[i]);
            combina(i + 1, currentCombination, currentSum + arr[i]);  // Prosegui con il prossimo elemento
            currentCombination.pop();  // Rimuoviamo l'elemento per esplorare altre combinazioni
        }
    }

    combina(0, [], 0);
    return miglioreCombinazione;
}

getSetProfiloDivisorio(cella:any){
  
  let codici:any[]=[];
  cella.divisori.forEach((divisorio:any)=>{
    let combinazione = this.trovaCombinazioneMigliore(divisorio.w, this.setProfiloDivisorio.getLunghezze());
    if(divisorio.w<=320){
      combinazione=[divisorio.w];
    } 
  
    combinazione.forEach((c:number)=>{
      this.setProfiloDivisorio.getData().filter((p:any)=>p.spessore==cella.spessore && p.lunghezza==c).forEach((obj:any)=>{
        if(cella.finitura=='STANDARD' && obj.finitura=='STANDARD' ){
         let ispresent=false;
          codici.forEach((pp:any)=>{
            if(pp.art_comp==obj.art_comp){
              ispresent=true;
              pp.qty+=1;
            }
          });
          if(!ispresent){
            codici.push({
              art_comp:obj.art_comp,
              qty:1
            })
          }
        }
        if(cella.finitura!='STANDARD' && obj.finitura!='STANDARD' ){
          let ispresent=false;
          codici.forEach((pp:any)=>{
            if(pp.art_comp==obj.art_comp){
              ispresent=true;
              pp.qty+=1;
            }
          });
          if(!ispresent){
            codici.push({
              art_comp:obj.art_comp,
              qty:1
            })
          }
        }
      });
    });
   
    combinazione = this.trovaCombinazioneMigliore(cella.altezza, this.setProfiloDivisorio.getLunghezze());
     if(cella.altezza<=320){
      combinazione=[cella.altezza];
    } 
    combinazione.forEach((c:number)=>{    
      this.setProfiloDivisorio.getData().filter((p:any)=>p.spessore==cella.spessore && p.lunghezza==c).forEach((obj:any)=>{
         if(cella.finitura=='STANDARD' && obj.finitura=='STANDARD' ){
          let ispresent=false;
          codici.forEach((pp:any)=>{
            if(pp.art_comp==obj.art_comp){
              ispresent=true;
              pp.qty+=1;
            }
          });
          if(!ispresent){
            codici.push({
              art_comp:obj.art_comp,
              qty:1
            })
          }
        }
        if(cella.finitura!='STANDARD' && obj.finitura!='STANDARD' ){
          let ispresent=false;
          codici.forEach((pp:any)=>{
            if(pp.art_comp==obj.art_comp){
              ispresent=true;
              pp.qty+=1;
            }
          });
          if(!ispresent){
            codici.push({
              art_comp:obj.art_comp,
              qty:1
            })
          }
        }
      });
    });

  });
 
  return codici;
}
 
getTappi2(obj:any,cellaDati:any){
  let tappi:any[]=[];
  let numTappi=0;
  let numTappiPav=0;
  const larghPanPavPerTappi=[0,27,31,60,80,100,120];
  const tappiPav=[ 
  [20,6,6,8,10,10,10],
  [40,6,6,8,10,10,10],
  [60,10,10,10,10,10,10],
  [80,10,10,10,10,10,10],
  [100,10,10,11,12,13,14],
  [120,10,10,11,12,13,14],
  [140,10,10,11,12,13,14],
  [160,10,10,11,12,13,14],
  [180,11,11,12,13,14,15],
  [200,12,12,13,14,15,16],
  [220,13,13,14,15,16,17],
  [240,14,14,15,16,17,18],
  [260,15,15,16,17,18,19],
  [280,16,16,17,18,19,20],
  [300,17,17,18,19,20,21],
  [320,18,18,19,20,21,22]

  ];

  const larghPanParetiSoffPerTappi=[0,20,27,31,40,60,80,100,120];

  const tappiParSof=[
    [40,4,5,5,5,6,7,8,9],
    [60,4,5,5,5,6,7,8,9],
    [80,5,6,6,6,7,8,9,10],
    [100,6,7,7,7,8,9,10,11],
    [120,7,8,8,8,9,10,11,12],
    [160,9,10,10,10,11,12,13,14],
    [180,10,11,11,11,12,13,14,15],
    [200,11,12,12,12,13,14,15,16],
    [220,12,14,13,13,14,15,16,17],
    [240,13,14,14,14,15,16,17,18],
    [260,14,15,15,15,16,17,18,19],
    [280,15,16,16,16,17,18,19,20],
    [300,16,17,17,17,18,19,20,21],
    [320,17,18,18,18,19,20,21,22],
    [340,18,19,19,19,20,21,22,23],
    [360,19,20,20,20,21,22,23,24],
    [380,20,21,21,21,22,23,24,25],
    [400,21,22,22,22,23,24,25,26],
    [420,22,23,23,23,24,25,26,27],
    [440,23,24,24,24,25,26,27,28]  
  ];



    obj.forEach((p:any)=>{

      if(p.side=='pavimento'){
        let indTP=-1;
        let larg=p.w;
        let lung=p.h;
        if(lung<larg){
           larg=p.h;
           lung=p.w;
        }
        larghPanPavPerTappi.forEach((t:any,ind:number)=>{
          if(t==larg){
            indTP=ind;
          }
        });
        if(indTP!=-1){
          tappiPav.forEach((t:any,ind:number)=>{
            if(t[0]==lung){
              numTappiPav+=t[indTP];
            }
          });
        }
      } else {
        let indTP=-1;
        let larg=p.w;
        let lung=p.h;
        if(lung<larg){
           larg=p.h;
           lung=p.w;
        }
        larghPanParetiSoffPerTappi.forEach((t:any,ind:number)=>{
          if(t==larg){
            indTP=ind;
          }
        });
        if(indTP!=-1){
          tappiParSof.forEach((t:any,ind:number)=>{
            if(t[0]==lung){
              numTappi+=t[indTP];
            }
          });
        }
      }
    });
/*
4000012438 MS012438	SU LATERALI E SOFFITTI BIANCHI
4000012695 MS012491	SU LATERALI E SOFFITTI IX

4000012694 MS012694	PED
4000012694 MS012694	CARP400
4000012695 MS012491	CAR P400IX
4000012694 MS012694	P1000ST
4000012695 MS012491	P1000ST


*/
if(cellaDati.finitura=='STANDARD'){
  tappi.push({
          codice:"4000012438",
            qty:numTappi
          })
  } else {
    tappi.push({
            codice:"4000012695",
            qty:numTappi
          })
  }
  let codice='';
  switch(cellaDati.finituraPavimento){
    case 'CAR_PL':
      codice='4000012694';
      break;
    case 'CAR_IXI':
      codice='4000012695';
    break;
    case 'CAR_IXE':
      codice='4000012694';
    break;
   case 'CAR_IXIE':
      codice='4000012695';
    break;
    case 'PED_PL':
      codice='4000012694';
    break;
    case 'PED_IXI':
      codice='';
      break;
    case 'P1000':
      codice='4000012694';
      break;
    case 'P1000IX':
      codice='4000012695';
      break;
    case 'P1000IXE':
      codice='4000012695';
      break;
  }
  if(codice!=''){
    tappi.push({
          codice:codice,
          qty:numTappiPav
        })
  }
  
  return tappi;

}

getTappi(BLKr:any){
    let codici:any[]=[];
    let p2:number=40;
    let p3:string='4000012438';
    let Prtt = 0;                                     //# PERIMETRO TOT. PANNELLI
    let Prtt1 = 0;                                  //  '# PERIMETRO TOT. PANNELLI PER
    let Prtt2 = 0;                                 //   '# PERIMETRO TOT. PANNELLI PER
    let Cnpv = 1;                                  //   '# CONTATORE PANNELLI PAVIMENTO
   
    Prtt = 0;                                  //   '# PERIMETRO TOT. PANNELLI
    let Lplb_1 = "10";
    let Lplb_2 = "12";                             //    '# GRUPPI x PANN. TAPPI BIANCHI
    let Lplb_3 = "14";                             //    '# GRUPPI x PANN. TAPPI BIANCHI
    let Lpob_1 = "30";
    let Lpob_2 = "32";                             //    '# GRUPPI x PORTE TAPPI BIANCHI
    let Lpva_1 = "60";
    let Lpva_2 = "62";
    let Lpva_3 = "65";                            //  '# GRUPPI x PAVIM. TAPPI ARGENTO
    let LpvMK_1 = "69";
    let LpvMK_2 = "6A";
    let LpvMK_3 = "6B";                         //     '# GRUPPI x PAVIM. MK TAPPI GRIGI
    let LsfMK_1 = "6C";
    let LsfMK_2 = "6D";
    let LsfMK_3 = "6E";                          //    '# GRUPPI x SOFF. MK TAPPI BIANCHI
    let Lpvg_1 = "61";
    let Lpvg_2 = "63";
    let Lpvg_3 = "66";

   let lscd_4 = "4000012491";
   let lscd_7 = "4000012694";                        //    ' LISTA CODICI COMP. VARI

    let Lpvg_4 = "6F";                         //     '# GRUPPI x PAVIM. TAPPI GRIGI

    let Lplg_1 = "11";
    let Lplg_2 = "13";                              //   '# GRUPPI x PANN. TAPPI GRIGI"
    let Lpog_1 = "31";
    let Lpog_2 = "33";                                 //    '# GRUPPI x PORTE TAPPI GRIGI
    let Tiptp = "0";
    /*
    '#--'#---------------------------------------------'#----------------------------'#
    '#  TAPPI BIANCHI:   Questo tipo di tappi viene inserito per tutti i pannelli  '#
    '#                   laterali e di soffitto aventi finitura interna STANDARD.  '#
    '#--'#---------------------------------------------'#                            '#
    '#  - PANNELLI LATERALI E DI SOFFITTO STANDARD E INOX ESTERNO (INCL. PORTE) '#
    '#                 Il calcolo viene eseguito selezionando dalla tabella del '#
    '#                 computo temporaneo ( gbtbcp) gli elementi il cui codice  '#
    '#                 grafico assuma i  ori 10 o 12 per il gruppo. Dai codi- '#
    '#                 ci selezionati vengono ricavate le informazioni relative '#
    '#                 alle dimensioni dei pannelli, necessarie per ricavarne il'#
    '#                 perimetro. Di seguito viene eseguita la somma dei peri-  '#
    '#                 metri di tutti i pannelli su cui devono essere inseriti  '#
    '#                 i tappi bianchi. La misura finale ricavata da questa ope-'#
    '#                 razione viene divisa per il passo dei tappi, ricavando   '#
    '#                 il numero di tappi bianchi da computare.                 '#
    '#---------------------------------------------'#----------------------------'#
    */
    let cnpl = 1;                                   //'# CONTATORE PANNELLI LATERALI
    let Nbct = 2;   
    /*                                //  '# NUM. COLONNE SELEZ. IN TAB.
   '    lcpl = sql "select P6, qta_comp _
    '                     from  gbtbcp _
    '                    where P6 like ' lplb(1)P5' _
    '                       or P6 like ' lplb(2)P5'"
    */
    //# LISTA CODICI E QTA PANNELLI
    BLKr.forEach((b:any)=>{
      if(!b.porta){
        let name=b.name.substring(0, 2);
        if(name == Lplb_1 || name == Lplb_2 || name == Lplb_3 
          || name == LsfMK_1 || name ==  LsfMK_2 
          || name ==  LsfMK_3) { //'messo da cisco per tappi soffitto MK
          let dima = b.w;  //, 5, 3))      // '# PANNELLO: DIMENSIONE 1
          let dimb = b.h;  // Val(Mid(BLKr.Name, 8, 3))     //'# PANNELLO: DIMENSIONE 2
          let  Prpa = (dima + dimb) * 2;            // '# PANNELLO: PERIMETRO
            Prtt = Prtt + Prpa;                //'* lcpl(cnpl + 1)     '# PANN.: TOT. PER. x COD.
            cnpl = cnpl + Nbct;               //    '# AGG. CONTATORE PANNELLI
        }
      }
     
    });
  
   // '#---------------------------------------------'#----------------------------'#
  //  '#  - PANNELLI PORTA FINITURA STANDARD E INOX ESTERNO                       '#
   // '#---------------------------------------------'#----------------------------'#
    let Cnpp = 2;                       //              '# CONTATORE PANNELLI PORTA
    Nbct = 3;                       //              '# NUM. COLONNE SELEZ. IN TAB.
  //  '    lcpp = sql "select qta_comp, l_porta, h_porta _
  //  '                  from  gbtbcp _
 //   '                 where P6 like ' lpob(1)P5' _
  //  '                    or P6 like ' lpob(2)P5'"
  //  '   If (lcpp(0) >= nbct) Then                    '# SE CI SONO CODICI
    BLKr.forEach((b:any)=>{
      if(!b.porta){
        let name=b.name.substring(0, 2);
        if(name ==  Lpob_1 
        || name == Lpob_2 ){
        
            let dima = b.w;     //  '# PANNELLO: DIMENSIONE 1
            let dimb = b.h;  //   '# PANNELLO: DIMENSIONE 2
            let Prpa = (dima + dimb) * 2;           //  '# PANNELLO: PERIMETRO
            Prtt = Prtt + Prpa;  // '* lcpp(cnpp - 1)     '# PANNELLO: TOT. PERIMETRI
            Cnpp = Cnpp + Nbct;       //            '# AGG. CONTATORE PANNELLI              
        
        }
      }
    });
   
  //      '#---------------------------------------------'#----------------------------'#
  //  '#  - INSERIMENTO TAPPI BIANCHI IN TABELLA COMPUTI                          '#
   // '#---------------------------------------------'#----------------------------'#
    if(Prtt > 0) {                     //      '# SE PERIMETRO TOT. MAGG. DI 0
        let Nbtp = Math.trunc(Prtt / p2);              //  '# NUMERO TOTALE TAPPI
        codici.push({
          codice:p3,
          qty:Nbtp
        })
     //   this.FC_insca(p3, Nbtp);  //'P6      '# FUNZ: INSER. COMP. IN TABELLA
   }                                        //'# FINE INSER. TAPPI BIANCH
 /*   '#--'#---------------------------------------------'#----------------------------'#
    '#  TAPPI GRIGI:     Questo tipo di tappi viene inserito per tutti i pannelli  '#
    '#                   laterali e di soffitto aventi finitura interna INOX       '#
    '#                   Per i pannelli a pavimento la procedura originale         '#
    '#                   si modifica per tener conto di due tipi di tappo          '#
    '#                   GRIGIO per gruppi 61 63 65 e ARGENTO per i gruppi 60 62 66'#
    '#                   (15/06/1999) originariamente il tappo era sempre GRIGIO   '#
    '#                   per qualsiasi pannello di pavimento (se presente).        '#
    '#                   quindi si ‚ inserita una doppia logica, ed un do while per'#
    '#                   effettuare il computo su tutti i pannelli                 '#
    '#--'#---------------------------------------------'#                            '#
    '#  - PANNELLI DI PAVIMENTO                                                 '#
    '#---------------------------------------------'#----------------------------'#
    */
    Prtt = 0;                     //                '# PERIMETRO TOT. PANNELLI
    Prtt1 = 0;                    //                '# PERIMETRO TOT. PANNELLI PER
    Prtt2 = 0;                    //                '# PERIMETRO TOT. PANNELLI PER
    Cnpv = 1;                      //               '# CONTATORE PANNELLI PAVIMENTO
    Nbct = 2;                     //                '# NUM. COLONNE SELEZ. IN TAB.
 
 /*   '# IN " gbtbcp" HO LA TABELLA SQL DEI COMPONENTI: t_comptp
    '#---------------------------------------------'#
    '# echo 'fc_cmptp' " lpvg(1)P5'
    '# echo " lpvg(2)P5'
    '# echo " lpvg(3)P5'
    '    lcpv = sql "select P6, qta_comp _
    '                  from  gbtbcp _
    '                 where P6 like ' lpvg(1)P5' _
    '                    or P6 like ' lpvg(2)P5' _
    '                    or P6 like ' lpvg(3)P5'"
    '# LISTA CODICI E QTA PANNELLI PRIMO TIPO
    */
    BLKr.forEach((b:any)=>{
      if(!b.porta){
        let name=b.name.substring(0, 2);
        if(name ==Lpvg_1 
          || name == Lpvg_2
          || name == Lpvg_3
          || name == Lpvg_4) {
              //    '      If (lcpv(0) >= nbct) Then                    '# SE CI SONO CODICI
              //   '      While (cnpv <= lcpv(0))                    '# CICLO SU NUM. CODICI SELEZ.
              //    '#      echo 'cnpv' " cnpv"
              //    '#      echo 'lcpv' " lcpv(0)"
                let dima =b.w;    //   '# PANNELLO: DIMENSIONE 1
                let dimb =b.h;   //  '# PANNELLO: DIMENSIONE 2
                let Prpa = (dima + dimb) * 2;          //   '# PANNELLO: PERIMETRO
                let Dima1 = b.w;  //     '# PANNELLO: DIMENSIONE 1
                let Dimb2 = b.h;  //      '# PANNELLO: DIMENSIONE 2
                let Prpa1 = (Dima1 + Dimb2) * 2;    //      '# PANNELLO: PERIMETRO
                Prtt1 = Prtt1 + Prpa1; //'* lcpv(cnpv + 1)
                Cnpv = Cnpv + Nbct;       //            '# AGG. CONTATORE PANNELLI
                // '# TOT. PERIMETRI x CODICE PRIMO GRUPPO DI PAVIMENTI
                //  '#      echo "-----------"
                //  '#      echo 'prtt1' " prtt1"
              //   '      Wend                                   '# FINE CICLO NUM. COD. P.LAT.
                //  '      End If                                     '# FINE SU PANN. PAVIMENTO
              //   '# PRIMO TIPO
          }
        }
      });
 //   '# echo 'prtt' " prtt"
 //   '# echo 'prtt1' " prtt1"
 ////   '# echo " lpva(1)P5'
 //   '# echo " lpva(2)P5'
 //   '# echo " lpva(3)P5'
    Cnpv = 1;              //                       '# CONTATORE PANNELLI PAVIMENTO
    Nbct = 2;               ////                      '# NUM. COLONNE SELEZ. IN TAB.
   // '    lcpv = sql "select P6, qta_comp _
   // '                  from  gbtbcp _
   // '                 where P6 like ' lpva(1)P5' _
   // '                    or P6 like ' lpva(2)P5' _
   // '                    or P6 like ' lpva(3)P5'"
   // '# LISTA CODICI E QTA PANNELLI SECONDO TIPO
   // '      If (lcpv(0) >= nbct) Then                    '# SE CI SONO CODICI
   // '      While (cnpv <= lcpv(0))                    '# CICLO SU NUM. CODICI SELEZ.
   // '#     prtt2 = 0
      BLKr.forEach((b:any)=>{
        if(!b.porta){
          let name=b.name.substring(0, 2);
          if(name ==Lpva_1 
            || name == Lpva_2 
            || name == Lpva_3) {
              let dima = b.w;    //   '# PANNELLO: DIMENSIONE 1
              let dimb = b.h;   // '# PANNELLO: DIMENSIONE 2
              let Prpa = (dima + dimb) * 2;           //  '# PANNELLO: PERIMETRO
              //'#      echo 'prtt //'" prtt"
              //'#      echo 'prtt2 //' " prtt2"
              let Dima2 = b.w;  //    '# PANNELLO: DIMENSIONE 1
              let Dimb2 = b.h;  //   '# PANNELLO: DIMENSIONE 2
              let Prpa2 = (Dima2 + Dimb2) * 2;      //       '# PANNELLO: PERIMETRO
              Prtt2 = Prtt2 + Prpa2; // '* lcpv(cnpv + 1)
              Cnpv = Cnpv + Nbct;      //             '# AGG. CONTATORE PANNELLI
            }
          }
      });
  //  '# TOT. PERIMETRI x CODICE SECONDO TIPO DI PAVIMENTO
  //  '#      echo "***********"
 //   '#      echo " prtt2"
  //  '      Wend
  //  '      End If
  //  '#      echo 'uscita da tipo 2 prtt' " prtt"
  //  '#      echo 'prtt2' " prtt2"

    Prtt = Prtt1 + Prtt2;        //         '# TOT. PERIMETRI x CODICE
    Cnpv = Cnpv + Nbct;          //         '# AGG. CONTATORE PANNELLI
   // '# FINE SU PANN. PAVIMENTO//
 //   '#      echo 'prima di pannelli laterali soffitto'
   // '#      echo 'prtt' " prtt"
   // '#      echo 'contatore pannelli' " cnpv"
   // '#      echo 'ingresso in conta laterali"
    //'#---------------------------------------------'#----------------------------'#
    //'#  - PANNELLI LATERALI E DI SOFFITTO INOX INTERNO E INOX INTERNO-ESTERNO   '#
    //'#---------------------------------------------'#----------------------------'#
    Prtt = 0;
    cnpl = 1;                  //                   '# CONTATORE PANNELLI LATERALI
    Nbct = 2;                  //                   '# NUM. COLONNE SELEZ. IN TAB.
   // '#---------------------------------------------'#
   // '    lcpl = sql "select P6, qta_comp _
  // // '                  from  gbtbcp _
  //  '                 where P6 like ' lplg(1)P5'\
 //   '                    or P6 like ' lplg(2)P5'"
        BLKr.forEach((b:any)=>{
          if(!b.porta){
            let name=b.name.substring(0, 2);
            if(name == Lplg_1 || name ==  Lplg_2) {

            //        '#  echo " lplg(1)P5'
            //        '#  echo " lplg(2)P5'
              //       '# LISTA CODICI E QTA PANNELLI
              //       '   If (lcpl(0) >= nbct) Then                    '# SE CI SONO CODICI
            //        '      While (cnpl <= lcpl(0))                    '# CICLO SU NUM. CODICI SELEZ.
                let dima = b.w;   //    '# PANNELLO: DIMENSIONE 1
                let dimb = b.h;    // '# PANNELLO: DIMENSIONE 2
                let Prpa = (dima + dimb) * 2;          //   '# PANNELLO: PERIMETRO
                Prtt = Prtt + Prpa;  //'* lcpl(cnpl + 1)     '# PANN.: TOT. PER. x COD.
                cnpl = cnpl + Nbct;            //       '# AGG. CONTATORE PANNELLI
                  //  '      Wend                                   '# FINE CICLO NUM. COD. P.LAT.
                  //  '   End If                                        '# FINE SU PANN. LATERALI
            }
          }
        });
 //   '#---------------------------------------------'#----------------------------'#
 //   '#  - PANNELLI PORTA FINITURA INOX INTERNO E INOX INTERNO-ESTERNO           '#
 //   '#---------------------------------------------'#----------------------------'#
    Cnpp = 2;                        //             '# CONTATORE PANNELLI PORTA
    Nbct = 3;                        //             '# NUM. COLONNE SELEZ. IN TAB.
   // '    lcpp = sql "select qta_comp, l_porta, h_porta _
   // '                  from  gbtbcp _
   // '                 where P6 like ' lpog(1)P5' _
   // '                    or P6 like ' lpog(2)P5'"
   
    BLKr.forEach((b:any)=>{
      if(!b.porta){
        let name=b.name.substring(0, 2);
        if(name ==  Lpog_1 
        || name == Lpog_2 ){
            let dima = b.w;     //  '# PANNELLO: DIMENSIONE 1
            let dimb = b.h;  //   '# PANNELLO: DIMENSIONE 2
            let Prpa = (dima + dimb) * 2;           //  '# PANNELLO: PERIMETRO
            Prtt = Prtt + Prpa;  // '* lcpp(cnpp - 1)     '# PANNELLO: TOT. PERIMETRI
            Cnpp = Cnpp + Nbct;       //            '# AGG. CONTATORE PANNELLI              
          
        }
      }
    });

  //  '##############cisco tappi grigi per pavimenti MK inizio
 
    BLKr.forEach((b:any)=>{
      if(!b.porta){
        let name=b.name.substring(0, 2);
        if(name ==LpvMK_1 
          || name == LpvMK_2 
          || name == LpvMK_3) {
            let dima =b.w;  //    '# PANNELLO: DIMENSIONE 1
            let dimb =b.h; //   '# PANNELLO: DIMENSIONE 2
            let Prpa = (dima + dimb) * 2;   //          '# PANNELLO: PERIMETRO
            Prtt = Prtt + Prpa; //'* lcpl(cnpl + 1)     '# PANN.: TOT. PER. x COD. 
          }
        }
      });
      
      
   // '##############cisco tappi grigi per pavimenti MK fine
   
   /*
    '#---------------------------------------------'#
    '#  INSERIM. TAPPI PANN. PAVIMENTO IN TABELLA  '#
    '#---------------------------------------------'#
    '#   echo " lscd(7)"
    '#   echo " lscd(4)"
    '#------------------------------------------------'#
    '# 11/06/1999                                     '#
    '# MODIFICA INSERITA PER TRATTARE IL TAPPO ARGENTO'#
    '# IL TAPPO ARGENTO VA INSERITO PER PAVIMENTI     '#
    '# STANDARD, INOX_ESTERNO, MISA_KIT               '#
    '# IL TAPPO GRIGIO VA INSERITO PER PAVIMENTI      '#
    '# INOX_INTERNO, INOX_INT_EST, P_1000             '#
    */
    if (Prtt1 > 0) {                  //      '# SE PERIMETRO TOT. MAGG. DI 0
       let Nbtp1 = Math.trunc(Prtt1 / p2);          //  '# NUMERO TOTALE TAPPI
     //   '#       echo " prtt1"
   //     '#       echo " nbtp1"
    //    '#       echo "P2"
        Tiptp = lscd_4;
    //    '#       echo " tiptp"
   //     'FC_insca Tiptp, Nbtp1  '                          '# FUNZ: INSER. COMP. IN TABELLA
    }                              //       '# FINE INSER. TAPPI BIANCHI
    if (Prtt2 > 0) {                   //     '# SE PERIMETRO TOT. MAGG. DI 0
        let Nbtp2 = Math.trunc(Prtt2 / p2);        //   '# NUMERO TOTALE TAPPI
      //  '#       echo " prtt2"
     //   '#       echo " nbtp2"
     //   '#       echo "P2"
        Tiptp = lscd_7;
     //   '#       echo " tiptp"
      //  'FC_insca Tiptp, Nbtp2
     //   'p6                      '# FUNZ: INSER. COMP. IN TABELLA
    }                            //      '# FINE INSER. TAPPI BIANCHI
    Prtt = Prtt1 + Prtt2;
    
  //  '#---------------------------------------------'#
   // '#  INSERIM. TAPPI PANN. PAVIMENTO IN TABELLA  '#
   // '#---------------------------------------------'#
    if (Prtt > 0) {                   //        '# SE PERIMETRO TOT. MAGG. DI 0
       // '#    echo ' ore di prtt per pannelli //' " prtt"
        let Nbtp = Math.trunc(Prtt / p2);            //    '# NUMERO TOTALE TAPPI
        codici.push({
          codice:lscd_7,
          qty:Nbtp
        })
       // this.FC_insca(lscd_7, Nbtp);   //    '# FUNZ: INSER. COMP. IN TABELLA
    }                       //                 '# FINE INSER. TAPPI BIANCHI
    return codici;
}
   

getPorte(cellaDati:any){
  let pte:any[]=[];
  if(cellaDati.elencoPorte){
    cellaDati.elencoPorte.forEach((p:any)=>{
      if(!p.configurata){
        if(p.modelliPortaOptions){
          let trovata=false;
          p.modelliPortaOptions.forEach((m:any)=>{
            if(!trovata && p.modelloPorta==m.value){
              trovata=true;
              let ispresent=false;
              pte.forEach((pp:any)=>{
                if(pp.codice==m.cod_comp){
                  ispresent=true;
                  pp.qty+=1;
                }
              });
              if(!ispresent){
                pte.push({
                  codice:m.cod_comp,
                  qty:1,
                  tipoPorta:cellaDati.portaDivisorio.tipo1Porta
                });
              }
            }
          });
          /*
          if(p.configurata){
            //codVersione industriali entrambe
            // codCompletamento ind scorre
        
              let param={
                tipo:p.tipologiaPorta,
                id:p.modelloPorta
              };
              this.apiService.post('app/opportunity_getconfigurataopzioni',param).subscribe(data2 => {
                let optzioni=data2.Result.opzioni.filter((x:any)=>x.tipo=='M');
                let porte=data2.Result.porte;
                // standard e scorrevoli (commerciali) verifico oblo
                if(p.tipologiaPorta=='STANDARD'  ){
                  porte.forEach((codp:any)=>{
                    let ispresent=false;
                    pte.forEach((pp:any)=>{
                        if(pp.codice==codp.codPorta2){
                          ispresent=true;
                          pp.qty+=1;
                        }
                    });
                    if(!ispresent){
                      pte.push({
                        codice:codp.codPorta2,
                        qty:1
                      });
                    }
                  });
                } 
                if(p.tipologiaPorta=='STANDARD' || p.tipologiaPorta=='SCORREVOLI' ){
                  if(p.conoblo){
                    porte.forEach((codp:any)=>{
                      let ispresent=false;
                      pte.forEach((pp:any)=>{
                          if(pp.codice==codp.codPannelloSIOblo){
                            ispresent=true;
                            pp.qty+=1;
                          }
                      });
                      if(!ispresent){
                        pte.push({
                          codice:codp.codPannelloSIOblo,
                          qty:1
                        });
                      }
                    });
                  } else {
                    porte.forEach((codp:any)=>{
                      let ispresent=false;
                      pte.forEach((pp:any)=>{
                          if(pp.codice==codp.codPannelloNoOblo){
                            ispresent=true;
                            pp.qty+=1;
                          }
                      });
                      if(!ispresent){
                        pte.push({
                          codice:codp.codPannelloNoOblo,
                          qty:1
                        });
                      }
                    });
                  }
                }
                if( p.tipologiaPorta=='SCORREVOLI' ){
                  optzioni.forEach((opt:any)=>{
                    let ispresent=false;
                    pte.forEach((pp:any)=>{
                        if(pp.codice==opt.codComp){
                          ispresent=true;
                          pp.qty+=1;
                        }
                    });
                    if(!ispresent){
                      pte.push({
                        codice:opt.codComp,
                        qty:1
                      });
                    }
                  });
                }
                p.configurataOpzioni.forEach((opt:any)=>{
                  let ispresent=false;
                  pte.forEach((pp:any)=>{
                      if(pp.codice==opt){
                        ispresent=true;
                        pp.qty+=1;
                      }
                  });
                  if(!ispresent){
                    pte.push({
                      codice:opt,
                      qty:1
                    });
                  }
                });
              });
          }
        */
        }
      }
    });
  }
  /*
  if(cellaDati.portaDivisorio){
    let p:any=cellaDati.portaDivisorio;
    if(p.modelliPortaOptions){
        p.modelliPortaOptions.forEach((m:any)=>{
          if(p.modelloPorta==m.value){
            let ispresent=false;
            pte.forEach((pp:any)=>{
              if(pp.codice==m.cod_comp){
                ispresent=true;
                pp.qty+=1;
              }
            });
            if(!ispresent){
              pte.push({
                codice:m.cod_comp,
                qty:1,
                tipoPorta:cellaDati.portaDivisorio.tipo1Porta
              });
            }
          }
        });
      
      }
  }
*/
  return pte;
}

getCappucci(obj:any,cc:any){
  if(obj.cappucci.length==0){
    return [];
  }
  let laticombinati=0;
  let cap:any=[];
  if(this.cellaDati.celleCollegate.length>0){
  laticombinati=4*this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocombinato && cc.elencoCelle.filter((c2:any)=>c2.id==x.cellaCollegataId)[0].spessore!=this.cellaDati.spessore).length;
 }
     
  let contaCappucciDx=0;
  let contaCappucciSn=0;
  obj.cappucci.forEach((c:any)=>{

    /*
    if(laticombinati>0 && contaCappucciSn+contaCappucciDx<laticombinati){
      if(c.name.indexOf('a00')>0){
        if(contaCappucciSn<contaCappucciDx){
          c.name=c.name.replace('06','10').replace('a00','b6s'); // speossori diversi a tre vie
          contaCappucciSn++;
        } else {
          c.name=c.name.replace('06','10').replace('a00','b6d'); // speossori diversi a tre vie
          contaCappucciDx++;
        }
      }
    }
    */
    let ispresent=false;
    cap.forEach((x:any,i:number)=>{
      if(x.codice==c.name){
        ispresent=true;
        cap[i].qty+=1;
      }
    });
    if(!ispresent){
      cap.push({
        codice:c.name,
        qty:1
      });
    }

  });

  return cap;
}

getAngolariU(obj:any){
  let ls:any[]=[];
  let codcal="70";
  let misure:any=[];

  if(obj.spessore==13){
     return ls;
  }
  // set accoppiamento senza pavimento + contatto fronte/retro:
  // obj.d = fronte/retro (ingombroX) → un solo U sull'asse aperto (non 2).
  // Su sn/ds il qty*2 resta (comportamento già corretto).
  const linksCombAperti = (this.cellaDati?.celleCollegate || []).filter(
    (c: any) =>
      c.attivo &&
      c.tipoCollegamento === 'combinate' &&
      !c.latocombinato,
  );
  const apertoFR = linksCombAperti.some(
    (c: any) => c.latocollegato === 'lato_fronte' || c.latocollegato === 'lato_retro',
  );
  const qtyD = apertoFR ? 1 : 2;

  this.lunghezzeAngolariService.getDataProfili().filter((x:any)=>x.lunghezza==obj.w).forEach((x:any)=>{
    misure=x.composizione;
  });

 let combAng = Object.values(
      misure.reduce((acc:any, segment:any) => {
        if (!acc[segment]) {
          acc[segment] = { segment: segment, count: 0 };
        }
        acc[segment].count++;
        return acc;
      }, {} as Record<number, any>)
    );

  combAng.forEach((c:any)=>{
    let codice=codcal+obj.spessore.toString().padStart(2,"0")+c.segment.toString().padStart(3,"0")+'000';
    ls.push({
        codice:codice,
        qty:c.count*2
      });
  });
 

let misureAng:any=[]
this.lunghezzeAngolariService.getDataProfili().filter((x:any)=>x.lunghezza==obj.d).forEach((x:any)=>{
    misureAng=x.composizione;
});

 let combAngANG = Object.values(
      misureAng.reduce((acc:any, segment:any) => {
        if (!acc[segment]) {
          acc[segment] = { segment: segment, count: 0 };
        }
        acc[segment].count++;
        return acc;
      }, {} as Record<number, any>)
    );
  combAngANG.forEach((c:any)=>{
    let codice=codcal+obj.spessore.toString().padStart(2,"0")+c.segment.toString().padStart(3,"0")+'000';
    ls.push({
        codice:codice,
        qty:c.count*qtyD
      });
  });

  let nmTreVieLatoNONComb= this.cellaDati.celleCollegate.filter((c:any)=> c.attivo && !c.latocombinato 
  && (c.tipoCollegamento=='collegateDivisorio' || c.tipoCollegamento=='combinate') ).length;
 
  let nmTreVieLatoComb= this.cellaDati.celleCollegate.filter((c:any)=> c.attivo && c.latocombinato 
  && (c.tipoCollegamento=='collegateDivisorio' || c.tipoCollegamento=='combinate') ).length;
 
  
  if(obj.spessore==6){
    if(nmTreVieLatoComb>0){
      ls.push({
        codice:'7000042750',
        qty:2
      });
      ls.push({
          codice:'7000042710',
          qty:2
      });
    }
    if(nmTreVieLatoNONComb>0){
      ls.push({
        codice:'7000042750',
        qty:2
      });
    
    }
    if(nmTreVieLatoNONComb == 0 && nmTreVieLatoComb == 0){
      ls.push({
        codice:'7000042750',
        qty:4
      });
    }  
  }
   
  if(obj.spessore==10){
    if(nmTreVieLatoComb>0){
      ls.push({
        codice:'7000046677',
        qty:2
      });
      ls.push({
          codice:'7000046645',
          qty:2
      });
    }
    if(nmTreVieLatoNONComb>0){
      ls.push({
        codice:'7000046677',
        qty:2
      });
    
    }
    if(nmTreVieLatoNONComb == 0 && nmTreVieLatoComb == 0){
      ls.push({
        codice:'7000046677',
        qty:4
      });
    }  
  }
      
  return ls;
  /*
    
  let cx=0;
 
  
  while(cx<obj.w){
    let misura=320;
    for(let j=0;j<misure.length;j++){
    
      if(misure[j]>=(obj.w-cx)){
        misura=misure[j];
      } else {
        break;
      }
    }
    cx+=misura;
    let codice=codcal+obj.spessore.toString().padStart(2,"0")+misura.toString().padStart(3,"0")+'000';
    let isPres=false;
    ls.forEach((z:any,ind:number)=>{
        if(z.codice==codice){
          isPres=true;
          ls[ind].qty++;
          ls[ind].qty++;
        }
    });
    if(!isPres){
      ls.push({
        codice:codice,
        qty:2
      });
    }
  }

  cx=0;
  while(cx<obj.d){
    let misura=320;
    for(let j=0;j<misure.length;j++){
    
      if(misure[j]>=(obj.d-cx)){
        misura=misure[j];
      } else {
        break;
      }
    }
    cx+=misura;
    let codice=codcal+obj.spessore.toString().padStart(2,"0")+misura.toString().padStart(3,"0")+'000';
    let isPres=false;
    ls.forEach((z:any,ind:number)=>{
        if(z.codice==codice){
          isPres=true;
          ls[ind].qty++;
          ls[ind].qty++;
        }
    });
    if(!isPres){
      ls.push({
        codice:codice,
        qty:2
      });
    }
  }
  if(obj.spessore==6){
      ls.push({
        codice:'7000042750',
        qty:4
      });
  }
  if(obj.spessore==13){
      ls.push({
        codice:'7000046677',
        qty:4
      });
  }
  return ls;
  */
}
getAngolari(obj:any,cc:any){
 let ls:any[]=[];
 let laticombinati=0;
 if(this.cellaDati.celleCollegate.length>0){
  laticombinati=this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocombinato && cc.elencoCelle.filter((c2:any)=>c2.id==x.cellaCollegataId)[0].spessore!=this.cellaDati.spessore).length;
 }
 

 
  obj.angolari.forEach((p:any)=>{
      let pname=p.name;
      if(laticombinati>0 && pname.indexOf('b03')>0){
        pname=pname.replace('06','10').replace('b03','c03'); // speossori diversi a tre vie
      }
     

    let isPres=false;
    ls.forEach((z:any,ind:number)=>{
        if(z.codice==pname){
          isPres=true;
          ls[ind].qty++;
        }
    });
    if(!isPres){
      ls.push({
        codice:pname,
        qty:1
      });
    }
  });
  return ls;
}

getPavimento(obj:any){
  let ls:any[]=[];
  obj.objPavimento.pannelli.forEach((p:any)=>{
    let isPres=false;
    ls.forEach((z:any,ind:number)=>{
        if(z.codice==p.name){
          isPres=true;
          ls[ind].qty++;
        }
    });
    if(!isPres){
      ls.push({
        codice:p.name,
        qty:1
      });
    }
  });
  return ls;
}


getVespaio(obj:any){
  let ls:any[]=[];
  
const availableLengths = [160, 200, 240, 280, 320];
const targetLength = obj.w;

const result = this.findBestCombination(targetLength, availableLengths);

  result.combination.forEach((x:any)=>{
    let isPres=false;
    let name='7500'+x+'000';
    ls.forEach((z:any,ind:number)=>{
    
      if(z.codice==name){
        isPres=true;
        ls[ind].qty++;
      }
    });
    if(!isPres){
      ls.push({
        codice:name,
        qty:1
      });
    }
   
  });
  
  ls.forEach((z:any,ind:number)=>{
    z.qty=z.qty*obj.objVespaio.pannelli.length;
  });
  this.currVespaio=ls;
  return ls;
}




findBestCombination(target: number, availableLengths: number[]) {
  let best: any | null = null;

  const dfs = (current: number[], sum: number, start: number) => {
    if (sum >= target) {
      const waste = sum - target;
      if (!best || waste < best.waste) {
        best = {
          combination: [...current],
          totalLength: sum,
          waste: waste
        };
      }
      return;
    }

    for (let i = start; i < availableLengths.length; i++) {
      current.push(availableLengths[i]);
      dfs(current, sum + availableLengths[i], i); // Consente riutilizzo delle stesse lunghezze
      current.pop();
    }
  };

  dfs([], 0, 0);
  return best!;
};



getSigillante(obj:any){
  let ls:any[]=[];
  let qty=1;
  if(obj.spessore<=6){
      return [];
  }
  if(obj.h*obj.w*obj.d>3000000){
       qty++;
  }
  //Nbtb = Nbtb + Int(Peri / 500) + 1 
  qty+=Math.round((obj.w*2+obj.d)/500)+1;
  ls.push({
      codice:'4000013706',
      qty:qty
    });
  return ls;
}

getFastFit(obj:any){
  //4000095212
 
  let ls:any[]=[];
  let ff=0;

  
  obj.objFronte.pannelli.forEach((p:any)=>{
    if(p.h>160){
      ff+=2;
    }
  });
  obj.objLatDs.pannelli.forEach((p:any)=>{
    if(p.h>160){
        ff+=2;
    }
  });
  obj.objLatSin.pannelli.forEach((p:any)=>{
    if(p.h>160){
    ff+=2;
    }
  });
  obj.objRetro.pannelli.forEach((p:any)=>{
    if(p.h>160){
       ff+=2;
    }
  });
  obj.objPavimento.pannelli.forEach((p:any)=>{
    if(p.h>160){
       ff+=2;
    }
  });
  obj.objSoffitto.pannelli.forEach((p:any)=>{
    if(p.h>160){
      ff+=2;
    }
  });
  ls.push({
        codice:'4000095212',
        qty:ff+8
      });
  return ls;
}

getTravi(obj:any){
  let ls:any[]=[];
  if(!obj.objTravi){
    return ls;
  }
  obj.objTravi.forEach((p:any)=>{
    ls.push({
        codice:p.name,
        qty:p.qty
    });
    // SET STAFFA TRAVE 
    let filePannelli=obj.objSoffitto.pannelli.filter((x:any)=>x.z==0).length-1;
    

    if(this.cellaDati.spessore==6){
      ls.push({
        codice:'5100095100',
        qty:p.qty*filePannelli
      });
    } else {
      ls.push({
        codice:'5100095101',
        qty:p.qty*filePannelli
      });
    }

  });
  return ls;
}

getLaterali(obj:any){

  let ls:any[]=[];
  
    this.objDivisori.forEach((d:any)=>{
      
        d.pannelli.forEach((p:any)=>{
          if(!p.porta){
            let isPres=false;
            ls.forEach((z:any,ind:number)=>{
              if(z.codice==p.name){
                isPres=true;
                ls[ind].qty++;
              }
            });
            if(!isPres){
              ls.push({
                codice:p.name,
                qty:1
              });
            }
          }
        });
    
    });

    obj.objFronte.pannelli.filter((x:any)=> (!x.fittizio ||x.sopraporta) && (!x.porta || x.porta.length==0)).forEach((p:any)=>{
      if(p.sopraporta){
      }
      let isPres=false;
      ls.forEach((z:any,ind:number)=>{

        if(z.codice==p.name){
          isPres=true;
          ls[ind].qty++;
        }
      });
      if(!isPres){
        ls.push({
          codice:p.name,
          qty:1
        });
      }
    });
    obj.objRetro.pannelli.filter((x:any)=>  (!x.fittizio ||x.sopraporta) && (!x.porta || x.porta.length==0)).forEach((p:any)=>{
      let isPres=false;
      ls.forEach((z:any,ind:number)=>{
         if(z.codice==p.name){
          isPres=true;
          ls[ind].qty++;
        }
      });
      if(!isPres){
        ls.push({
          codice:p.name,
          qty:1
        });
      }
    });
   
    obj.objSoffitto.pannelli.forEach((p:any)=>{
      let isPres=false;
      ls.forEach((z:any,ind:number)=>{
        if(z.codice==p.name){
          isPres=true;
          ls[ind].qty++;
        }
      });
      if(!isPres){
        ls.push({
          codice:p.name,
          qty:1
        });
      }
    });
    obj.objLatSin.pannelli.filter((x:any)=> (!x.fittizio ||x.sopraporta) && (!x.porta || x.porta.length==0)).forEach((p:any)=>{
      let isPres=false;
      ls.forEach((z:any,ind:number)=>{
        if(z.codice==p.name){
          isPres=true;
          ls[ind].qty++;
        }
      });
      if(!isPres){
        ls.push({
          codice:p.name,
          qty:1
        });
      }
    });
    obj.objLatDs.pannelli.filter((x:any)=> (!x.fittizio ||x.sopraporta) && (!x.porta || x.porta.length==0)).forEach((p:any)=>{
     let isPres=false;
 
      if((p.name.substring(0,2)=='11' || p.name.substring(0,2)=='12')&& (p.treVie)){
        p.name='13'+p.name.substring(2);
      }
      ls.forEach((z:any,ind:number)=>{
        if(z.codice==p.name){
          isPres=true;
          ls[ind].qty++;
        }
      });
      if(!isPres){
        ls.push({
          codice:p.name,
          qty:1
        });
      }
    });    
    return ls;
}

getFastFit_SupportoSoffitto(objCella:any){
  
  let Nbsp:number=0;
  let codici:any[]=[];

  if(objCella.spessore==6){
    let Cnls:number=objCella.objFronte.pannelli.length; // tutti i pannelli
    Cnls+=objCella.objRetro.pannelli.length;
    Cnls+=objCella.objLatSin.pannelli.length;
    Cnls+=objCella.objLatDs.pannelli.length;
    Cnls+=objCella.objSoffitto.pannelli.length;
    
    let cnpa:number=objCella.objFronte.pannelli.length;  // pannelli laterali
    cnpa+=objCella.objRetro.pannelli.length;
    cnpa+=objCella.objLatSin.pannelli.length;
    cnpa+=objCella.objLatDs.pannelli.length;

    let cnpo:number=0; //CONTEGGIO PORTE
    let Cnpv:number=objCella.objPavimento.pannelli.length;  // PAVIEMNTO
    let Sotp:number=0;
    let Nbtr:number=0;

    let  Totp = Cnls + cnpo + Cnpv; //TOTALE
    let  Nbic = (Totp * 2) + Nbtr * 4 + 10      // '# NUMERO INSERTI 
    Nbsp = (cnpa + cnpo) - Sotp;         //    '# NUMERO SUPPORTI    
    codici.push({codice:'4000095212' ,qty:Nbic});
    codici.push({codice:'4000095400' ,qty:Nbsp});
  } else {
    Nbsp = 4;
    codici.push({codice:'4000095401' ,qty:Nbsp});
  }
  return codici; 
  
}

getChiaveAElle(cella:any){
  return [{codice:'4000044001' ,qty:2}];
}

getCodice(tipo:string,cella:any){

 if((tipo=='soffitto')||(tipo=='laterale')||(tipo=='divisorio')||(tipo=='fronte_retro')){
  if(cella.finitura=='STANDARD'){
    return '10';
  }
  if(cella.finitura=='INOX_INT'){
     return '11';
  }
  if(cella.finitura=='INOX_EST'){
     return '12';
  }
  if(cella.finitura=='INOX_IE'){
     return '13';
  }
 }

 if(tipo=='pavimento'){
    if(cella.finituraPavimento=='CAR_PL'){
      return '60';
    }
    if(cella.finituraPavimento=='CAR_IXI'){
      return '61';
    }
    if(cella.finituraPavimento=='CAR_IXE'){
      return '62';
    }
    if(cella.finituraPavimento=='CAR_IXIE'){
      return '63';
    }  
    if(cella.finituraPavimento=='PED_PL'){
      return '65';
    }    
    if(cella.finituraPavimento=='PED_IXI'){
      return '67';
    }   
    if(cella.finituraPavimento=='P1000'){
      return '66';
    }     
    if(cella.finituraPavimento=='P1000IXE'){
      return '68';
    }   
    if(cella.finituraPavimento=='P1000IX'){
      return '67';
    }       
    if(cella.finituraPavimento=='WALL_PANEL'){
      
        return '10';
   
    } 
  }
 
  
  
  return '';
}

  initScaffale(width:number){
    return {
      id:'n'+uuid.v4(),
      width:width,
      altezza:167,
      numeroRipiani:4,
      scaffaliUniti:false,
      scaffaleBloccato:false,
      elenco:[]
    };
  }

  initDropIn(spessorePannello:number){
    return {
      id:'n'+uuid.v4(),
      spessore:spessorePannello,
      tempInt:'-2/+8',
      tempEst:32,
      volume:9,
      descDropIn:''
    };
  }
  initimpiantoRemoto(tipo:string){
    return {
      id:'n'+uuid.v4(),
      type:tipo,
      impianto:null,
      opzioni:[],
      mandatory:[],
      volume:9,
      tipoImpianto:'',
      art_comp:'',
      numerotubi:1,
      valueSetTubi:'',
      tempEst:0,
      tempInt:0
    };
  }

  initFB(spessorePannello:number,dimensione:string,width:number,height:number,distLato:number,
    lato:string,cellaId:string,subType:null|string=null){
   
      
    this.tempIntSp6=[
      "-2/+8"
   ];

    if(subType==''){
      if(spessorePannello==6){
        return {
          id:'n'+uuid.v4(),
          width:width,
          height:height,
          spessore:spessorePannello,
          dimensione:dimensione,
          tempInt:"0/+2",
          tempEst:43,
          volume:9,
          controllore:'Carel',
          lato:lato,
          distLato:distLato,
          cellaId:cellaId,
          descFreeBlock:'',
          art_comp:'',
          subType:subType,
          accessorio_resistenza_carter:false
        };
      } else{
        return {
          id:'n'+uuid.v4(),
          width:width,
          height:height,
          spessore:spessorePannello,
          dimensione:dimensione,
          tempInt: "-18/-20",
          tempEst:43,
          volume:9,
          controllore:'Carel',
          lato:lato,
          distLato:distLato,
          cellaId:cellaId,
          descFreeBlock:'',
          art_comp:'',
          subType:subType,
          accessorio_resistenza_carter:false
        };
      } 
    } else {  
      return {
        id:'n'+uuid.v4(),
        width:width,
        height:height,
        spessore:spessorePannello,
        dimensione:dimensione,
        tempInt:'-2/+8',
        tempEst:32,
        volume:9,
        controllore:'Eliwell',
        lato:lato,
        distLato:distLato,
        cellaId:cellaId,
        descFreeBlock:'',
        art_comp:'',
        subType:subType,
        accessorio_resistenza_carter:false
      };
    }
    
  }
  initPannelloCustom(ind:number,spessore:number,finitura:number){
    return {
      spessore:spessore,
      finitura:finitura
    };
  }

  /** Lati che formano lo spigolo (come disegnaAngolariVert2). */
  getLatiAngolo(posAng: string): { lato1: string; lato2: string } {
    switch (posAng) {
      case '0':
        return { lato1: 'lato_fronte', lato2: 'lato_sn' };
      case 'w':
        return { lato1: 'lato_sn', lato2: 'lato_retro' };
      case 'wd':
        return { lato1: 'lato_retro', lato2: 'lato_ds' };
      case 'd':
        return { lato1: 'lato_ds', lato2: 'lato_fronte' };
      default:
        return { lato1: '', lato2: '' };
    }
  }

  /**
   * True se il tratto di contatto divisorio sul `latoCollegato` arriva fino allo spigolo `posAng`.
   * Laterali: start=fronte, end=retro. Fronte/retro: start=sn, end=ds.
   */
  contattoDivisorioRaggiungeAngolo(
    link: any,
    latoCollegato: string,
    posAng: string,
    cella: any,
  ): boolean {
    const { lato1, lato2 } = this.getLatiAngolo(posAng);
    if (latoCollegato !== lato1 && latoCollegato !== lato2) {
      return false;
    }
    const altro = latoCollegato === lato1 ? lato2 : lato1;
    const lungh =
      latoCollegato === 'lato_sn' || latoCollegato === 'lato_ds'
        ? cella.ingombroY || 0
        : cella.ingombroX || 0;
    const a = link.distLato || 0;
    // sulla cella corta larghezza può essere 0 → contatto l'intero lato da distLato
    const span =
      link.larghezza > 0 ? link.larghezza : Math.max(0, lungh - a);
    const b = a + span;
    const eps = 1;

    let atStart = false;
    let atEnd = false;
    if (latoCollegato === 'lato_sn' || latoCollegato === 'lato_ds') {
      atStart = altro === 'lato_fronte';
      atEnd = altro === 'lato_retro';
    } else {
      atStart = altro === 'lato_sn';
      atEnd = altro === 'lato_ds';
    }
    if (atStart) {
      return a <= eps;
    }
    if (atEnd) {
      return b >= lungh - eps;
    }
    return false;
  }

  /**
   * Questa cella "possiede" l'asta a 3 vie / compensatorio su quel contatto:
   * - se più corta dell'altra sul lato di contatto → sì (T sulla cella stretta)
   * - se più lunga o uguale → no (uguali: niente T né compensatori)
   */
  cellaPossiedeTreVieDivisorio(link: any, cella: any, config: any): boolean {
    const other = (config?.elencoCelle || []).find((c: any) => c.id == link.cellaCollegataId);
    if (!other) {
      return false;
    }
    const lato = link.latocollegato;
    // dimensione sul lato di contatto (Y per sn/ds, X per fronte/retro)
    const lunghThis =
      lato === 'lato_sn' || lato === 'lato_ds' ? cella.ingombroY || 0 : cella.ingombroX || 0;
    const dimOther =
      lato === 'lato_sn' || lato === 'lato_ds' ? other.ingombroY || 0 : other.ingombroX || 0;

    return lunghThis < dimOther; // solo la più corta; uguali → niente compensatorio / T
  }

  /**
   * Spigolo a 3 vie: contatto divisorio che arriva allo spigolo e cella più stretta.
   */
  isAngoloTreVieDivisorio(posAng: string, cella: any = null, config: any = null): boolean {
    const cellaDati = cella || this.cellaDati;
    const { lato1, lato2 } = this.getLatiAngolo(posAng);
    const links = (cellaDati?.celleCollegate || []).filter(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'collegateDivisorio' &&
        (x.latocollegato === lato1 || x.latocollegato === lato2),
    );
    return links.some(
      (link: any) =>
        this.contattoDivisorioRaggiungeAngolo(link, link.latocollegato, posAng, cellaDati) &&
        this.cellaPossiedeTreVieDivisorio(link, cellaDati, config),
    );
  }

  /**
   * Divisorio a tutto lato tra celle di uguale lunghezza sul contatto:
   * il contatto copre l'intero lato e arriva allo spigolo → tipoAngolo = collegateDivisorio.
   */
  isAngoloDivisorioATuttoLatoUguale(
    posAng: string,
    cella: any = null,
    config: any = null,
  ): boolean {
    const cellaDati = cella || this.cellaDati;
    const { lato1, lato2 } = this.getLatiAngolo(posAng);
    const links = (cellaDati?.celleCollegate || []).filter(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'collegateDivisorio' &&
        (x.latocollegato === lato1 || x.latocollegato === lato2),
    );
    const eps = 0.5;
    return links.some((link: any) => {
      if (
        !this.contattoDivisorioRaggiungeAngolo(link, link.latocollegato, posAng, cellaDati)
      ) {
        return false;
      }
      const other = (config?.elencoCelle || []).find((c: any) => c.id == link.cellaCollegataId);
      if (!other) {
        return false;
      }
      const lato = link.latocollegato;
      const lunghThis =
        lato === 'lato_sn' || lato === 'lato_ds'
          ? cellaDati.ingombroY || 0
          : cellaDati.ingombroX || 0;
      const dimOther =
        lato === 'lato_sn' || lato === 'lato_ds'
          ? other.ingombroY || 0
          : other.ingombroX || 0;
      if (Math.abs(lunghThis - dimOther) > eps) {
        return false;
      }
      const a = link.distLato || 0;
      const span =
        link.larghezza > 0 ? link.larghezza : Math.max(0, lunghThis - a);
      // tutto il lato
      return a <= eps && a + span >= lunghThis - eps;
    });
  }

  /**
   * Non disegnare angolare su questo spigolo: c'è un T divisorio ma lo disegna l'altra cella
   * (questa è più lunga). Se i lati sono uguali non si salta (niente T).
   */
  isAngoloDivisorioSaltato(posAng: string, cella: any = null, config: any = null): boolean {
    const cellaDati = cella || this.cellaDati;
    const { lato1, lato2 } = this.getLatiAngolo(posAng);
    const links = (cellaDati?.celleCollegate || []).filter(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'collegateDivisorio' &&
        (x.latocollegato === lato1 || x.latocollegato === lato2),
    );
    return links.some((link: any) => {
      if (!this.contattoDivisorioRaggiungeAngolo(link, link.latocollegato, posAng, cellaDati)) {
        return false;
      }
      const other = (config?.elencoCelle || []).find((c: any) => c.id == link.cellaCollegataId);
      if (!other) {
        return false;
      }
      const lato = link.latocollegato;
      const lunghThis =
        lato === 'lato_sn' || lato === 'lato_ds' ? cellaDati.ingombroY || 0 : cellaDati.ingombroX || 0;
      const dimOther =
        lato === 'lato_sn' || lato === 'lato_ds' ? other.ingombroY || 0 : other.ingombroX || 0;
      return lunghThis > dimOther; // solo se l'altra è più corta e possiede il T
    });
  }

 tipoAngoloDivisorio(posAng:string,latocombinato=true){
    const { lato1, lato2 } = this.getLatiAngolo(posAng);

    let cellecollegateDivisorio=this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocombinato==latocombinato
    && (x.tipoCollegamento=='collegateDivisorio' && (x.latocollegato==lato1 || x.latocollegato==lato2)) );
  
    
    if(cellecollegateDivisorio.length>0){
      return 'collegateDivisorio';
    }
  
    return '';

  }
  
  
  
  disegnaAngolo(angolo:string,configurazioneCelle:any){
    let res=true;
    const angoliDaCanc = configurazioneCelle?.angoliDaCanc || [];
    let ff=angoliDaCanc.filter((a:any)=> a.lato=='lato_fronte');
    ff.forEach((a:any)=>{

      a.celleUniteSulLato.forEach((v:any,ind:number)=>{
        if(this.cellaDati.id==v.id){
          if(angolo=='0' && ind>0){
              res= false;
          }
          if(angolo=='d' && ind<a.celleUniteSulLato.length-1){
              res= false;
          }
        }
      });
    });
    ff=angoliDaCanc.filter((a:any)=> a.lato=='lato_retro');
    ff.forEach((a:any)=>{
      a.celleUniteSulLato.forEach((v:any,ind:number)=>{
        if(this.cellaDati.id==v.id){
          if(angolo=='w' && ind>0){
            res= false;
          }
          if(angolo=='wd' && ind<a.celleUniteSulLato.length-1){
            res= false;
          }
        }
      });
    });
    ff=angoliDaCanc.filter((a:any)=> a.lato=='lato_sn');
    ff.forEach((a:any)=>{
      a.celleUniteSulLato.forEach((v:any,ind:number)=>{
        if(this.cellaDati.id==v.id){
          // catena dal basso: salta fronte-sn sulle celle sopra la prima, retro-sn sulle non-ultime
          if(angolo=='0' && ind>0){
            res= false;
          }
          if(angolo=='w' && ind<a.celleUniteSulLato.length-1){
            res= false;
          }
        }
      });
    });
    ff=angoliDaCanc.filter((a:any)=> a.lato=='lato_ds');
    ff.forEach((a:any)=>{
      a.celleUniteSulLato.forEach((v:any,ind:number)=>{
        if(this.cellaDati.id==v.id){
          // catena dal basso (come getCatenaPareteContinua):
          // salta fronte-ds ('d') sulle celle sopra la prima, retro-ds ('wd') sulle non-ultime
          if(angolo=='d' && ind>0){
            res= false;
          }
          if(angolo=='wd' && ind<a.celleUniteSulLato.length-1){
            res= false;
          }
        }
      });
    });

    // fallback live: se angoliDaCanc non ha la catena, ricalcola (parete continua visibile)
    if (res && this.cellaDati?.id && configurazioneCelle?.elencoCelle) {
      if (this.angoloSuGiuntoPareteContinua(angolo, configurazioneCelle)) {
        res = false;
      }
    }

    if(this.isAngoloDivisorioSaltato(angolo, this.cellaDati, configurazioneCelle)){
        res= false;
    }

    // set accoppiamento senza parete: niente angolare/cappuccio sullo spigolo del contatto
    if (res && this.checkCombinateLatoDaNonDisegnare(angolo)) {
      res = false;
    }

    // divisorio: una sola parete → la cella con !latocombinato non conta angolare/cappuccio
    // (altrimenti con celle uguali le quantità si raddoppiano). Eccezione: cella corta col T a 3 vie.
    if (
      res &&
      this.checkCombinateLatoDaNonDisegnare(angolo, true) &&
      !this.isAngoloTreVieDivisorio(angolo, this.cellaDati, configurazioneCelle)
    ) {
      res = false;
    }
    
       
    return res;
  }

  /**
   * True se l'angolare cade sul giunto interno di una parete continua unite (lato visibile).
   * Catena ordinata: fronte/retro da sinistra; laterali dal basso.
   */
  angoloSuGiuntoPareteContinua(angolo: string, config: any, cella: any = null): boolean {
    const cellaRef = cella || this.cellaDati;
    const skipIf = (lato: string, pred: (ind: number, len: number) => boolean): boolean => {
      const info = this.getCatenaPareteContinua(lato, cellaRef, config);
      if (!info || !info.chain || info.chain.length <= 1) {
        return false;
      }
      const ind = info.chain.findIndex((c: any) => c.id == cellaRef.id);
      if (ind < 0) {
        return false;
      }
      return pred(ind, info.chain.length);
    };

    // '0' = fronte+sn, 'w' = retro+sn, 'wd' = retro+ds, 'd' = fronte+ds
    if (angolo === '0') {
      return (
        skipIf('lato_fronte', (i) => i > 0) ||
        skipIf('lato_sn', (i) => i > 0)
      );
    }
    if (angolo === 'w') {
      return (
        skipIf('lato_retro', (i) => i > 0) ||
        skipIf('lato_sn', (i, n) => i < n - 1)
      );
    }
    if (angolo === 'wd') {
      // spigolo alto-dx: giunto se continuo sul destro e non è la cella più in alto,
      // oppure continuo sul retro e non è l'ultima a destra
      return (
        skipIf('lato_retro', (i, n) => i < n - 1) ||
        skipIf('lato_ds', (i, n) => i < n - 1)
      );
    }
    if (angolo === 'd') {
      // spigolo basso-dx: giunto se continuo sul destro e non è la cella più in basso,
      // oppure continuo sul fronte e non è l'ultima a destra
      return (
        skipIf('lato_fronte', (i, n) => i < n - 1) ||
        skipIf('lato_ds', (i) => i > 0)
      );
    }
    return false;
  }      
  checkCombinateLatoDaNonDisegnare(angolo:string,isDivisorio=false){
    let lato1=angolo;
    let lato2=angolo;
    let res=false;
    if(angolo=='0'){
      lato1='lato_fronte';
      lato2='lato_sn';
    }
    if(angolo=='w'){
      lato1='lato_retro';
      lato2='lato_sn';
    }
    if(angolo=='wd'){
      lato1='lato_retro';
      lato2='lato_ds';
    }
    if(angolo=='d'){
      lato1='lato_fronte';
      lato2='lato_ds';
    }
    // angolari pav/sof orizzontali: un solo lato (non spigolo)
    if(angolo=='pav_fronte'){
      lato1='lato_fronte';
      lato2='lato_fronte';
    }
    if(angolo=='pav_retro'){
      lato1='lato_retro';
      lato2='lato_retro';
    }
    if(angolo=='pav_sn'){
      lato1='lato_sn';
      lato2='lato_sn';
    }
    if(angolo=='pav_ds'){
      lato1='lato_ds';
      lato2='lato_ds';
    }
    if(!isDivisorio){
      this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && !x.latocombinato && (x.latocollegato==lato1 ||x.latocollegato==lato2)).forEach((c:any)=>{
          if(c.tipoCollegamento=='combinate'){
            res=true;
          }
        });
    } else {

      this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && !x.latocombinato && (x.latocollegato==lato1 ||x.latocollegato==lato2)).forEach((c:any)=>{
        if(c.tipoCollegamento=='collegateDivisorio'){
          res=true;
        }
      });
    }
  
    return res;

  }

  initDivisorio(type:string,w:number,spessore:number,x:number,y:number){
     let divi= {
        id:'n'+uuid.v4(),
        type:type,
        distLato:0,
        w:w,
        spessore:spessore,
        x:x,
        y:y
     };
     return divi;
  }

  // compatibilta dei vecchi preventivi con i nuovi
  getCompatibilitbyCelle(cc:any,opzioniList:any,lang:string,electrolux:any){



    let conf:any=this.initConfigurazione(opzioniList,lang,electrolux);
    let cella:any=this.initCella(opzioniList,lang,electrolux);
    for (const key of Object.keys(conf)) {
      if(!cc.hasOwnProperty(key)){
       cc[key]=conf[key];
      }
    }

    cc.elencoCelle.forEach((currCella:any,ind:number)=>{
      for (const key of Object.keys(cella)) {
        if(!currCella.hasOwnProperty(key)){
          cc.elencoCelle[ind][key]=cella[key];
        } 
      }
    });         
  }

  initConfigurazione(opzioniList:any,lang:string,electrolux:any,aggiungiCella=true,isMiniCella=false){
      let c:any=this.initCella(opzioniList,lang,electrolux);
      let cList:any=[];
      c.isMiniCella=isMiniCella;
     if(this.userCellePreConf()){
        this.initCellaPreConf(c);
        cList=[c];
      } else {
        cList=[c];
        if(!aggiungiCella){
          cList=[];
        }
      }
      
      this.changeDescTecnica(c,lang);
      return {
        status:'NUOVA',
        prezzo:0,
        prezzolordo:0,
        geometria:'RETTANGOLARI',
        descrizione:'',
        sconto:0,
        numeroCelle:1,
        elencoFreeBlocks:[],
        elencoImpiantiRemoti:[],
        elencoDropin:[],
        elencoScaffali:[],
        elencoCelle:cList,
        electrolux:electrolux,
        elencoPorteScollegate:[],
        elencoPunti:[],
        elencoAngoli:[],
      };
     
  }

  // CELLE PER DAGARD
  initCellaPreConf(c:any){
    c.altezza=220;
    c.ingombroX=120;
    c.ingombroY=120;
    c.soffittoMAXI=true;
    c.isCellaPreConf=true;
    if(this.tipoCellaOptions.length>0){
       c.tipoCella=this.tipoCellaOptions[0].value;
    } else {
      this.apiService.post('app/opportunity_gettipocella',{spessore:c.spessore}).subscribe(data2 => {
            this.tipoCellaOptions=data2;
            this.tipoCellaOptions.forEach((t:any)=>{
              t.label=this.lang.el(t.label);
            });
            c.tipoCella=this.tipoCellaOptions[0].value;
        });
    }
   
  }

  initCella(opzioniList:any,lang:string,electrolux:any){
    let cella= {
        id:'n'+uuid.v4(),
        descrizioneTecnica:'',
        combinata:'',
        celleCombinate:[],
        electrolux:electrolux,
        tipoCollegamento:'',
        cellaUnitaId:0,
        celleCollegate:[],
        distLato:0,   
        isCellaPreConf:false,
        isMiniCella:false,
        minicellaImpianto:'Nessun_impianto',
        minicellaScaffale:'',
        impiantiMiniCelleOptions:[],
        customClient:'',
        altezza:240,
        ingombroX:320,
        ingombroY:320,
        tipoCella:'',
        finitura:'STANDARD',
        spessore:6,
        valvolaCompensazione:false,
        pannellicustom:{ 
          fronte:{},
          retro: {},
          sinistra:{},
          destra:{}
        }, 
        angolaricustom:{ 
          sinistraretro:{
            finitura:'STANDARD'
          },
          sinistrafronte: {
            finitura:'STANDARD'
          },
          destraretro:{
            finitura:'STANDARD'
          },
          destrafronte:{
            finitura:'STANDARD'
          },
        }, 
        porta:false,
        finituraangolari:'STANDARD',
        pavimenti:true,
        finituraPavimento:'CAR_PL',
        finituraDivisori:'STANDARD',
        divisoriporta:true,
        soffittoMAXI:false,
        vespaio:false,
        ruotasoffitto:false,
        ruotaPavimento:false,
        passo:40,
        altezzaOrizz:4,
        finituraOrizz:'',
        divisoriSpessore:0,
        lato_porta:'lato_fronte',
        lato_porta_lato_fronte:false,
        lato_porta_lato_retro:false,
        lato_porta_lato_sn:false,
        lato_porta_lato_ds:false,
        lato_raccordo:'',
        lato_raccordo_prec:'',
        divisorioCella:'normale',
        portaDivisorio:this.initPorta(),
        elencoPorte:[],
        opzioni:structuredClone(opzioniList),
        offsetX:300,
        offsetY:300,
        offsetX3d:0,
        offsetY3d:0,
        
        divisori:[],
        scaffaliCellePreconfCodice:'',
        scaffaliCellePreconfTipoOptions:[],
        scaffaliCellePreconf:false,    

    };
   
    this.onChangeSpessore(cella,lang);

    return cella;
  }

  
   
  initPorta(){
    


      let porta= {
        id:uuid.v4(),
        tipoPorta:'STANDARD',
        tipologiaPorta:'STANDARD',
        versoAperturaPorta:-1,
        luceNetta:'',
        pavimentoPorta:1,
        divisorioPorta:-1,
        divisorioCollegatoId:null,
        modelloPorta:'',
        tipo1Porta:this.userCellePreConf()? 'DAGARD':this.globalService.societa=='DAGARD'? 'DAGARD': this.tipo1PortaOptions[0].value,
        larghporta:80,
        altezza:0,
        distSnPorta:0,
        leftDoorSpacepx:'0px',
        leftDoorSpace:0,
        rightDoorSpacepx:'0px',
        rightDoorSpace:0,
        doorSpacepx:'0px',
        doorSpace:0,
        largDivlatoporta:0,
        modelliPortaOptions:[],
        eleDistOptions:[0],
        strisceporta:false,
        ruota180gradi:false,
        configurata:false,
        conoblo:false,
        configurataOpzioni:[],
        configurataMandatory:[],
        scollegata:false
      };

      return porta;
  }

  isCustomDistinta(){
   return this.distintaData.filter((x:any)=>x.new==='x').length>0;
  }
  
  resetDistinta(configurazioneCelle:any){
    configurazioneCelle.prezzolordo=0;
    this.distintaData=[];
  }
  
  changeIngombri(cella:any){
   
    
    cella.ingombroX=Math.round(cella.ingombroX/20)*20;
    if(cella.spessore==13){
       cella.ingombroY=Math.round(cella.ingombroY/40)*40;
    } else {
        cella.ingombroY=Math.round(cella.ingombroY/20)*20;
    }
 
  }

  
  
  setCollegamentoCella(c1:any,c2:any,node1:any,node2:any,ccElencoCelle:any){
    

    let c1Piccola=false;
    let lato='';
    let lato2='';
    if(this.currCollegamento.latocollegato=='lato_sn' || this.currCollegamento.latocollegato=='lato_ds'){
        if(c1.ingombroY<=c2.ingombroY){
          c1Piccola=true;
        } else {
          if(c1.ingombroY==c2.ingombroY && node1.zIndex>node2.zIndex){
            c1Piccola=true;
          }
        }
  
        if(node1.offsetX>node2.offsetX){
          lato='lato_sn';
          lato2='lato_ds';
        } else {
          lato='lato_ds';
          lato2='lato_sn';
        }
    }
    if(this.currCollegamento.latocollegato=='lato_fronte' || this.currCollegamento.latocollegato=='lato_retro'){
     
      if(c1.ingombroX<c2.ingombroX){
        c1Piccola=true;
      } else {
        if(c1.ingombroX==c2.ingombroX && node1.zIndex>node2.zIndex){
          c1Piccola=true;
        }
      }

      if(node1.offsetY<node2.offsetY){
        lato='lato_fronte';
        lato2='lato_retro';
      } else {
        lato='lato_retro';
        lato2='lato_fronte';
      }
    }
    
    // ATTENZIONE: con set accoppiamento la cella SENZA pavimento perde la parete
    // (latocombinato=false); quella CON pavimento la mantiene (latocombinato=true).
    if (this.currCollegamento.tipoCollegamento === 'combinate') {
      if (!c1.pavimenti) {
        c1Piccola = true;
      } else if (!c2.pavimenti) {
        c1Piccola = false;
      }
    }

    c1.celleCollegate.forEach((coll:any,ind:number)=>{
      
        if(coll.cellaCollegataId==c2.id){
          c1.celleCollegate[ind].tipoCollegamento=this.currCollegamento.tipoCollegamento;
          c1.celleCollegate[ind].latocollegato=lato;
          c1.celleCollegate[ind].attivo=this.currCollegamento.attivo;
         // if(!c1Piccola && (this.currCollegamento.tipoCollegamento=='combinate' || this.currCollegamento.tipoCollegamento=='collegateDivisorio')){
          if(!c1Piccola && (this.currCollegamento.tipoCollegamento=='combinate')){
            c1.celleCollegate[ind].latocombinato=true;
          } else {
            c1.celleCollegate[ind].latocombinato=false;
          }
          if(!c1Piccola){
            c1.celleCollegate[ind].latocombinato=true;
          } else {
            c1.celleCollegate[ind].latocombinato=false;
          }
          let distLato=0;
          let larghezza=0;
          // usare il lato geometrico (lato), non currCollegamento.latocollegato:
          // su fronte/retro la lunghezza contatto è X, su sn/ds è Y
          const contattoFR = lato === 'lato_fronte' || lato === 'lato_retro';
          const contattoLat = lato === 'lato_sn' || lato === 'lato_ds';

          if(!c1Piccola){
            if(contattoFR){
              larghezza=c2.ingombroX;
              distLato=Math.round(node2.offsetX-node2.width/2)-Math.round(node1.offsetX-node1.width/2);
            }
            if(contattoLat){
              larghezza=c2.ingombroY;
              distLato=Math.round(node1.offsetY+node1.height/2)-Math.round(node2.offsetY+node2.height/2);
            }
            
          } else {
            larghezza=0;
            if(this.currCollegamento.tipoCollegamento=='combinate' ){
              if(contattoLat){
                larghezza=c1.ingombroY;
              } else if(contattoFR){
                larghezza=c1.ingombroX;
              }
            }
            distLato=0;
          }
          c1.celleCollegate[ind].distLato=distLato;
          c1.celleCollegate[ind].larghezza=larghezza;  
        }
     });
     c2.celleCollegate.forEach((coll:any,ind:number)=>{
      
        if(coll.cellaCollegataId==c1.id){
          c2.celleCollegate[ind].tipoCollegamento=this.currCollegamento.tipoCollegamento;
          c2.celleCollegate[ind].latocollegato=lato2;
          c2.celleCollegate[ind].attivo=this.currCollegamento.attivo;
         // if(c1Piccola && (this.currCollegamento.tipoCollegamento=='combinate' || this.currCollegamento.tipoCollegamento=='collegateDivisorio')){
          if(c1Piccola && (this.currCollegamento.tipoCollegamento=='combinate')){
           c2.celleCollegate[ind].latocombinato=true;
          } else {
            c2.celleCollegate[ind].latocombinato=false;
          }
          if(c1Piccola){
            c2.celleCollegate[ind].latocombinato=true;
          } else {
            c2.celleCollegate[ind].latocombinato=false;
          }
          let distLato=0;
          let larghezza=0;
          const contattoFR2 = lato2 === 'lato_fronte' || lato2 === 'lato_retro';
          const contattoLat2 = lato2 === 'lato_sn' || lato2 === 'lato_ds';

          if(c1Piccola){
            if(contattoFR2){
              larghezza=c1.ingombroX;
              distLato=Math.round(node1.offsetX-node1.width/2)-Math.round(node2.offsetX-node2.width/2);
            }
            if(contattoLat2){
              larghezza=c1.ingombroY;
              distLato=Math.round(node2.offsetY+node2.height/2)-Math.round(node1.offsetY+node1.height/2);
            }
            
          } else {
            larghezza=0;
            if(this.currCollegamento.tipoCollegamento=='combinate'){
              if(contattoLat2){
                larghezza=c2.ingombroY;
              } else if(contattoFR2){
                larghezza=c2.ingombroX;
              }
            }
            distLato=0;
          }
          c2.celleCollegate[ind].distLato=distLato;
          c2.celleCollegate[ind].larghezza=larghezza;  
        }
     });
     // Mai setCellaContent qui: i bordi li fa sempre updateHtmlNodesOuterBorders
     // (altrimenti transparent/margini CSS restano appiccicati e il divisorio sembra unite).

  }

  disabledMoveOrResize(cC:any,nodo:any,args:any=null){
    if(!nodo.addInfo || !nodo.addInfo.id){
      return false;
    }
    if(nodo.addInfo.type=='scaffale'){
      let bloccato=false;
      cC.elencoScaffali.forEach((c:any)=>{
        if(nodo.addInfo.id==c.id){
          if(c.scaffaleBloccato){
             bloccato= true;
          }
        }
      });
      return bloccato;
    }
    if(nodo.addInfo.type=='cella'){
      let cella:any=null;
      cC.elencoCelle.forEach((c:any)=>{
        if(nodo.addInfo.id==c.id){
          cella=c;
        }
      });
      if(cella ){
      
        if(this.userCellePreConf() && args){
          if(Math.round(args.newValue.width)>400){
            return true;
          }
          if(Math.round(args.newValue.height)>400){
            return true;
          }
        }

        if(cella.celleCollegate.length==0){
          return false;
        }
        if(cella.celleCollegate.filter((c:any)=>c.attivo).length>0){
          return true;
        } 
      }
    }
    return false;
  }


  changeCollegamentoCella(event:any,cella:any){
      cella.celleCombinate.push(this.cellaCombinataInd);
  }

  
  addPortaDivisorio(cellaCollegataInd:number,nodoCella:any,latoDivisorio:string,cellaIndex:number,prev:any){
      let copyPorta = (JSON.parse(JSON.stringify(this.nodePortaSN)));
      copyPorta.addInfo.cellaCollegataInd=cellaIndex;
      copyPorta.addInfo.id='n'+uuid.v4();
      let dist=0;
      if(latoDivisorio=='lato_ds'){
        dist=Math.round((nodoCella.height-copyPorta.height)/2);
        copyPorta.offsetX=nodoCella.offsetX+Math.round(nodoCella.width/2)-Math.round(copyPorta.width/2);
        copyPorta.offsetY=nodoCella.offsetY-Math.round(nodoCella.height/2)+dist;
      }
      if(latoDivisorio=='lato_sn'){
        dist=Math.round((nodoCella.height-copyPorta.height)/2);
        copyPorta.offsetX=nodoCella.offsetX-Math.round(nodoCella.width/2)+Math.round(copyPorta.width/2);
        copyPorta.offsetY=nodoCella.offsetY-Math.round(nodoCella.height/2)+dist;
      }
      if(latoDivisorio=='lato_retro'){
        dist=Math.round((nodoCella.width-copyPorta.width)/2);
        copyPorta.offsetX=nodoCella.offsetX-Math.round(nodoCella.width/2)+dist;
        copyPorta.offsetY=nodoCella.offsetY-Math.round(nodoCella.height/2)+Math.round(copyPorta.height/2);
      }
      if(latoDivisorio=='lato_fronte'){
        dist=Math.round((nodoCella.width-copyPorta.width)/2);
        copyPorta.offsetX=nodoCella.offsetX-Math.round(nodoCella.width/2)+dist;
        copyPorta.offsetY=nodoCella.offsetY+Math.round(nodoCella.height/2)-Math.round(copyPorta.height/2);
      }
    
      copyPorta.addInfo.cellaCollegataId=nodoCella.addInfo.id;
      copyPorta.addInfo.cellaCollegataInd=cellaCollegataInd;
      copyPorta.addInfo.cellaCollegataLato=latoDivisorio;
      copyPorta.addInfo.cellaCollegataDistLato=40;
      copyPorta.addInfo.portaDivisorio=true;
      
      return copyPorta;
  }

  addPorta(cc:any,cellaDati:any,lato:string,prev:any,nodo:any=null,divisorio:any=null){
    // elimina la porta dall'elenco delle porte scollegate
    if(nodo){
      cc.elencoPorteScollegate.forEach((p:any,ind:number)=>{
        if(p.id==nodo.addInfo.id){
          cc.elencoPorteScollegate.splice(ind,1);
          this.currPortaScollegataInd=-1;
        }
      });
    }
    let p:any=this.initPorta();
    if(nodo){
     p.versoAperturaPorta=nodo.addInfo.apertura;
     switch(nodo.addInfo.title){
      case 'SC L':
      case 'SC R':
        p.tipologiaPorta='SCORREVOLI';
        p.scorrevole=true;
        p.configurata=true;
         break;
      case 'SC IND L':
      case 'SC IND R':
        p.tipologiaPorta='INDUSTRIALI SCORREVOLI';
        p.scorrevole=true;
        p.configurata=true;
       
        break;
      case 'IND L':
      case 'IND R':
        p.tipologiaPorta='INDUSTRIALI BATTENTE';
        p.configurata=true;
        break;
      case 'L':
      case 'R':
        p.tipologiaPorta='STANDARD';
         break;

     }
    }

    if(lato=='lato_retro'){
      let nump=cellaDati.elencoPorte.filter((x:any)=>x.lato_porta=='lato_retro').length+1;
      p.nomePorta=this.lang.el('Lato retro')+' '+nump;
      p.lato_porta='lato_retro';
    }
    if(lato=='lato_fronte'){
      let nump=cellaDati.elencoPorte.filter((x:any)=>x.lato_porta=='lato_fronte').length+1;
      p.nomePorta=this.lang.el('Lato fronte')+' '+nump;
      p.lato_porta='lato_fronte';
    }
    if(lato=='lato_ds'){
      let nump=cellaDati.elencoPorte.filter((x:any)=>x.lato_porta=='lato_ds').length+1;
      p.nomePorta=this.lang.el('Lato destro')+' '+nump;
      p.lato_porta='lato_ds';
    }
    if(lato=='lato_sn'){
      let nump=cellaDati.elencoPorte.filter((x:any)=>x.lato_porta=='lato_sn').length+1;
      p.nomePorta=this.lang.el('Lato sinistro')+' '+nump;
      p.lato_porta='lato_sn';
    }
  
    if(divisorio){
      p.portaDivisorio=true;
      p.divisorioCollegatoId=divisorio.divisorioCollegatoId;
    }
   
    cellaDati.elencoPorte.push(p);
    this.onChangeSpessore(cellaDati,prev.lang);
    let distPorta=0;

    this.changeModelloPorta(null,cellaDati,cellaDati.elencoPorte[cellaDati.elencoPorte.length-1],'',distPorta);
    cellaDati.elencoPorte.sort((a:any, b:any) => (a.lato_porta > b.lato_porta ? -1 : 1));
  
    if(lato=='lato_fronte'){
      cellaDati.lato_porta_lato_fronte=true;
    }
    if(lato=='lato_retro'){
      cellaDati.lato_porta_lato_retro=true;
   
    }
    if(lato=='lato_sn'){
      cellaDati.lato_porta_lato_sn=true;
    }
    
    if(lato=='lato_ds'){
      cellaDati.lato_porta_lato_ds=true;
    }

    return p.id;
  
  }

  addPortaScollegata(cC:any,nodo:any=null){
    let p:any=this.initPorta();
    p.scollegata=true;
    p.montataSuDivisorio=false;
    p.spessore=true;
    p.altezza=240;
    p.spessore=6;
    if(nodo.addInfo.apertura){
      p.versoAperturaPorta=nodo.addInfo.apertura;
    }
    p.pavimenti=true;
    if(nodo){
     switch(nodo.addInfo.title){
      case 'SC L':
      case 'SC R':
        p.tipologiaPorta='SCORREVOLI';
        p.scorrevole=true;
         break;
      case 'SC IND L':
      case 'SC IND R':
        p.tipologiaPorta='INDUSTRIALI SCORREVOLI';
        p.scorrevole=true;
        break;
      case 'IND L':
      case 'IND R':
        p.tipologiaPorta='INDUSTRIALI BATTENTE';
         break;
      case 'L':
      case 'R':
        p.tipologiaPorta='STANDARD';
         break;

     }
    }

    let nump=cC.elencoPorteScollegate.length+1;
    p.nomePorta=this.lang.el('Porta scollegata')+' '+nump;
    p.lato_porta='lato_retro';

    cC.elencoPorteScollegate.push(p);

    
    this.changeModelloPorta(null,this.initCella([],'',false),cC.elencoPorteScollegate[cC.elencoPorteScollegate.length-1]);

    

    return p.id;
  
  }

  changeTipoCella(configurazioneCelle:any){
    configurazioneCelle.elencoCelle.forEach((c:any)=>{
      if(c.cellaUnitaId==configurazioneCelle.elencoCelle[this.currCellaInd].id){
        c.tipoCella=configurazioneCelle.elencoCelle[this.currCellaInd].tipoCella
      }
    });
    if(configurazioneCelle.elencoCelle[this.currCellaInd].cellaUnitaId!=''){
      configurazioneCelle.elencoCelle.forEach((c:any)=>{
      if(c.id==configurazioneCelle.elencoCelle[this.currCellaInd].cellaUnitaId){
        c.tipoCella=configurazioneCelle.elencoCelle[this.currCellaInd].tipoCella
      }
    });
    }    
  }

  loadDroInOptionms(dataJson:any){
    dataJson.forEach((i:any)=>{
      if(!this.dropInOptions.IdTemperaturaInterna.includes(i.IdTemperaturaInterna)){
        this.dropInOptions.IdTemperaturaInterna.push(i.IdTemperaturaInterna);
      }
      if(!this.dropInOptions.IdTemperaturaEsterna.includes(i.IdTemperaturaEsterna)){
        this.dropInOptions.IdTemperaturaEsterna.push(i.IdTemperaturaEsterna);
      }
    });
  }  
  
  loadFreeBlocksOptionms(dataJson:any){
    dataJson.forEach((i:any)=>{
      if(!this.freeBlockOptions.IdTemperaturaInterna.includes(i.IdTemperaturaInterna)){
        this.freeBlockOptions.IdTemperaturaInterna.push(i.IdTemperaturaInterna);
      }
      if(!this.freeBlockOptions.IdTemperaturaEsterna.includes(i.IdTemperaturaEsterna)){
        this.freeBlockOptions.IdTemperaturaEsterna.push(i.IdTemperaturaEsterna);
      }
    });
  }  

  loadImpiantiremotiOptionms(what:string,ir:any){
    ir[what].forEach((i:any)=>{
      if(!this.impiantiRemotiOptions[what].IdTemperaturaInterna.includes(i.IdTemperaturaInterna)){
        this.impiantiRemotiOptions[what].IdTemperaturaInterna.push(i.IdTemperaturaInterna);
      }
      if(!this.impiantiRemotiOptions[what].IdTemperaturaEsterna.includes(i.IdTemperaturaEsterna)){
        this.impiantiRemotiOptions[what].IdTemperaturaEsterna.push(i.IdTemperaturaEsterna);
      }
      if(!this.impiantiRemotiOptions[what].Volume.includes(i.Volume)){
        this.impiantiRemotiOptions[what].Volume.push(i.Volume);
      }
    });
  }

  loadcurrImpiantoRemotoOptionms(tipo:string,cC:any){
    this.impiantoRemotoOpzioniData={
      gruppi:[],
      opzioni:[]
    };
    let param={
      impianto:tipo,
    };
    this.apiService.post('app/opportunity_getimpiantiopzioni',param).subscribe(data2 => {
      this.impiantoRemotoOpzioniData.opzioni=data2.Result.opzioni;
      this.impiantoRemotoOpzioniData.gruppi=data2.Result.gruppi;

     this.changeImpiantoRemotoOptions2(cC,this.currImpiantoInd,false);
      this.changeImpiantoRemoto(cC,this.currImpiantoInd,false);

    });
  }
  
  changeFreeBlockOptions(cc:any,indIR:number,prev:any,setartcomp=false){
      cc.elencoFreeBlocks[indIR].descFreeBlock='';
      cc.elencoFreeBlocks[indIR].art_comp='';
      let freebdata:any=this.freeBlocksdataService.getData();
      if(cc.elencoFreeBlocks[indIR].subType){
        freebdata=this.freeBlocksdataService.getDataUniversal();
      }
      if(cc.electrolux==1){
       freebdata= freebdata.filter((x:any)=> this.freeBlockElectrolux.includes(x.art_comp));
      } else {
        freebdata= freebdata.filter((x:any)=> !this.freeBlockElectrolux.includes(x.art_comp));
      }
      let freeFilter:any=null;
      if(cc.elencoFreeBlocks[indIR].subType){
        freeFilter=freebdata.filter((x:any)=>
           cc.elencoFreeBlocks[indIR].tempInt==x.IdTemperaturaInterna
          && cc.elencoFreeBlocks[indIR].tempEst==x.IdTemperaturaEsterna
          && cc.elencoFreeBlocks[indIR].controllore==x.Controllore
         );
      } else {
        freeFilter=freebdata.filter((x:any)=>
        cc.elencoFreeBlocks[indIR].spessore==x.Spessore_pannello 
        && cc.elencoFreeBlocks[indIR].tempInt==x.IdTemperaturaInterna
        && cc.elencoFreeBlocks[indIR].tempEst==x.IdTemperaturaEsterna
        && cc.elencoFreeBlocks[indIR].controllore==x.Controllore
        && cc.elencoFreeBlocks[indIR].dimensione==x.Dimensione_pannello
       );
  
      }
   

      this.freeblocksTipiOpt=[];
      freeFilter.forEach((x:any)=>{
      this.freeblocksTipiOpt.push({
          value:x.art_comp,
          label:this.lang.el('Max vol.')+': '+x.Volume+this.lang.el(' >> Impianto')+': '+x.tipoImpianto,
          volume:x.Volume
        });
      });

      if(cc.elencoCelle.length>0){
        let volume=(3+cc.elencoCelle[0].ingombroX)*(3+cc.elencoCelle[0].ingombroY)*cc.elencoCelle[0].altezza/1000000;

        if(setartcomp){
          if (!Number.isNaN(volume)) {
            cc.elencoFreeBlocks[indIR].art_comp=freeFilter[0].art_comp;
          } else {
            let isok=false;

            freeFilter.forEach((x:any)=>{

              if(x.Volume>=volume && !isok){
                  cc.elencoFreeBlocks[indIR].art_comp=x.art_comp;
                  isok=true;

              }
            });
          }
        
          }
      } 
  }

  setFreeBlock(cc:any,indIR:number,prev:any){
     
      let freebdata:any=this.freeBlocksdataService.getData();
      if(cc.elencoFreeBlocks[indIR].subType){
        freebdata=this.freeBlocksdataService.getDataUniversal();
      }
      if(cc.electrolux==1){
        freebdata = freebdata.filter((x:any)=> this.freeBlockElectrolux.includes(x.art_comp));
      } else {
        freebdata = freebdata.filter((x:any)=> !this.freeBlockElectrolux.includes(x.art_comp));
      }
      let freeFilter=freebdata.filter((x:any)=>x.art_comp==cc.elencoFreeBlocks[indIR].art_comp);
       if(freeFilter.length>0){
        cc.elencoFreeBlocks[indIR].descFreeBlock=freeFilter[0].tipoImpianto;
      } 
      if(cc.elencoFreeBlocks[indIR].controllore=='Carel'){
        cc.elencoFreeBlocks[indIR].accessorio_bus_adapter=false;
      }
  }
  
  setDropin(cc:any,indIR:number){
      let dropinData=this.dropindataService.getData();
      let dropinFilter=dropinData.filter((x:any)=>x.art_comp==cc.elencoDropin[indIR].art_comp);
       if(dropinFilter.length>0){
        cc.elencoDropin[indIR].descDropIn=dropinFilter[0].tipoImpianto;
      } 
   
      
  }

  changeDropinOptionms(cc:any,indIR:number){
      cc.elencoDropin[indIR].descDropIn='';
      cc.elencoDropin[indIR].art_comp='';
      let dropinData=this.dropindataService.getData();
      let dropinFilter=dropinData.filter((x:any)=>
      cc.elencoDropin[indIR].spessore==x.Spessore_pannello 
      && cc.elencoDropin[indIR].tempInt==x.IdTemperaturaInterna
      && cc.elencoDropin[indIR].tempEst==x.IdTemperaturaEsterna );
       this.dropinTipiOpt=[];
      dropinFilter.forEach((x:any)=>{
      this.dropinTipiOpt.push({
          value:x.art_comp,
          label:this.lang.el('Max vol.')+': '+x.Volume+this.lang.el(' >> Impianto')+': '+x.tipoImpianto
        });
      });
  }

  changeImpiantoRemoto(cc:any,indIR:number,reset=true){
    let tempInt=cc.elencoImpiantiRemoti[indIR].tempInt;
    let tempEst=cc.elencoImpiantiRemoti[indIR].tempEst;
    let art_comp=cc.elencoImpiantiRemoti[indIR].art_comp;
 

    this.impiantoRemotoOpzioni=[];
    this.impiantoRemotoMandatory=[];
    let irData=this.irData[cc.elencoImpiantiRemoti[indIR].type].filter((x:any)=>
      x.IdTemperaturaInterna==tempInt && x.IdTemperaturaEsterna==tempEst && x.art_comp==art_comp);
    if(irData.length>0){
      if(reset){
        cc.elencoImpiantiRemoti[indIR].tipoImpianto=irData[0].tipoImpianto;
        cc.elencoImpiantiRemoti[indIR].volume=irData[0].Volume;
      }
  
      let cIt:any={
          art_comp:art_comp,
          tipoImpianto:cc.elencoImpiantiRemoti[indIR].tipoImpianto
        };
      let opt= this.impiantoRemotoOpzioniData.opzioni.filter((x:any)=>
          x[cIt.tipoImpianto]=='X' && x.STANDARD=='O'
        );
      let optMandatory= this.impiantoRemotoOpzioniData.opzioni.filter((x:any)=>
          x[cIt.tipoImpianto]=='X' && (x.STANDARD=='C' ||   x.STANDARD=='M')
        );
      
      this.impiantoRemotoOpzioniData.gruppi.forEach((x:any)=>{
        let it:any=[];
        it.push({
          label:this.lang.el('Non presente'),
          value:''
        })
        opt.filter((z:any)=>z.CHAPTER==x.sezione).forEach((k:any)=>{
          it.push({
            value:k.codComp,
            label:k.desc
          })
        });
        if(it.length>1){
          this.impiantoRemotoOpzioni.push(
            {
                  label: x.sezione,
                  value: x.sezione,
                  items: it
          });
        }
      });
      if(reset){
        cc.elencoImpiantiRemoti[indIR].mandatory=[];
      }
      this.impiantoRemotoOpzioniData.gruppi.forEach((x:any)=>{
        let it:any=[];
        optMandatory.filter((z:any)=>z.CHAPTER==x.sezione).forEach((k:any)=>{
          it.push({
            value:k.codComp,
            label:k.desc
          })
        });
        if(it.length>1){
          if(reset){
            cc.elencoImpiantiRemoti[indIR].mandatory.push(it[0].value);
          }
          this.impiantoRemotoMandatory.push(
            {
                  label: x.sezione,
                  value: x.sezione,
                  items: it
          });
        }
      });
    }
    if(reset){
      cc.elencoImpiantiRemoti[indIR].opzioni=Array(this.impiantoRemotoOpzioni.length).fill('');
    }
    this.impiantoRemotoOpzioni=[...this.impiantoRemotoOpzioni];
    this.impiantoRemotoMandatory=[...this.impiantoRemotoMandatory];
    this.applyDesImpiantoRemotoOpzioni(cc.elencoImpiantiRemoti[indIR].type);
    
  }

  changeImpiantoRemotoOptions2(cc:any,indIR:number,reset=true){
    if(reset){
      cc.elencoImpiantiRemoti[indIR].tipoImpianto='';
      cc.elencoImpiantiRemoti[indIR].art_comp='';
      cc.elencoImpiantiRemoti[indIR].mandatory=[];
    }
   
    
    this.impiantoRemotoTipiOpt=[];
    this.impiantoRemotoMandatory=[];
    let tempInt=cc.elencoImpiantiRemoti[indIR].tempInt;
    let tempEst=cc.elencoImpiantiRemoti[indIR].tempEst;
    
    let irData=this.irData[cc.elencoImpiantiRemoti[indIR].type].filter((x:any)=>
    x.IdTemperaturaInterna==tempInt && x.IdTemperaturaEsterna==tempEst);
  
    irData.forEach((x:any)=>{
    if(x.Controllore){
      this.impiantoRemotoTipiOpt.push({
        value:x.art_comp,
        label:x.Controllore + ' ' + this.lang.el('Max vol.')+': '+x.Volume+this.lang.el(' >> ')+': '+x.tipoImpianto
      });  
    } else {
      this.impiantoRemotoTipiOpt.push({
        value:x.art_comp,
        label: this.lang.el('Max vol.')+': '+x.Volume+this.lang.el(' >> ')+': '+x.tipoImpianto
      });  
    }
    
    });
  }

  changeImpiantoRemotoTubi(cc:any,indIR:number,value:string){
    cc.elencoImpiantiRemoti[indIR].valueSetTubi=value;
  }
  changeImpiantoRemotoOptionms(cc:any,indIR:number){
    cc.elencoImpiantiRemoti[indIR].impianto='';
    cc.elencoImpiantiRemoti[indIR].mandatory=[];
    
    this.impiantoRemotoOpzioni=[];
    this.impiantoRemotoMandatory=[];
    let tempInt=cc.elencoImpiantiRemoti[indIR].tempInt;
    let tempEst=cc.elencoImpiantiRemoti[indIR].tempEst;
    let volume=cc.elencoImpiantiRemoti[indIR].volume;  
    

    let irData=this.irData[cc.elencoImpiantiRemoti[indIR].type].filter((x:any)=>
       x.IdTemperaturaInterna==tempInt && x.IdTemperaturaEsterna==tempEst);
    let cIt:any=null;

    irData.forEach((x:any)=>{
      if( x.Volume>volume && !cIt){
        cIt=x;
        cc.elencoImpiantiRemoti[indIR].impianto=cIt;
      }
    });
    if(cIt){
     let opt= this.impiantoRemotoOpzioniData.opzioni.filter((x:any)=>
        x[cIt.tipoImpianto]=='X' && x.STANDARD=='O'
      );
      let optMandatory= this.impiantoRemotoOpzioniData.opzioni.filter((x:any)=>
        x[cIt.tipoImpianto]=='X' && (x.STANDARD=='C' ||   x.STANDARD=='M')
      );
      
      this.impiantoRemotoOpzioniData.gruppi.forEach((x:any)=>{
        let it:any=[];
        it.push({
          label:this.lang.el('Non presente'),
          value:''
        })
        opt.filter((z:any)=>z.CHAPTER==x.sezione).forEach((k:any)=>{
          it.push({
            value:k.codComp,
            label:k.desc
          })
        });
        if(it.length>1){
          this.impiantoRemotoOpzioni.push(
            {
                  label: x.sezione,
                  value: x.sezione,
                  items: it
          });
        }
      });
      cc.elencoImpiantiRemoti[indIR].mandatory=[];
      this.impiantoRemotoOpzioniData.gruppi.forEach((x:any)=>{
        let it:any=[];
        optMandatory.filter((z:any)=>z.CHAPTER==x.sezione).forEach((k:any)=>{
          it.push({
            value:k.codComp,
            label:k.desc
          })
        });
        if(it.length>1){
          cc.elencoImpiantiRemoti[indIR].mandatory.push(it[0].value);
          this.impiantoRemotoMandatory.push(
            {
                  label: x.sezione,
                  value: x.sezione,
                  items: it
          });
        }
      });
    }
    cc.elencoImpiantiRemoti[indIR].opzioni=Array(this.impiantoRemotoOpzioni.length).fill('');
    this.impiantoRemotoOpzioni=[...this.impiantoRemotoOpzioni];
    this.impiantoRemotoMandatory=[...this.impiantoRemotoMandatory];
    this.applyDesImpiantoRemotoOpzioni(cc.elencoImpiantiRemoti[indIR].type);
  }
             
  isconOblo(porta:any){

  if(this.userCellePreConf()){
    return false;
  }
  if(porta.configurata && (porta.tipologiaPorta=='STANDARD' || porta.tipologiaPorta=='SCORREVOLI')){
      return true;
   } else {
      return false;
   }
   
  
  }


  /** Tabella glossario per opzioni impianto remoto */
  srcTableImpiantoRemoto(tipo: string): string {
    switch (tipo) {
      case 'MS': return 'impianti_ms';
      case 'MSG': return 'impianti_msg';
      case 'REFREEX': return 'impianti_refreex';
      case 'SEE': return 'impianti_see';
      case 'SEEW': return 'impianti_seew';
      case 'S_CAR': return 'impianti_s_car';
      case 'SILENT': return 'impianti_silent';
      case 'MISAERM': return 'impianti_misaerm';
      default: return '';
    }
  }

  /** Traduce label gruppi + items dropdown impianto remoto */
  applyDesImpiantoRemotoOpzioni(tipo: string): void {
    const src = this.srcTableImpiantoRemoto(tipo);
    if (!src) {
      return;
    }
    void this.lang.loadDesTranslations().then(() => {
      this.impiantoRemotoOpzioni = this.impiantoRemotoOpzioni.map((g: any) => ({
        ...g,
        label: this.lang.des(src, g.label),
        items: this.lang.des(src, g.items || []),
      }));
      this.impiantoRemotoMandatory = this.impiantoRemotoMandatory.map((g: any) => ({
        ...g,
        label: this.lang.des(src, g.label),
        items: this.lang.des(src, g.items || []),
      }));
      this.impiantoRemotoOpzioni = [...this.impiantoRemotoOpzioni];
      this.impiantoRemotoMandatory = [...this.impiantoRemotoMandatory];
    });
  }

  /** Tabella glossario per opzioni porta configurata */
  srcTableOpzioniPorta(tipologiaPorta: string): string {
    switch (tipologiaPorta) {
      case 'SCORREVOLI':
        return 'porte_scorrevoli_configurate_opzioni';
      case 'INDUSTRIALI BATTENTE':
      case 'INDUSTRIALI SCORREVOLI':
        return 'porte_industriali_configurate_opzioni';
      case 'STANDARD':
      default:
        return 'porte_battente_configurate_opzioni';
    }
  }

  changeConfigurataPorta(event:any,cella:any,porta:any){


    this.portaConfigurataOpzioni=[];
    let param={
      tipo:porta.tipologiaPorta,
      finitura:porta.tipoPorta,
      id:porta.modelloPorta,
      portaAltezza:porta.altezza,
      cellaAltezza:cella.altezza,
      cellaSpessore:cella.spessore,
      cellaVespaio:cella.vespaio,
      cellaPavimenti:cella.pavimenti,
    };
    this.apiService.post('app/opportunity_getconfigurataopzioni',param).subscribe(data2 => {
      let opt= data2.Result.opzioni.filter((x:any)=>
       x.tipo=='O'
      );
      let optMandatory= data2.Result.opzioni.filter((x:any)=>
        x.tipo=='M'
      );
      
      if(porta.versoAperturaPorta==2){ //sinistra
        opt=opt.filter((x:any)=> x.desc.indexOf(' DX')<0);
      } else {
        opt=opt.filter((x:any)=> x.desc.indexOf(' SX')<0);
      }
     // if(!porta.conoblo){
     //   opt=opt.filter((x:any)=>x.desc.indexOf('OBLO')<0);
     // }
      opt=opt.filter((x:any)=>x.spessore=='' || x.spessore==(cella? cella.spessore:porta.spessore)+'');
      this.portaConfigurataOpzioni=[];

      data2.Result.gruppi.forEach((x:any)=>{
        let it:any=[];
        opt.filter((z:any)=>z.sezione==x).forEach((k:any)=>{
          it.push({
            value:k.codComp,
            label:k.desc
          })
        });

        if(it.length>0){
          this.portaConfigurataOpzioni.push(
            {
                  label: x,
                  value: x,
                  items: it
          });
        }
      
      });
      this.portaConfigurataMandatory=[];
      porta.configurataMandatory=[];
      data2.Result.gruppi.forEach((x:any)=>{
        let it:any=[];
       
        optMandatory.filter((z:any)=>z.sezione==x).forEach((k:any)=>{
          it.push({
            value:k.codComp,
            label:k.desc
          })
        });
        if(it.length>0){
          porta.configurataMandatory.push(it[0].value);
          this.portaConfigurataMandatory.push(
            {
                label: x,
                value: x,
                items: it
            });
        }
       
      });
      const srcOpzioni = this.srcTableOpzioniPorta(porta.tipologiaPorta);
      void this.lang.loadDesTranslations().then(() => {
        this.portaConfigurataOpzioni = this.portaConfigurataOpzioni.map((g: any) => ({
          ...g,
          label: this.lang.des(srcOpzioni, g.label),
          items: this.lang.des(srcOpzioni, g.items || []),
        }));
        this.portaConfigurataMandatory = this.portaConfigurataMandatory.map((g: any) => ({
          ...g,
          label: this.lang.des(srcOpzioni, g.label),
          items: this.lang.des(srcOpzioni, g.items || []),
        }));
        this.portaConfigurataOpzioni=[...this.portaConfigurataOpzioni];
        this.portaConfigurataMandatory=[...this.portaConfigurataMandatory];
      });
      
    });
      

  }
 
  setModelloPorta(cella:any,porta:any){

  
    
    if((typeof porta.modelloPorta=='number' && porta.modelloPorta>0)
       || (typeof porta.modelloPorta!='number' && porta.modelloPorta!='')){

      let misuraPannello=0;  
      porta.modelliPortaOptions.forEach((p:any)=>{
        if(p.value==porta.modelloPorta){
          misuraPannello=p.lgz_pann;
          porta.luceNetta=p.luceNetta;
          porta.altezza=p.alt_pann;
          /*
          if(porta.larghporta>misuraPannello){
            porta.distSnPorta+=Math.round((porta.larghporta-misuraPannello)/(20*2))*20; 
          } else{
            porta.distSnPorta-=Math.round((misuraPannello-porta.larghporta)/(20*2))*20; 
            if(porta.distSnPorta<0){
              porta.distSnPorta=0;
            }
          }
          */
          porta.larghporta=misuraPannello;      
        }

      });
      if(typeof porta.modelloPorta=='number'){
        let param={
          tipo:porta.tipologiaPorta,
          finitura:porta.tipoPorta,
          id:porta.modelloPorta,
          portaAltezza:porta.altezza,
          cellaAltezza:cella.altezza,
          cellaSpessore:cella.spessore,
          cellaVespaio:cella.vespaio,
          cellaPavimenti:cella.pavimenti,
        };
        this.apiService.post('app/opportunity_getconfigurataopzioni',param).subscribe(data2 => {
          porta.porte=data2.Result.porte;
          porta.opzioni=data2.Result.opzioni;
    
               
        });
      } 
    }
    
    
    if(porta.tipoPorta=='INDUSTRIALI SCORREVOLI'){
      porta.configurata=true;
    }
     if(porta.tipoPorta=='INDUSTRIALI BATTENTE'){
      porta.configurata=true;
    }
    if(cella){
       this.changeConfigurataPorta(null,cella,porta);
    }
    
                             
  }

  
 recalcDistPortaOptions(c:any,p:any){
  
  
  this.distSnPortaOptions=[];


  let cd=0;
  if(p.lato_porta=='lato_fronte' || p.lato_porta=='lato_retro'){
    while(cd+p.larghporta<=c.ingombroX){
      this.distSnPortaOptions.push(cd);
      cd+=20;
    }
  } else {
    while(cd+p.larghporta<=c.ingombroY){
      this.distSnPortaOptions.push(cd);
      cd+=20;
    }
  }
  
 }
 
                                                                       
  changeModelloPorta(event:any,cellaDati:any,porta:any,divisorio:string='',distPorta:any=null){
   // attende per quando la posizione della porta va impostata: sta finendo il drag 
   setTimeout(() => { 
    let dxOrSxString='';
    let treVie:boolean=false;
    switch (porta.versoAperturaPorta) {
        case 1:
            dxOrSxString = "DX";
            break;
        case 2:
            dxOrSxString = "SX";
            break;
        default:
            dxOrSxString = "";
            break;
    }


    
    // la porta è a tre vie se è collegata con divisorio e solo nel pezzo di lato con il divisorio
  if(!porta.scollegata){
      cellaDati.celleCollegate.filter((x:any)=>x.attivo 
      && x.latocollegato==porta.lato_porta
      && x.tipoCollegamento=='collegateDivisorio').forEach((ccol:any)=>{
        if((porta.distSnPorta>=ccol.distLato && porta.distSnPorta<=ccol.distLato+ccol.larghezza)||(ccol.larghezza==0)){
           treVie=true;
        }
      });
    } 

    let param:any={
      sql:this.listaporteOK(cellaDati,porta,porta.scollegata? false:cellaDati.electrolux),
      tipoPorta:porta.tipo1Porta,
      spe_pann:porta.scollegata? porta.spessore:cellaDati.spessore,
      electrolux:porta.scollegata? false:cellaDati.electrolux
    }
    if(dxOrSxString!=''){
      param.TipoApertura=dxOrSxString;
    }
    if(porta.scollegata? false:cellaDati.isMiniCella){
      param.isMiniCella=true;
      param.minicella={  
            altezza:cellaDati.altezza,
            lunghezza:cellaDati.ingombroX/10,
            larghezza:cellaDati.ingombroY/10,
            customClient:cellaDati.customClient,
            spessore:cellaDati.spessore,
            minicellaImpianto:cellaDati.minicellaImpianto,
            pavimento:cellaDati.pavimenti
      };
    }
    this.apiService.post('app/opportunity_getporte',{param:param}).subscribe(data2 => {
      porta.modelliPortaOptions=[];
      let portaLabel='';
      porta.modelliPortaOptions.forEach((x:any)=>{
        if(x.value==porta.value){
          portaLabel=porta.label;
        }
      });
      if(porta.scollegata? false:cellaDati.isMiniCella){
        data2.forEach((pp:any)=>{
          if(porta.scollegata){
             porta.altezza=pp.Altezza/10;
          } else {
             cellaDati.altezza=pp.Altezza/10;
          }
         
          porta.modelliPortaOptions.push({
            value:pp.Codice,
            label:pp.Descrizione,
            alt_pann:pp.alt_pann,
            lgz_pann:pp.lgz_pann,
            luceNetta:pp.luceNetta
          });

        });
        // cerca se esiste il modello porta gia selezionato
        let pp:any=null;
        if(porta.modelliPortaOptions.filter((x:any)=>x.value==porta.modelloPorta).length>0){
          pp=porta.modelliPortaOptions.filter((x:any)=>x.value==porta.modelloPorta)[0];
        } else {
          // cerca se esiste con apertura opposta
           if(porta.modelliPortaOptions.filter((x:any)=>x.label==portaLabel.replace('DX','SX')).length>0){
            pp=porta.modelliPortaOptions.filter((x:any)=>x.label==portaLabel.replace('DX','SX'))[0];
           } else {
              if(porta.modelliPortaOptions.filter((x:any)=>x.label==portaLabel.replace('SX','DX')).length>0){
                pp=porta.modelliPortaOptions.filter((x:any)=>x.label==portaLabel.replace('SX','DX'))[0];
              } else {
                pp=porta.modelliPortaOptions.filter((x:any)=>x.label.indexOf('DX')>=0)[0];
                if(porta.versoAperturaPorta==2){
                  pp=porta.modelliPortaOptions.filter((x:any)=>x.label.indexOf('SX')>=0)[0];
                }
              }
           }
        }
        if(pp){
          porta.modelloPorta=pp.value;
          let misuraPannello=pp.lgz_pann;
          porta.luceNetta=pp.luceNetta;
          if(porta.scollegata){
              porta.distSnPorta=0; 
          } else {
              porta.distSnPorta=Math.round((cellaDati.ingombroX-misuraPannello)/(20*2))*20; 
          }
        }
      } else {
        if(porta.scollegata){
          if(!porta.montataSuDivisorio){
            if(porta.tipo1Porta=='DAGARD'){
              porta.modelliPortaOptions=data2.filter((x:any)=> x.label.indexOf('P/CL')<0);
            } else{
              porta.modelliPortaOptions=data2.filter((x:any)=> x.label.indexOf('3V')<0);
            }
          } else {
            if(porta.tipo1Porta=='DAGARD'){
              porta.modelliPortaOptions=data2.filter((x:any)=> x.label.indexOf('P/CL')>=0);
             // porta.modelloPorta=pp.value;
            } else{
              porta.modelliPortaOptions=data2.filter((x:any)=> x.label.indexOf('3V')>=0);
            }
          
          }
        } else {
          if(divisorio=='' && !treVie){
            
         
            if(porta.tipo1Porta=='DAGARD'){
              porta.modelliPortaOptions=data2.filter((x:any)=> x.label.indexOf('P/CL')<0);
            } else{
              if(porta.tipo1Porta=='SPORTELLI'){
                porta.modelliPortaOptions=data2.filter((x:any)=> x.cod_comp!='' &&  x.label.indexOf('3V')<0);
              } else {
                 porta.modelliPortaOptions=data2.filter((x:any)=> x.label.indexOf('3V')<0);
              }
            }
          } else {
            if(porta.tipo1Porta=='DAGARD'){
              porta.modelliPortaOptions=data2.filter((x:any)=> x.label.indexOf('P/CL')>=0);
            } else{
              if(porta.tipo1Porta=='SPORTELLI'){
                porta.modelliPortaOptions=data2.filter((x:any)=> x.cod_comp!='' &&  x.label.indexOf('3V')>=0);
              } else {
                 porta.modelliPortaOptions=data2.filter((x:any)=> x.label.indexOf('3V')>=0);
              }
            }
          
          }
          if(!porta.scollegata && porta.modelliPortaOptions.length>0){
            // cerca se esiste il modello porta gia selezionato
            let pp:any=null;
            if(porta.modelliPortaOptions.filter((x:any)=>x.value==porta.modelloPorta).length>0){
              pp=porta.modelliPortaOptions.filter((x:any)=>x.value==porta.modelloPorta)[0];
            } else {
              // cerca se esiste con apertura opposta
              if(porta.modelliPortaOptions.filter((x:any)=>x.label==portaLabel.replace('DX','SX')).length>0){
                pp=porta.modelliPortaOptions.filter((x:any)=>x.label==portaLabel.replace('DX','SX'))[0];
              } else {
                  if(porta.modelliPortaOptions.filter((x:any)=>x.label==portaLabel.replace('SX','DX')).length>0){
                    pp=porta.modelliPortaOptions.filter((x:any)=>x.label==portaLabel.replace('SX','DX'))[0];
                  } else {
                    pp=porta.modelliPortaOptions.filter((x:any)=>x.label.indexOf('DX')>=0)[0];
                    if(porta.versoAperturaPorta==2){
                      pp=porta.modelliPortaOptions.filter((x:any)=>x.label.indexOf('SX')>=0)[0];
                    }
                  }
              }
            }
            if(pp){
              porta.modelloPorta=pp.value;
              let misuraPannello=pp.lgz_pann;
              porta.luceNetta=pp.luceNetta;
              if(distPorta){
                  porta.distSnPorta=distPorta;
              }
              porta.larghporta=misuraPannello;
              this.recalcDistPortaOptions(cellaDati,porta);
            }

          }
        }
        

      }
      // FILTRO PORTE ALTEZZA
      if((porta.tipo1Porta=='DAGARD')){ // MISTRAL
        let filtro='(2400';
        switch (porta.scollegata? porta.altezza:cellaDati.altezza){
          case 200:
            filtro='(2000';
            break;
          case 220:
          case 260:
            filtro='(2200';
            break;
          case 240:
            filtro='(2400';
            break;
        }
        porta.modelliPortaOptions=porta.modelliPortaOptions.filter((x:any)=> {
          return x.label.indexOf(filtro)>0;
        });
      } else {
        // SOVRAPORTA DEVE ESSERE <>20 SOLO PER PORTE COMMERCILI 
        if(porta.tipologiaPorta!="INDUSTRIALI BATTENTE" && porta.tipologiaPorta!="INDUSTRIALI SCORREVOLI"){
          let altezza=(porta.scollegata? porta.altezza:cellaDati.altezza)-20;
          porta.modelliPortaOptions=porta.modelliPortaOptions.filter((x:any)=> {
            let t=parseInt(x.label.split('/')[1].split(' ')[0]);
            return t!=altezza;
          });
        }
      }
      if(this.userCellePreConf() && !porta.scollegata){
        if(cellaDati.ingombroX==140){
           porta.modelliPortaOptions=porta.modelliPortaOptions.filter((p:any)=> {
              return p.label.indexOf('X800')>0 && p.label.indexOf('X1000)')>0 ;
            });
        }
        // filtro altezze
        // filtro 140
        porta.modelliPortaOptions.forEach((p:any)=>{
          if(p.label.indexOf('X800)')>0){
            porta.modelloPorta=p.value;
          }
        });
       

      }
      // Traduce label per UI (filtri tecnici già eseguiti su IT)
      void this.lang.loadDesTranslations().then(() => {
        porta.modelliPortaOptions = this.lang.des('t_porte', porta.modelliPortaOptions);
        this.setModelloPorta(cellaDati,porta);
      });
    
    });
   
    
   }, 500);
  }

    formCellaIsValid(configurazioneCelle:any){
    let msg:string[]=[];
    
    if(configurazioneCelle && configurazioneCelle.elencoImpiantiRemoti){
       configurazioneCelle.elencoImpiantiRemoti.forEach((c:any,ind:number)=>{
          if(!c.art_comp || c.art_comp==''){
              msg.push(this.lang.el('Configurazione impianto non presente')); 
          }
       });
    }

    if(configurazioneCelle && configurazioneCelle.elencoDropin){
       configurazioneCelle.elencoDropin.forEach((c:any,ind:number)=>{
          if(c.descDropIn==''){
              msg.push(this.lang.el('Configurazione impianto Dropin non presente')); 
          }
       });
    }
    if(configurazioneCelle && configurazioneCelle.elencoFreeBlocks){
       configurazioneCelle.elencoFreeBlocks.forEach((c:any,ind:number)=>{
          if(c.descFreeBlock==''){
              msg.push(this.lang.el('Configurazione impianto FreeBlock non presente')); 
          }
       });
    }
    if(configurazioneCelle && configurazioneCelle.elencoCelle){
    
      configurazioneCelle.elencoCelle.forEach((c:any,ind:number)=>{
        if(c.ingombroX/20!=Math.trunc(c.ingombroX/20)){
              msg.push(this.lang.el('Misura cella errata: imgombroX')); 
        }
        if(c.ingombroY/20!=Math.trunc(c.ingombroY/20)){
              msg.push(this.lang.el('Misura cella errata: imgombroY')); 
        }
        if(c.altezza/20!=Math.trunc(c.altezza/20)){
              msg.push(this.lang.el('ALtezza cella errata')); 
        }
        c.elencoPorte.forEach((p:any)=>{
          if(p.modelloPorta==''){
             msg.push(this.lang.el('Configurazione porta errata: selezionare un modello')); 
          }
        });
        if(c.divisorioCella=='conPorta' && c.portaDivisorio.modelloPorta==''){
           msg.push(this.lang.el('Configurazione porta divisorio errata: selezionare un modello')); 
        }
        c.celleCollegate.forEach((x:any)=>{
          if(x.tipoCollegamento=='combinate'){
            let c2=configurazioneCelle.elencoCelle.filter((z:any)=>z.id==x.cellaCollegataId)[0];
            if(c.spessore==6 && c2.spessore==6){
              msg.push(this.lang.el('Configurazione set accoppiamento con profilo non disponibile')); 
            } else {
              if(c.spessore==10 && c2.spessore==10 && c.pavimenti && c2.pavimenti){
                msg.push(this.lang.el('Configurazione set accoppiamento non disponibile')); 
              }
              if(c.spessore==6 && c2.spessore==10 && c.pavimenti){
                msg.push(this.lang.el('Configurazione set accoppiamento non disponibile')); 
              }
              if(c.spessore==10 && c2.spessore==6 && c2.pavimenti){
                msg.push(this.lang.el('Configurazione set accoppiamento non disponibile')); 
              }
            }
          }
        });
      //  if(c.tipoCella=='' && !c.isMiniCella){
      //    msg.push(this.lang.el('Configurazione cella errata: selezionare il tipo della cella')); 
      //  }
      });


    }
 
    return msg;

  }
  

  public  listaporteOK(cellaDati:any,porta:any,electrolux:any): string {
   

    let sqlQuery: string = '';
  
    let libraryCode: string;
    let finish: string;
    let floorString: string;
    let dxOrSxString: string;
    let dividerString: string;
    let doorTypeString: string;
    let aggregatedDoorCode: number=0;
    let aggregatedDoorCode1: number=0;

    
    let doorCode='';
    let doorType=porta.tipo1Porta;
    let heightOfCell=cellaDati.altezza;
    let thickness=cellaDati.spessore;
    let family='';
    let aggregatedDoorCodeFinal='';
    let doorCategory=0;
    // standard 
    if(porta.scollegata){
        heightOfCell=porta.altezza;
        thickness=porta.spessore;
    }

      
    if(porta.tipologiaPorta=='STANDARD' && porta.tipoPorta =='STANDARD'){
      finish = "ST";
      aggregatedDoorCode = 30;
      if(electrolux==1){
        aggregatedDoorCode = 56;
      }
      if(this.globalService.getUser().organization=='MISA'){
         aggregatedDoorCode1 = 56;
      }
     
    }


    if((porta.tipologiaPorta=='STANDARD'   )  && porta.tipoPorta =='INOX_INT'){
      finish = "IXIN";
      aggregatedDoorCode = 31;
    }
    if((porta.tipologiaPorta=='STANDARD'   ) && porta.tipoPorta =='INOX_EST'){
      finish = "IXES";
      aggregatedDoorCode = 32;
    }
    if((porta.tipologiaPorta=='STANDARD'  ) && porta.tipoPorta =='INOX_IE'){
      finish = "IXIE";
      aggregatedDoorCode = 33;
    }

    if((porta.tipologiaPorta=='SCORREVOLI'   ) && porta.tipoPorta =='STANDARD'){
      finish = "IXIN";
 //     family="t_ar1.family = 'misa'";
      aggregatedDoorCode = 39;
    }
    if((porta.tipologiaPorta=='SCORREVOLI'   ) && porta.tipoPorta =='INOX_INT'){
      finish = "IXIN";
   //   family="t_ar1.family = 'misa'";
      aggregatedDoorCode = 34;
    }
    if((porta.tipologiaPorta=='SCORREVOLI'   ) && porta.tipoPorta =='INOX_EST'){
      finish = "IXES";
  //    family="t_ar1.family = 'misa'";
      aggregatedDoorCode = 37;
    }
    if((porta.tipologiaPorta=='SCORREVOLI'  ) && porta.tipoPorta =='INOX_IE' ){
      finish = "IXIE";
  //    family="t_ar1.family = 'misa'";
      aggregatedDoorCode = 38;
    }


    if(porta.tipologiaPorta=='INDUSTRIALI BATTENTE'  ){
      aggregatedDoorCode = 39;
  //    family="t_ar1.family = 'misa'";
      if(electrolux==1){
        aggregatedDoorCode = 57;
      }
       if(this.globalService.getUser().organization=='MISA'){
         aggregatedDoorCode1 = 57;
      }
     
    }

    if(porta.tipologiaPorta=='INDUSTRIALI SCORREVOLI'  ){
      aggregatedDoorCode = 39;
      aggregatedDoorCodeFinal = 'S';   
  //    family="t_ar1.family = 'misa'";
    }

    if(porta.tipologiaPorta=='SCORREVOLI'){
         doorCategory=2;
    }
    
    if(porta.tipologiaPorta=='INDUSTRIALI SCORREVOLI'){
         doorCategory=4;
    }

    if(porta.tipologiaPorta=='INDUSTRIALI BATTENTE'){
        doorCategory=3;
        if(electrolux==1){
          aggregatedDoorCode = 57;
        }
    }

    switch (doorType) {
        case "DAGARD":
            libraryCode = "DAGARD"; // & finish & "IS"
            break;
        case "ELX":
            libraryCode = "ELX"; // & finish & "IS"
            doorCode = "56";
            break;
        default:
            libraryCode = "";
            break;
    }

    switch (porta.versoAperturaPorta) {
        case 1:
            dxOrSxString = " and t_porte.TipoApertura like 'DX'";
            break;
        case 2:
            dxOrSxString = " and t_porte.TipoApertura like 'SX'";
            break;
        default:
            dxOrSxString = "";
            break;
    }
    if(cellaDati.pavimenti){
        floorString = " and (t_po1.pavimento like 'SI' OR t_po1.pavimento='' OR t_po1.pavimento='SINO') ";
    } else {
        floorString = " and (t_po1.pavimento like 'NO' OR t_po1.pavimento='' OR t_po1.pavimento='SINO') ";
    }
    
    
    switch (porta.divisorioPorta) {
        case 1:
            dividerString = " and t_po1.divisorio like 'SI'";
            break;
        case 0:
            dividerString = " and t_po1.divisorio like 'NO'";
            break;
        default:
            dividerString = "";
            break;
    }

/*
doorCategory
0 == porte standard batt comm
2 == scorrevoli comm
3 == ind a battente
4 == ind scorrevoli

*/
   doorTypeString= "";
   if(porta.tipologiaPorta=='INDUSTRIALI BATTENTE'  ){
    doorTypeString = " and t_ar1.family='misa' and t_po1.con_accessori = 3 " ; // & 
   }
   if(porta.tipologiaPorta=='INDUSTRIALI SCORREVOLI'  ){
    doorTypeString = " and t_ar1.family='misa' and t_po1.con_accessori = 4 " ; // & 
   }
   if(porta.tipologiaPorta=='STANDARD' && porta.tipoPorta =='STANDARD' ){
    doorTypeString = " and t_po1.con_accessori = 0 "; // & 
   }
   if(porta.tipologiaPorta=='SCORREVOLI' && porta.tipoPorta =='STANDARD' ){
    doorTypeString = " and t_po1.con_accessori = 2 "; // & 
   }

   
        
    sqlQuery =  " t_ar1.cod_libr like '" + libraryCode +  "%'";

    
    if(porta.tipologiaPorta=='INDUSTRIALI SCORREVOLI' || porta.tipologiaPorta=='INDUSTRIALI BATTENTE'){
      if(thickness==6){
         sqlQuery = "NOT ( t_po1.ide_port LIKE '% IN %'  OR t_po1.ide_port LIKE '% INS %') AND ";
      }
      if(thickness==10){
         sqlQuery ="";//  " (t_po1.spe_tamp = '" + thickness + "' or t_po1.spe_tamp = '6') ";
      }
      if(thickness==13){
        sqlQuery =  " t_po1.spe_pann = '10' and ";
      } 

      if(aggregatedDoorCode1!=0){
        sqlQuery = sqlQuery + "  (t_ar1.cod_comp like '" + aggregatedDoorCode +  "%"+aggregatedDoorCodeFinal+"' OR t_ar1.cod_comp like '" + aggregatedDoorCode1 +  "%"+aggregatedDoorCodeFinal+"') ";

      } else {
        sqlQuery = sqlQuery + "  t_ar1.cod_comp like '" + aggregatedDoorCode +  "%"+aggregatedDoorCodeFinal+"'";
      }
    
    } else {
      sqlQuery = " t_po1.spe_pann = '" + ("00" + thickness).slice(-2) + "'";
      if(aggregatedDoorCode1!=0){
        sqlQuery = sqlQuery + " and (t_ar1.cod_comp like '" + aggregatedDoorCode +  "%"+aggregatedDoorCodeFinal+"' OR t_ar1.cod_comp like '" + aggregatedDoorCode1 +  "%"+aggregatedDoorCodeFinal+"') ";

      } else {
         sqlQuery = sqlQuery + " and t_ar1.cod_comp like '" + aggregatedDoorCode +  "%"+aggregatedDoorCodeFinal+"'";
      }
    
    }



 
    
    

    sqlQuery = sqlQuery + doorTypeString;
    sqlQuery = sqlQuery + " and t_po1.alt_pann <= " + heightOfCell;
    sqlQuery = sqlQuery + dxOrSxString;
    sqlQuery = sqlQuery + floorString;
    sqlQuery = sqlQuery + dividerString;

    if (libraryCode !== "") {
        sqlQuery = sqlQuery + " and t_ar1.cod_libr like '" + libraryCode +  "%'";
    }

    if(family!=''){
      sqlQuery = sqlQuery + " and " + family ;
    }
   return sqlQuery;

  }

  changePavimentiPorta(cellaDati:any,lang:string){

    if(cellaDati.pavimenti){
      this.pavimentoPortaOptions=[
        {value:1,label:this.lang.el('Si')}
      ];
      cellaDati.elencoPorte.forEach((p:any)=>{
        p.pavimentoPorta=1;
      });
    } else {
      this.pavimentoPortaOptions=[
        {value:0,label:this.lang.el('NO')},
      ];
      cellaDati.elencoPorte.forEach((p:any)=>{
        p.pavimentoPorta=0;
      });
    }
   
    this.changeDescTecnica(cellaDati,lang);
    
  }

  
  changeDescTecnica(cella:any,lang:string){
      let desc='';
      let pavimento='';
      let misura='';
      let finitura='';
      
      if(lang=='it-IT'){
        
         if(cella.finitura && cella.finitura=='STANDARD'){
          finitura='lamiera zincata plastificata bianca'; 
        } else {
          finitura='in lamiera inox'; 
        }
        if(!cella.pavimenti){
          pavimento='';
        } else {
          pavimento='con pavimento '+(cella.finituraPavimento=='carrabile P400' ? '': cella.finituraPavimento);
        }
      
        
         if(cella.spessore){
          misura=cella.spessore*10+'';
        }
        desc='Cella frigorifera con '+pavimento+', composta da pannelli modulari di '+misura+' mm di spessore. Realizzata '+finitura+', atossica, con uno spessore di 0,5 mm. Isolata con schiuma di poliuretano iniettata, densità 40 kg/m³. Assemblaggio tramite sistema di fissaggio rapido';
      }
      if(lang=='en-EN'){
        if(cella.finitura && cella.finitura=='STANDARD'){
          finitura='white plastic-coated galvanized'; 
        } else {
          finitura='steel sheet'; 
        }
        if(!cella.pavimenti){
          pavimento='';
        } else {
          pavimento='with '+cella.finituraPavimento+' floor';
        }
      
        if(cella.spessore){
          misura=cella.spessore*10+'';
        }
        
        desc='Cold room '+pavimento+', made of '+misura+'  mm thick modular panels. Constructed from '+finitura+', non-toxic, with a thickness of 0.5 mm. Insulated with injected polyurethane foam, density 40 kg/m³. Assembled using a quick-fix system.';
      }
      if(lang=='fr-FR'){
        if(cella.finitura && cella.finitura=='STANDARD'){
          finitura='galvanisée plastifiée blanche'; 
        } else {
          finitura='acier inoxidable'; 
        }
        
        if(!cella.pavimenti){
          pavimento='';
        } else {
           pavimento='avec sol '+cella.finituraPavimento;
        }
       
        if(cella.spessore){
          misura=cella.spessore*10+'';
        }
        desc='Chambre froide '+pavimento+' composée de panneaux modulaires de '+misura+' mm d\'épaisseur. Réalisée en tôle '+finitura+', non toxique, d\'épaisseur 5/10. Isolation en mousse de polyuréthane injectée, densité 40 kg/m³. Assemblage par système de fixation rapide. ';
      }
    
    
      cella.descrizioneTecnica=desc;
   
  }

  
  
  onChangeSpessorePortaScollegata(porta:any){
 
    if(porta.spessore==13){
      porta.pavimenti=true;
      this.altezzaOptions=this.altezzaOptionsSp13;
      if(porta.altezza==220 || porta.altezza==260 || porta.altezza==300 ){
        porta.altezza=240;
      }
    } else {
         this.altezzaOptions=this.altezzaOptionsAll;
    }
    if(porta.spessore==10){
      porta.pavimenti=true;
    }

    this.changeModelloPorta(null,this.initCella([],'',false),porta);
    
  }

  
  onChangeSpessore(cellaDati:any,lang:string){
 
    if(cellaDati.spessore==13){
      cellaDati.pavimenti=true;
      this.altezzaOptions=this.altezzaOptionsSp13;
      if(cellaDati.altezza==220 || cellaDati.altezza==260 || cellaDati.altezza==300 ){
        cellaDati.altezza=240;
      }
    } else {
         this.altezzaOptions=this.altezzaOptionsAll;
    }
    if(cellaDati.spessore){
        this.tipoCellaOptions=[];
        this.apiService.post('app/opportunity_gettipocella',{spessore:cellaDati.spessore}).subscribe(data2 => {
            this.tipoCellaOptions=data2;
            this.tipoCellaOptions.forEach((t:any)=>{
              t.label=this.lang.el(t.label);
            });
            this.changeDescTecnica(cellaDati,lang);
        });

    }

    if(!this.operazioneInCorso){
      if(!this.userCellePreConf() && (cellaDati.spessore==10 ||cellaDati.spessore==13) ){
              cellaDati.valvolaCompensazione=true;
      }
      if(!this.userCellePreConf() && cellaDati.spessore==6 ) {
          cellaDati.valvolaCompensazione=false;
      }
    }
   

    if(this.userCellePreConf() &&  cellaDati.spessore==10){
      cellaDati.pavimenti=true;
    }
    
    this.onChangeAltezza(cellaDati,lang);
    if(this.userCellePreConf() && cellaDati.spessore==10){
      cellaDati.valvolaCompensazione=true;
      cellaDati.vespaio=true;
    }
    
  }

  onChangeAltezza(cellaDati:any,lang:string){
    if(cellaDati.portaDivisorio && cellaDati.portaDivisorio.modelloPorta!=''){

      this.changeModelloPorta(null,cellaDati,cellaDati.portaDivisorio,'divisorio');
    }
    if( cellaDati.elencoPorte){
      cellaDati.elencoPorte.forEach((p:any)=>{

        this.changeModelloPorta(null,cellaDati,p);
      });
    }
   
  }


  onChangeFinitura(cellaDati:any,lang:string){
  this.changeDescTecnica(cellaDati,lang);
  }

  
  
  insertPannelliLato(lungh:number,lato:string,obj:any,altezza:number,fittizio=false,treVie=false){
    if(lungh==0){
      return;
    }

    // Compensatorio 27/31: a seguire sempre fittizio 9/13 (sp+3) così il tratto somma 40.
    if(lungh==27 || lungh==31){
      this.insertPannello(obj,lato,lungh,altezza,fittizio,treVie);
      const sp = this.cellaDati?.spessore;
      if (sp != null && sp !== 13) {
        const follow = sp + 3; // 9 (sp6) o 13 (sp10)
        if (follow > 0) {
          this.insertPannello(obj, lato, follow, altezza, true, treVie);
        }
      }
      return;
    }
    if(lungh<20){
      this.insertPannello(obj,lato,lungh,altezza,fittizio,treVie);
      return;
    }
    let lunghezzeModuli=this.riempiLato(lungh);
    for(let j:number=0;j<lunghezzeModuli.d120;j++){
      this.insertPannello(obj,lato,120,altezza,fittizio,treVie);
    }
    for(let j:number=0;j<lunghezzeModuli.d100;j++){
      this.insertPannello(obj,lato,100,altezza,fittizio,treVie);
    }
    for(let j:number=0;j<lunghezzeModuli.d80;j++){
    this.insertPannello(obj,lato,80,altezza,fittizio,treVie);
    }
    for(let j:number=0;j<lunghezzeModuli.d60;j++){
      this.insertPannello(obj,lato,60,altezza,fittizio,treVie);
    }
    for(let j:number=0;j<lunghezzeModuli.d40;j++){
      this.insertPannello(obj,lato,40,altezza,fittizio,treVie);
    }
    for(let j:number=0;j<lunghezzeModuli.d20;j++){
      this.insertPannello(obj,lato,20,altezza,fittizio,treVie);
    }
     
  }

  getObjVespaio(){
    this.objVespaio={
      x:0,
      y:-1*this.cellaDati.altezzaOrizz-this.cellaDati.spessore,
      z:-this.cellaDati.spessore,
      step:this.cellaDati.passo,
      pannelli:[]
    };
    
    let curr=0;
    this.objVespaio.pannelli.push({
      w:this.cellaDati.spessore,
       d:this.cellaDati.ingombroY,
      h:this.cellaDati.altezzaOrizz,
      side:'vespaio',
      step:0,
    });

    while(curr<this.cellaDati.ingombroX-this.cellaDati.spessore){
      
      if(curr==0){
        this.objVespaio.pannelli.push({
          w:this.cellaDati.spessore,
          d:this.cellaDati.ingombroY,
          h:this.cellaDati.altezzaOrizz,
          side:'vespaio',
          step:this.cellaDati.spessore,
        });
        curr+=this.cellaDati.spessore;
      } else {
       
        curr+=this.cellaDati.passo;
        let step=this.cellaDati.passo;
        if(curr>=this.cellaDati.ingombroX-this.cellaDati.spessore){
          step=this.cellaDati.ingombroX-curr+this.cellaDati.passo;
        } 
        
         this.objVespaio.pannelli.push({
          w:this.cellaDati.spessore,
          d:this.cellaDati.ingombroY,
          h:this.cellaDati.altezzaOrizz,
          side:'vespaio',
          step:step,
        });
      }
     
    }
   
    this.objVespaio.pannelli.push({
        w:this.cellaDati.spessore,
        d:this.cellaDati.ingombroY,
        h:this.cellaDati.altezzaOrizz,
        side:'vespaio',
        step:this.cellaDati.spessore,
      });

  }

  esistePortaLatoNonCombinato(lato:string,config:any){
    let esiste=false;
    this.cellaDati.celleCollegate.forEach((x:any,o:number)=>{
        if(x.attivo && x.latocollegato==lato && x.tipoCollegamento!='combinate'){
          config.elencoCelle.forEach((s:any,sind:number)=>{
          if(s.id==x.cellaCollegataId){
            switch(lato){
              case 'lato_ds':
                esiste=s.elencoPorte.filter((z:any)=>!z.portaDivisorio && z.lato_porta=='lato_sn').length>0;
                break;
              case 'lato_sn':
                esiste=s.elencoPorte.filter((z:any)=>!z.portaDivisorio && z.lato_porta=='lato_ds').length>0;
                break;
              case 'lato_fronte':
                esiste=s.elencoPorte.filter((z:any)=>!z.portaDivisorio && z.lato_porta=='lato_retro').length>0;
                break;
              case 'lato_retro':
                esiste=s.elencoPorte.filter((z:any)=>!x.portaDivisorio && z.lato_porta=='lato_fronte').length>0;
                break;
            }
          }
        });
      }
    });
   
    return esiste;
  }

  getElementiLato(lato:string,config:any,cellaDati:any,divisorio:any=null,celleUnite:any=null){
     /*
    elementiLato: comprende freblock porte e celle unite
      distanzaSn: distanza da sinistra o dal basso 
      larghezza= larghezza dell'elemento
      porta: oggetto porta se è una porta

    */
    let arr:any[]=[];
    let lungh=0;
    if(lato=='lato_fronte' || lato=='lato_retro'){
      lungh=cellaDati.ingombroX;
    } else {
      lungh=cellaDati.ingombroY;
    }
    if(divisorio){
      cellaDati.elencoPorte.filter((x:any)=>x.portaDivisorio && x.divisorioCollegatoId==divisorio.id).forEach((p:any)=>{
       
        if(p.distSnPorta+p.larghporta>lungh){
          arr.push({
            distanzaSn:p.distSnPorta-(p.distSnPorta+p.larghporta-lungh),
            larghezza:p.larghporta,
            porta:p
          });
        } else {
          arr.push({
            distanzaSn:p.distSnPorta,
            larghezza:p.larghporta,
            porta:p
          });
        }
      });
    } else {
      if(celleUnite){
        let distanza=0;
        celleUnite.forEach((cu:any)=>{
          let cce=config.elencoCelle.filter((x:any)=>x.id==cu.id)[0];
          cce.elencoPorte.filter((x:any)=>!x.portaDivisorio && x.lato_porta==lato).forEach((p:any)=>{
            let lungh=0;
            if(lato=='lato_fronte' || lato=='lato_retro'){
              lungh=cce.ingombroX;
            } else {
              lungh=cce.ingombroY;
            }
            
            if(p.distSnPorta+p.larghporta>lungh){
              arr.push({
                distanzaSn:distanza+p.distSnPorta-(p.distSnPorta+p.larghporta-lungh),
                larghezza:p.larghporta,
                porta:p
              });
            } else {
              arr.push({
                distanzaSn:distanza+p.distSnPorta,
                larghezza:p.larghporta,
                porta:p
              });
            }
          });
          if(config.elencoFreeBlocks){
            config.elencoFreeBlocks.filter((x:any)=>x.cellaId==cce.id && x.lato==lato).forEach((p:any)=>{
              p.distSnPorta=p.distLato;
              let stessaDist=false;
              arr.forEach((ff:any,ind:number)=>{
                if(ff.distanzaSn==distanza+p.distLato){
                  arr[ind].fb=p;
                  stessaDist=true;
                }
              });
              if(!stessaDist){ 
                arr.push({
                  distanzaSn:distanza+p.distLato,
                  larghezza:p.width,
                  fb:p
                });
              }
              
            });
          }
          cce.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato==lato).forEach((c:any)=>{
            if(c.tipoCollegamento=='unite' || c.tipoCollegamento=='collegateDivisorio' ){
              if(c.tipoCollegamento=='collegateDivisorio'){
                let conPorta=false;
                arr.forEach((e:any,ind:number)=>{
            
                  if(e.porta && e.distanzaSn>distanza+c.distLato && e.distanzaSn<distanza+c.distLato+c.larghezza){ // la porta è nel divisorio
                    conPorta=true;
                    arr.push({
                      distanzaSn:distanza+c.distLato,
                      larghezza:e.distanzaSn-distanza-c.distLato,
                      tipoCollegamento:c.tipoCollegamento
                    });
                    arr.push({
                      distanzaSn:distanza+c.distLato+e.distanzaSn-c.distLato+e.larghezza,
                      larghezza:c.larghezza-(e.distanzaSn-distanza+-c.distLato)-e.larghezza,
                      tipoCollegamento:c.tipoCollegamento
                    });
                  } 
                });
                if(!conPorta){
                  arr.push({
                  distanzaSn:distanza+c.distLato,
                  larghezza:c.larghezza,
                  tipoCollegamento:c.tipoCollegamento
                });
                }
              } else {
                arr.push({
                  distanzaSn:distanza+c.distLato,
                  larghezza:c.larghezza,
                  tipoCollegamento:c.tipoCollegamento
                });
              }
          
            }
            if(c.tipoCollegamento=='combinate' ){
              if(!c.latocombinato){ 
                arr.push({
                  distanzaSn:c.distLato,
                  larghezza:lungh,
                  tipoCollegamento: 'combinate' 
                });
              } 
            }
          });
           if(lato=='lato_fronte' || lato=='lato_retro'){
              distanza+=cce.ingombroX;
            } else {
              distanza+=cce.ingombroY;
            }
        });
      } else {
        // cella singola: porte + freeblock da config.elencoFreeBlocks
        cellaDati.elencoPorte.filter((x:any)=>!x.portaDivisorio && x.lato_porta==lato).forEach((p:any)=>{
          if(p.distSnPorta+p.larghporta>lungh){
            arr.push({
              distanzaSn:p.distSnPorta-(p.distSnPorta+p.larghporta-lungh),
              larghezza:p.larghporta,
              porta:p
            });
          } else {
            arr.push({
              distanzaSn:p.distSnPorta,
              larghezza:p.larghporta,
              porta:p
            });
          }
        });
        if(config?.elencoFreeBlocks){
          config.elencoFreeBlocks.filter((x:any)=>x.cellaId==cellaDati.id && x.lato==lato).forEach((p:any)=>{
            let stessaDist=false;
            arr.forEach((ff:any,ind:number)=>{
              if(ff.distanzaSn==p.distLato){
                arr[ind].fb=p;
                stessaDist=true;
              }
            });
            if(!stessaDist){
              arr.push({
                distanzaSn:p.distLato,
                larghezza:p.width,
                fb:p
              });
            }
          });
        }
      }
    }
        

    arr= arr.sort((a:any, b:any) => ( a.distanzaSn < b.distanzaSn ? -1 : 1));
      

    return arr;
  }


  angoloNovanta(config:any,lato:string,cella:any,startLeft:number,distanza:number){
    let isAngoloStart:boolean=false;
    let isAngoloEnd:boolean=false;
    
   
    let res=false;
    cella.celleCollegate.forEach((c:any)=>{
      if(c.tipoCollegamento=='unite'){
        if((lato=='lato_fronte' || lato=='lato_sn'  || lato=='lato_ds' ) && c.latocollegato=='lato_fronte'){
           res=true;
        }
        if((lato=='lato_retro' || lato=='lato_sn'  || lato=='lato_ds' ) && c.latocollegato=='lato_retro'){
           res=true;
        }
        if((lato=='lato_retro' || lato=='lato_sn'  || lato=='lato_fronte' ) && c.latocollegato=='lato_sn'){
           res=true;
        }
        if((lato=='lato_retro' || lato=='lato_ds'  || lato=='lato_fronte' ) && c.latocollegato=='lato_ds'){
           res=true;
        }
      }
      if(lato==c.latocollegato && c.tipoCollegamento=='collegateDivisorio'){
          res=true;
      }
    });
    if(!res){
      return false;
    }

    if(cella.spessore==13) return false;
    const pannello=cella.spessore==6? 31:27;
   
    let pts=config.elencoPunti.filter((x:any)=> x.id==cella.id);
    let pt1:any={};
    let pt2:any={};
     if(lato=='lato_fronte'){
      pt1={x:pts[0].x1+startLeft,y:pts[0].y2};
      pt2={x:pts[0].x1+distanza,y:pts[0].y2};
    }
    if(lato=='lato_retro'){
      pt1={x:pts[0].x1+startLeft,y:pts[0].y1};
      pt2={x:pts[0].x1+distanza,y:pts[0].y1};
    }
    if(lato=='lato_sn'){
      pt1={x:pts[0].x1,y:pts[0].y2-startLeft};
      pt2={x:pts[0].x1,y:pts[0].y2-distanza};
    }
    if(lato=='lato_ds'){
      pt1={x:pts[0].x2,y:pts[0].y2-startLeft};
      pt2={x:pts[0].x2,y:pts[0].y2-distanza};
    }
    //cerca se esiste nei elencoAngoli
    config.elencoAngoli.forEach((pt:any)=>{
      if(pt.x==pt1.x && pt.y==pt1.y){
        isAngoloStart=true;

      }
    });
    config.elencoAngoli.forEach((pt:any)=>{
      if(pt.x==pt2.x && pt.y==pt2.y){
        isAngoloEnd=true;
      }
    });  
   
    let obj:any=null;
    let side:string='';
    switch(lato){
      case 'lato_fronte':
        side='fronte_retro';
        obj=this.objFronte;
        break;
      case 'lato_retro':
        side='fronte_retro';
        obj=this.objRetro;
        break;
      case 'lato_sn':
        side='laterale';
        obj=this.objLatSin;
        break;
      case 'lato_ds':
        side='laterale';
        obj=this.objLatDs;
        break;
    }


    if(isAngoloStart && isAngoloEnd){
      this.insertPannelliLato(this.cellaDati.spessore,side,obj,this.cellaDati.altezza,true);
      this.insertPannelliLato(pannello,side,obj,this.cellaDati.altezza);
      this.insertPannelliLato(distanza-startLeft-2*pannello-6-this.cellaDati.spessore*2,side,obj,this.cellaDati.altezza);
      this.insertPannelliLato(pannello,side,obj,this.cellaDati.altezza);
       this.insertPannelliLato(this.cellaDati.spessore,side,obj,this.cellaDati.altezza,true);
    
    }
    if(isAngoloStart && !isAngoloEnd){
      this.insertPannelliLato(this.cellaDati.spessore+3,side,obj,this.cellaDati.altezza,true);
      this.insertPannelliLato(pannello,side,obj,this.cellaDati.altezza);
      this.insertPannelliLato(distanza-startLeft-pannello-3-this.cellaDati.spessore,side,obj,this.cellaDati.altezza);
    }
    if(!isAngoloStart && isAngoloEnd){
      this.insertPannelliLato(distanza-startLeft-pannello-3-this.cellaDati.spessore,side,obj,this.cellaDati.altezza);
      this.insertPannelliLato(pannello,side,obj,this.cellaDati.altezza);
      this.insertPannelliLato(this.cellaDati.spessore+3,side,obj,this.cellaDati.altezza,true);
    }
   
    return isAngoloStart || isAngoloEnd;
  }

  calcNumPareti(angolo:string){
   
    let orient=-1;
    let pareti=2;
    let resAngolo=angolo;
    let offsetX=0;
    let offsetY=0;

    this.cellaDati.celleCollegate.forEach((c:any)=>{
    //==========================
    // SET ACCOPPIAMENTO
    //==========================
    if(c.tipoCollegamento=='combinate' && !c.latocombinato){    
      pareti=0;
      let isFound=false;
      if(angolo=='ss' && c.latocollegato=='lato_sn'){
        orient=90;
        isFound=true;
      }
      if(angolo=='ss' && c.latocollegato=='lato_retro'){
        orient=90;
        isFound=true;
      }
      if(angolo=='sd' && c.latocollegato=='lato_ds'){
        orient=0;
        isFound=true;
      }
      if(angolo=='sd' && c.latocollegato=='lato_retro'){
        orient=0;
        isFound=true;
      }
      if(angolo=='is' && c.latocollegato=='lato_sn'){
        orient=90;
        offsetY=0;
        isFound=true;
      }
      if(angolo=='is' && c.latocollegato=='lato_fronte'){
        orient=180;
        offsetY=0;
        offsetX=-1.5;
        isFound=true;
      }
      if(angolo=='id' && c.latocollegato=='lato_ds'){
        orient=180;
        isFound=true;
      }
      if(angolo=='id' && c.latocollegato=='lato_fronte'){
        orient=180;
        offsetY=0;
        isFound=true;
      }
      if(!isFound){
        pareti=2;
        resAngolo=angolo;
        offsetX=0;
        offsetY=0;
      }
    }
    //==========================
    // DIVISORIO
    //==========================
    if(c.tipoCollegamento=='collegateDivisorio' && !c.latocombinato){  
      offsetY=-1.5;
      resAngolo=angolo;
      pareti=3;
      let isFound=false;
      if(angolo=='ss' && c.latocollegato=='lato_sn'){
        orient=90;
        isFound=true;
      }
      if(angolo=='ss' && c.latocollegato=='lato_retro'){
        orient=0;
        offsetY=0;
        offsetX=-1.5;
        isFound=true;
      }
      if(angolo=='sd' && c.latocollegato=='lato_ds'){
        orient=-90;
        isFound=true;
      }
      if(angolo=='sd' && c.latocollegato=='lato_retro'){
        orient=0;
        offsetY=0;
        isFound=true;
      }
      if(angolo=='is' && c.latocollegato=='lato_sn'){
        orient=90;
        offsetY=0;
        isFound=true;
      }
      if(angolo=='is' && c.latocollegato=='lato_fronte'){
        orient=180;
        offsetY=0;
        offsetX=-1.5;
        isFound=true;
      }
      if(angolo=='id' && c.latocollegato=='lato_ds'){
        orient=-90;
        offsetY=0;
        isFound=true;
      }
      if(angolo=='id' && c.latocollegato=='lato_fronte'){
        orient=180;
        offsetY=0;
        isFound=true;
      }
      if(!isFound){
        pareti=2;
        resAngolo=angolo;
        offsetX=0;
        offsetY=0;
      }
    }
    //==========================
    // UNITE
    //==========================
    if(c.tipoCollegamento=='unite' && !c.latocombinato){  
      if(angolo=='ss' && c.latocollegato=='lato_sn'){
        orient=180;
        offsetX=this.cellaDati.spessore+3;
        offsetY=1.5;
        resAngolo='is';
        pareti= 2;
      }
      if(angolo=='ss' && c.latocollegato=='lato_retro'){
          orient=90;
          offsetY=this.cellaDati.spessore+3;
          offsetX=1.5;
          resAngolo='sd';
          pareti= 2;
      }
      if(angolo=='sd' && c.latocollegato=='lato_ds'){
          orient=0;
          resAngolo='id';
          offsetX=this.cellaDati.spessore+3;
          offsetY=1.5;
          pareti=2;
      }
      if(angolo=='sd' && c.latocollegato=='lato_retro'){
          orient=-90;
          offsetY=this.cellaDati.spessore+3;
          offsetX=1.5;
          resAngolo='ss';
          pareti=2;
      }
      if(angolo=='is' && c.latocollegato=='lato_sn'){
          orient=90;
          resAngolo='ss';
          offsetX=this.cellaDati.spessore+3;
          offsetY=1.5;
          pareti= 2;
      }
      if(angolo=='is' && c.latocollegato=='lato_fronte'){
          orient= 90;
          resAngolo='id';
          offsetY=this.cellaDati.spessore+3;
          offsetX=1.5;
          pareti= 2;
      }
      if(angolo=='id' && c.latocollegato=='lato_ds'){
          orient=180;
          resAngolo='sd';
          offsetX=this.cellaDati.spessore+3;
          offsetY=1.5;
          pareti= 2;
      }
      if(angolo=='id' && c.latocollegato=='lato_fronte'){
          orient=-90;
          resAngolo='is';
          offsetY=this.cellaDati.spessore+3;
          offsetX=1.5;
          pareti=2;
      }
    }
  

/*
      if(angolo=='ss' && c.latocollegato=='lato_retro'){
          orient=-90;
          offsetY=(c.tipoCollegamento!='unite' ) || c.latocombinato? 0:this.cellaDati.spessore+3;
          offsetX=(c.tipoCollegamento!='unite' ) || c.latocombinato? 0:1.5;
          resAngolo=(c.tipoCollegamento!='unite' ) && !c.latocombinato?'sd':angolo;
          pareti=(c.tipoCollegamento!='unite' )? c.latocombinato? 3:0 :  2;
      }
      if(angolo=='sd' && c.latocollegato=='lato_ds'){
          orient=0;
          resAngolo=(c.tipoCollegamento!='unite' ) && !c.latocombinato?'id':angolo;
          offsetX=(c.tipoCollegamento!='unite' ) || c.latocombinato? 0:this.cellaDati.spessore+3;
          offsetY=(c.tipoCollegamento!='unite' ) || c.latocombinato? 0:1.5;
          pareti=(c.tipoCollegamento!='unite' ) && !c.latocombinato? c.latocombinato? 3:0 : 2;
      }
      if(angolo=='sd' && c.latocollegato=='lato_retro'){
          orient=90;
          offsetY=(c.tipoCollegamento!='unite' ) || c.latocombinato? 0:this.cellaDati.spessore+3;
          offsetX=(c.tipoCollegamento!='unite' ) || c.latocombinato? 0:1.5;
          resAngolo=(c.tipoCollegamento!='unite' ) && !c.latocombinato?'ss':angolo;
          pareti=(c.tipoCollegamento!='unite' ) ? c.latocombinato? 3:0 :  2;
      }
      if(angolo=='is' && c.latocollegato=='lato_sn'){
          orient=180;
          resAngolo=(c.tipoCollegamento!='unite' ) && !c.latocombinato?'ss':angolo;
          offsetX=(c.tipoCollegamento!='unite' ) || c.latocombinato ? 0:this.cellaDati.spessore+3;
          offsetY=(c.tipoCollegamento!='unite' )  || c.latocombinato ? 0:1.5;
          pareti=(c.tipoCollegamento!='unite' ) ? c.latocombinato? 3:0 : 2;
      }
      if(angolo=='is' && c.latocollegato=='lato_fronte'){
          orient= 90;
          resAngolo=(c.tipoCollegamento!='unite' ) && !c.latocombinato?'id':angolo;
          offsetY=(c.tipoCollegamento!='unite' ) || c.latocombinato? 0:this.cellaDati.spessore+3;
          offsetX=(c.tipoCollegamento!='unite' ) || c.latocombinato? 0:1.5;
          pareti=(c.tipoCollegamento!='unite' ) && !c.latocombinato? c.latocombinato? 3:0 : 2;
      }
      if(angolo=='id' && c.latocollegato=='lato_ds'){
          orient=180;
          resAngolo=(c.tipoCollegamento!='unite' ) && !c.latocombinato?'sd':angolo;
          offsetX=(c.tipoCollegamento!='unite') || c.latocombinato? 0:this.cellaDati.spessore+3;
          offsetY=(c.tipoCollegamento!='unite') || c.latocombinato? 0:1.5;
          pareti=(c.tipoCollegamento!='unite' ) && !c.latocombinato? c.latocombinato? 3:0 : 2;
      }
      if(angolo=='id' && c.latocollegato=='lato_fronte'){
          orient=-90;
          resAngolo=(c.tipoCollegamento!='unite' ) && !c.latocombinato?'is':angolo;
          offsetY=(c.tipoCollegamento!='unite' ) || c.latocombinato? 0:this.cellaDati.spessore+3;
          offsetX=(c.tipoCollegamento!='unite') || c.latocombinato? 0:1.5;
          pareti=(c.tipoCollegamento!='unite') && !c.latocombinato? c.latocombinato? 3:0 : 2;
      }
          */
    });
    
    return {
      numPareti:pareti,
      orient:orient,
      angolo:resAngolo,
      offsetX:offsetX,
      offsetY:offsetY
    };
  }

  calcolaCelleUniteSulLato(config:any,lato:string){
    let ordineCelle:any[]=[];
    let ycorrente=0;
    let xcorrente=0;
    let celleUniteSulLato=[];
    let lunghTot=0;
     

    config.elencoCelle.forEach((cel:any)=>{
      if(cel.id==this.cellaDati.id){
        if(lato=='lato_fronte' ){
          ycorrente=Math.round(cel.offsetY+cel.ingombroY/2);
        } else {
          ycorrente=Math.round(cel.offsetY-cel.ingombroY/2);
        }
        if(lato=='lato_sn' ){
          xcorrente=Math.round(cel.offsetX-cel.ingombroX/2);
        } else {
          xcorrente=Math.round(cel.offsetX+cel.ingombroX/2);
        }
      }
      let y1=0;
      let x1=0;
      let y2=0;
      let x2=0;
      if(lato=='lato_fronte' ){
          y1=Math.round(cel.offsetY+cel.ingombroY/2);
          y2=Math.round(cel.offsetY+cel.ingombroY/2);
          x1=Math.round(cel.offsetX-cel.ingombroX/2);
          x2=Math.round(cel.offsetX+cel.ingombroX/2);
      } 
      if(lato=='lato_sn' ){
          y1=Math.round(cel.offsetY+cel.ingombroY/2);
          y2=Math.round(cel.offsetY-cel.ingombroY/2);
          x1=Math.round(cel.offsetX-cel.ingombroX/2);
          x2=Math.round(cel.offsetX-cel.ingombroX/2);
      } 
      if(lato=='lato_retro' ){
          y1=Math.round(cel.offsetY-cel.ingombroY/2);
          y2=Math.round(cel.offsetY-cel.ingombroY/2);
          x1=Math.round(cel.offsetX-cel.ingombroX/2);
          x2=Math.round(cel.offsetX+cel.ingombroX/2);
      } 
      if(lato=='lato_ds' ){
          y1=Math.round(cel.offsetY+cel.ingombroY/2);
          y2=Math.round(cel.offsetY-cel.ingombroY/2);
          x1=Math.round(cel.offsetX+cel.ingombroX/2);
          x2=Math.round(cel.offsetX+cel.ingombroX/2);
      } 
      ordineCelle.push({
        id:cel.id,
        p1:{
          x1:x1,
          y1:y1,
          x2:x2,
          y2:y2,
          ingombroX:cel.ingombroX,
          ingombroY:cel.ingombroY,
        }
      })
    });
    /*
    if(lato=='lato_fronte' || lato=='lato_retro' ){
      ordineCelle=ordineCelle.filter((a:any)=> a.p1.y1==ycorrente && a.p1.x1==xcorrente ).sort((a, b) => a.p1.x1 - b.p1.x1);
    } else {
      ordineCelle=ordineCelle.filter((a:any)=> a.p1.x1==xcorrente).sort((a, b) => b.p1.y1 - a.p1.y1);
    }
    */
    ordineCelle=ordineCelle.filter((a:any)=> (a.p1.y1==ycorrente && a.p1.x1==xcorrente) || (a.p1.y2==ycorrente && a.p1.x2==xcorrente) ).sort((a, b) => a.p1.x1 - b.p1.x1);
  


    let curr=0;
    let ordineCelle21:any=[];

    ordineCelle.forEach((cel:any)=>{
       if(lato=='lato_fronte' || lato=='lato_retro' ){
        if(curr==0 || curr==cel.p1.x1){
          ordineCelle21.push(cel);
          curr=cel.p1.x2;
        }
       } else {
        if(curr==0 || curr==cel.p1.y1){
          ordineCelle21.push(cel);
          curr=cel.p1.y2;
        }
       }
    });
    let ordineCelle2:any=[];
    let unite=true;
    ordineCelle21.forEach((cel:any)=>{
      if(unite){
        let cellcobj=config.elencoCelle.filter((cel2:any)=>cel2.id==cel.id)[0];
        // proseguo del lato con divisorio → interrompe la parete continua (lato cella1 + divisorio cella2)
        const hasDivSuQuestoLato = (cellcobj?.celleCollegate || []).some(
          (x: any) =>
            x.attivo &&
            x.tipoCollegamento === 'collegateDivisorio' &&
            x.latocollegato === lato,
        );
        if (hasDivSuQuestoLato) {
          unite = false;
          return;
        }
        if(lato=='lato_fronte' || lato=='lato_retro' ){
          cellcobj.celleCollegate.filter((x:any)=>x.attivo && (x.latocollegato=='lato_ds' || x.latocollegato=='lato_sn')).forEach((c:any)=>{
              if(c.tipoCollegamento!='unite' ){
                unite=false;
              }
          });
          if(unite){
            ordineCelle2.push(cel);
          }
        } else {
          cellcobj.celleCollegate.filter((x:any)=>x.attivo && (x.latocollegato=='lato_retro' || x.latocollegato=='lato_fronte')).forEach((c:any)=>{
              if(c.tipoCollegamento!='unite' ){
                unite=false;
              }
          });
          if(unite){
            ordineCelle2.push(cel);
          }
        }
      }
    });

    if(this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.tipoCollegamento=='combinate' && (x.latocollegato==lato && !x.latocombinato)).length==0){
      if(ordineCelle21.length>0 && ordineCelle2.length==0 && ordineCelle.filter((x:any)=>x.id==this.cellaDati.id).length>0){
        ordineCelle2.push(ordineCelle.filter((x:any)=>x.id==this.cellaDati.id)[0]);
      }
    } else {
      ordineCelle2=[];
    }

    ordineCelle2.forEach((cel:any)=>{
       if(lato=='lato_fronte' || lato=='lato_retro' ){
        lunghTot+=cel.p1.ingombroX;
       } else {
        lunghTot+=cel.p1.ingombroY;
       }
    });
  
    celleUniteSulLato=ordineCelle2;
    


    /*
    this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato==lato).forEach((c:any)=>{
      if(c.tipoCollegamento!='unite' ){
        if(c.latocombinato ){
          celleUniteSulLato=ordineCelle2.filter((a:any)=> a.id==this.cellaDati.id); 
        } else {
          celleUniteSulLato=[];
        }
      }
    });
    */
    if(celleUniteSulLato.length>1 && config.calcAngoliDaCanc){
      if(!config.angoliDaCanc){
        config.angoliDaCanc=[];
      }
      config.angoliDaCanc.push({
        id:this.cellaDati.id,
        celleUniteSulLato:celleUniteSulLato,
        lunghTot:lunghTot,
        lato:lato
      });
    }
    return {
      celleUniteSulLato:celleUniteSulLato,
      lunghTot:lunghTot,
      lato:lato
    }
  }


  /**
   * Nodo cella sul diagramma di model-design (addInfo.type === 'cella').
   */
  getNodoCella(cellaId: any): any {
    if (!this.diagram?.nodes || cellaId == null) {
      return null;
    }
    return (this.diagram as Diagram).nodes.find(
      (n: any) => n?.addInfo?.type === 'cella' && n?.addInfo?.id == cellaId
    ) || null;
  }

  /**
   * Costruisce i pannelli dei 4 lati in this.objCella.
   * - contatto unite: fittizio / salta (come updateHtmlNodesOuterBorders)
   * - pareti collineari unite (es. fronte continuo): una sola lunghezza su cella owner
   */
  getObj2(objCella: any, cellaDati: any, config: any = null): any {
    this.cellaDati = cellaDati;

    this.objCella = {
      w: objCella.w,
      h: objCella.h,
      d: objCella.d,
      spessore: objCella.spessore,
      cappucci: [],
      angolari: [],
      objFronte: { x: 0, y: 0, z: 0, pannelli: [] },
      objRetro: { x: objCella.w, y: 0, z: 0, pannelli: [] },
      objLatSin: { x: 0, y: 0, z: 0, pannelli: [] },
      objLatDs: { x: 0, y: 0, z: objCella.d, pannelli: [] },
    };

    const rect = this.getDiagramRectCella(cellaDati?.id);
    const lunghFronteRetro = rect ? Math.round(rect.width) : Math.round(cellaDati.ingombroX || objCella.d);
    const lunghLaterali = rect ? Math.round(rect.height) : Math.round(cellaDati.ingombroY || objCella.w);
    const altezza = cellaDati.altezza;

    // covers: stessa logica dei bordi HTML (tratti nascosti = contatto unite)
    const covers = this.getUniteCoversComeBordi(config);

    // registro multi-passata (una volta per configurazione): parziali → pieni → altri/opposti
    if (config?.elencoCelle?.length && !config._compensoDivisorioPrepared) {
      this.prepareCompensoDivisorioRegistry(config);
    }

    type LatoBuild = {
      latoCella: string;
      latoPannello: string;
      obj: any;
      lungh: number;
    };
    const sides: LatoBuild[] = [
      {
        latoCella: 'lato_fronte',
        latoPannello: 'fronte_retro',
        obj: this.objCella.objFronte,
        lungh: lunghFronteRetro,
      },
      {
        latoCella: 'lato_retro',
        latoPannello: 'fronte_retro',
        obj: this.objCella.objRetro,
        lungh: lunghFronteRetro,
      },
      {
        latoCella: 'lato_sn',
        latoPannello: 'laterale',
        obj: this.objCella.objLatSin,
        lungh: lunghLaterali,
      },
      {
        latoCella: 'lato_ds',
        latoPannello: 'laterale',
        obj: this.objCella.objLatDs,
        lungh: lunghLaterali,
      },
    ];

    // 1 = parziale / T (ha compensatori da creare subito), 2 = pieno senza punti nuovi, 3 = altri
    const faseLato = (latoCella: string, lungh: number): number => {
      const contatti = this.getContattiDivisorioSuLato(latoCella, cellaDati, config, lungh);
      if (!contatti.length) {
        return 3;
      }
      if (!this.divisorioCopreInteroLato(contatti, lungh)) {
        return 1;
      }
      // unione piena ma con T / punti già in registro → costruisci prima (come parziale)
      const pts =
        this.getPuntiCompensoDaRegistro(cellaDati.id, latoCella).length > 0
          ? this.getPuntiCompensoDaRegistro(cellaDati.id, latoCella)
          : this.getPuntiCompensoDivisorioSuLato(latoCella, cellaDati, config, lungh);
      return pts.length > 0 ? 1 : 2;
    };

    [1, 2, 3].forEach((fase) => {
      sides
        .filter((s) => faseLato(s.latoCella, s.lungh) === fase)
        .forEach((s) => {
          this.insertPannelliLatoConPorte2(
            s.latoCella,
            s.latoPannello,
            s.obj,
            s.lungh,
            altezza,
            cellaDati,
            covers,
            config,
          );
        });
    });

    // ancore pareti opposte = geometria diagramma (non somma pannelli).
    if (lunghFronteRetro > 0) {
      this.objCella.objLatDs.z = lunghFronteRetro;
    }
    let retroX = lunghLaterali > 0 ? lunghLaterali : this.objCella.objRetro.x;
    // L a un angolo: +sp+3 sul retro SOLO se il contatto laterale è verso il retro.
    // Mai se su lato_retro c’è già unite (es. A–B unite e B–C combinate: non spostare
    // il lato unito di B quando arriva C).
    const deltaSp = (cellaDati.spessore || 0) + 3;
    const hasUniteOnRetro = (cellaDati.celleCollegate || []).some(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'unite' &&
        x.latocollegato === 'lato_retro',
    );
    const linksDiv = (cellaDati.celleCollegate || []).filter(
      (x: any) => x.attivo && x.tipoCollegamento === 'collegateDivisorio',
    );
    const latDiv = linksDiv.filter(
      (x: any) => x.latocollegato === 'lato_sn' || x.latocollegato === 'lato_ds',
    );
    const frDiv = linksDiv.filter(
      (x: any) =>
        x.latocollegato === 'lato_fronte' || x.latocollegato === 'lato_retro',
    );
    let addRetro = 0;
    if (!hasUniteOnRetro) {
      if (latDiv.length === 1 && config?.elencoCelle?.length) {
        const link = latDiv[0];
        const other = config.elencoCelle.find((c: any) => c.id == link.cellaCollegataId);
        const dimThis = cellaDati.ingombroY || 0;
        const dimOther = other?.ingombroY || 0;
        if (other && dimThis > dimOther + 0.5) {
          const dist = Number(link.distLato) || 0;
          const larg =
            Number(link.larghezza) > 0
              ? Number(link.larghezza)
              : dimOther;
          const lungh = lunghLaterali || dimThis;
          if (dist + larg / 2 > lungh / 2) {
            addRetro = deltaSp;
          }
        }
      } else if (
        frDiv.length === 1 &&
        frDiv[0].latocollegato === 'lato_fronte' &&
        config?.elencoCelle?.length
      ) {
        const other = config.elencoCelle.find(
          (c: any) => c.id == frDiv[0].cellaCollegataId,
        );
        if (other && (cellaDati.ingombroX || 0) > (other.ingombroX || 0) + 0.5) {
          addRetro = deltaSp;
        }
      }
    }
    if (lunghLaterali > 0 || addRetro > 0) {
      this.objCella.objRetro.x = retroX + addRetro;
    }

    // allinea anche i campi usati da drawPareti / PDF / misure (leggono this.objLatDs ecc.)
    this.objFronte = this.objCella.objFronte;
    this.objRetro = this.objCella.objRetro;
    this.objLatSin = this.objCella.objLatSin;
    this.objLatDs = this.objCella.objLatDs;

    return this.objCella;
  }

  oppositeLatoCella(lato: string): string {
    switch (lato) {
      case 'lato_fronte': return 'lato_retro';
      case 'lato_retro': return 'lato_fronte';
      case 'lato_sn': return 'lato_ds';
      case 'lato_ds': return 'lato_sn';
      default: return '';
    }
  }

  keyCompensoDivisorio(cellaId: any, lato: string): string {
    return `${cellaId}::${lato}`;
  }

  lunghLatoCella(cella: any, lato: string): number {
    if (!cella) {
      return 0;
    }
    return lato === 'lato_sn' || lato === 'lato_ds'
      ? Math.round(cella.ingombroY || 0)
      : Math.round(cella.ingombroX || 0);
  }

  mergePuntiCompenso(a: number[], b: number[], lunghLato = 0): number[] {
    const eps = 0.5;
    const out: number[] = [];
    const add = (p: number) => {
      const clamped =
        lunghLato > 0 ? Math.max(0, Math.min(lunghLato, p)) : p;
      if (!out.some((x) => Math.abs(x - clamped) <= eps)) {
        out.push(clamped);
      }
    };
    (a || []).forEach(add);
    (b || []).forEach(add);
    return out.sort((x, y) => x - y);
  }

  /**
   * Punti compensatorio già noti sulla grande per il contatto di questa cella
   * (lettura registro o calcolo live), in coordinate LOCALI di questa cella.
   */
  collectCompensoDaGrandeSuContatto(
    cellaDati: any,
    latoDiv: string,
    config: any,
    lunghLato: number,
  ): number[] {
    if (!cellaDati || !config || lunghLato <= 0) {
      return [];
    }
    const links = (cellaDati.celleCollegate || []).filter(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'collegateDivisorio' &&
        x.latocollegato === latoDiv,
    );
    if (!links.length || links.some((l: any) => this.cellaPossiedeCompensoDivisorio(l, cellaDati, config))) {
      return [];
    }
    const eps = 0.5;
    const pts: number[] = [];
    const add = (p: number) => {
      const clamped = Math.max(0, Math.min(lunghLato, p));
      if (!pts.some((x) => Math.abs(x - clamped) <= eps)) {
        pts.push(clamped);
      }
    };
    const latoGrande = this.oppositeLatoCella(latoDiv);
    links.forEach((link: any) => {
      const other = (config.elencoCelle || []).find((c: any) => c.id == link.cellaCollegataId);
      if (!other) {
        return;
      }
      const lunghGrande = this.lunghLatoCella(other, latoGrande);
      if (lunghGrande <= 0) {
        return;
      }
      const fromReg =
        this.compensoDivisorioReg.get(this.keyCompensoDivisorio(other.id, latoGrande)) || [];
      const puntiGrande =
        fromReg.length > 0
          ? fromReg
          : this.getPuntiCompensoDivisorioSuLato(latoGrande, other, config, lunghGrande);
      if (!puntiGrande.length) {
        return;
      }
      const linkGrande = (other.celleCollegate || []).find(
        (x: any) =>
          x.attivo &&
          x.tipoCollegamento === 'collegateDivisorio' &&
          x.cellaCollegataId == cellaDati.id &&
          x.latocollegato === latoGrande,
      );
      const aG = Math.max(0, linkGrande?.distLato || 0);
      const spanG =
        linkGrande?.larghezza > 0
          ? linkGrande.larghezza
          : lunghLato > 0
            ? lunghLato
            : Math.max(0, lunghGrande - aG);
      const bG = Math.min(lunghGrande, aG + spanG);
      const liberiGrande = this.getTrattiLiberiDivisorioConCompenso(
        latoGrande,
        other,
        config,
        lunghGrande,
      );
      // Solo pannelli NEL divisorio di questa cella (es. T tra due contatti).
      // Se il pannello è sul tratto LIBERO della grande (prima/dopo il contatto),
      // non appartiene al divisorio di questa cella → niente specchio sul lato opposto.
      puntiGrande.forEach((p) => {
        if (Math.abs(p - aG) <= eps) {
          const liberoPrima = liberiGrande.some(
            (t) => Math.abs(t.b - p) <= eps && t.angoloEnd,
          );
          if (!liberoPrima) {
            add(0);
          }
        } else if (Math.abs(p - bG) <= eps) {
          // pannello sul libero dopo → non nel divisorio di questa cella
          // (né al T: il pannello T sta sull'inizio del contatto successivo = aG)
        } else if (p > aG + eps && p < bG - eps) {
          add(p - aG);
        }
      });
    });
    return pts.sort((x, y) => x - y);
  }

  /**
   * Due celle sono unite su un lato ortogonale a `latoContatto`
   * (es. contatto sn/ds → unite su fronte/retro, come nella L: cella sx vs due a dx unite).
   */
  sonoUniteOrtogonaliAlLato(
    cellA: any,
    cellB: any,
    latoContatto: string,
  ): boolean {
    if (!cellA || !cellB) {
      return false;
    }
    const latOrt =
      latoContatto === 'lato_sn' || latoContatto === 'lato_ds'
        ? ['lato_fronte', 'lato_retro']
        : ['lato_sn', 'lato_ds'];
    const linkAB = (cellA.celleCollegate || []).find(
      (l: any) =>
        l.attivo &&
        l.tipoCollegamento === 'unite' &&
        l.cellaCollegataId == cellB.id &&
        latOrt.includes(l.latocollegato),
    );
    if (linkAB) {
      return true;
    }
    const linkBA = (cellB.celleCollegate || []).find(
      (l: any) =>
        l.attivo &&
        l.tipoCollegamento === 'unite' &&
        l.cellaCollegataId == cellA.id &&
        latOrt.includes(l.latocollegato),
    );
    return !!linkBA;
  }

  /**
   * Dimensione del lato di contatto (Y per sn/ds, X per fronte/retro).
   */
  dimLatoContatto(cella: any, lato: string): number {
    if (!cella) {
      return 0;
    }
    return lato === 'lato_sn' || lato === 'lato_ds'
      ? cella.ingombroY || 0
      : cella.ingombroX || 0;
  }

  /**
   * Owner del divisorio = cella col lato collegato più grande.
   * Se uguali → id minore (una sola).
   */
  cellaEOwnerDivisorioVs(
    cella: any,
    other: any,
    lato: string,
  ): boolean {
    const dimThis = this.dimLatoContatto(cella, lato);
    const dimOther = this.dimLatoContatto(other, lato);
    if (dimThis > dimOther + 0.5) {
      return true;
    }
    if (dimThis < dimOther - 0.5) {
      return false;
    }
    return String(cella?.id ?? '') <= String(other?.id ?? '');
  }

  /**
   * Divisorio: SEMPRE sulla cella più grande (lato collegato più lungo).
   * L'altra ha latocombinato=false → in getObj2 pannelli=[] sul lato.
   */
  applicaOwnerDivisorioSuCellaPiuGrande(config: any): void {
    const elenco = config?.elencoCelle || [];
    if (elenco.length < 2) {
      return;
    }
    elenco.forEach((c: any) => {
      (c.celleCollegate || []).forEach((link: any) => {
        if (
          !link?.attivo ||
          link.tipoCollegamento !== 'collegateDivisorio' ||
          !link.latocollegato
        ) {
          return;
        }
        const other = elenco.find((o: any) => o.id == link.cellaCollegataId);
        if (!other) {
          return;
        }
        const owner = this.cellaEOwnerDivisorioVs(c, other, link.latocollegato);
        link.latocombinato = owner;
        // allinea il link di ritorno sull'altra cella
        const opp = this.oppositeLatoCella(link.latocollegato);
        (other.celleCollegate || []).forEach((back: any) => {
          if (
            back?.attivo &&
            back.tipoCollegamento === 'collegateDivisorio' &&
            back.cellaCollegataId == c.id &&
            (back.latocollegato === opp ||
              back.latocollegato === link.latocollegato)
          ) {
            back.latocombinato = !owner;
          }
        });
      });
    });
  }

  /**
   * True se questa cella possiede la parete divisorio su `lato`
   * (è la più grande su almeno un contatto attivo).
   */
  cellaPossiedePareteDivisorioSuLato(
    cellaDati: any,
    latoCella: string,
    config: any,
  ): boolean {
    const elenco = config?.elencoCelle || [];
    return (cellaDati?.celleCollegate || []).some((x: any) => {
      if (
        !x.attivo ||
        x.tipoCollegamento !== 'collegateDivisorio' ||
        x.latocollegato !== latoCella
      ) {
        return false;
      }
      const other = elenco.find((c: any) => c.id == x.cellaCollegataId);
      if (!other) {
        return !!x.latocombinato;
      }
      return this.cellaEOwnerDivisorioVs(cellaDati, other, latoCella);
    });
  }

  /**
   * Se una cella ha ≥2 collegamenti divisorio/combinate sullo stesso lato verso
   * celle unite tra loro (ortogonalmente), il divisorio va disegnato su QUELLA cella
   * (latocombinato=true); le altre sul lato opposto hanno latocombinato=false
   * (niente pannelli sul contatto).
   */
  applicaOwnerDivisorioSuLatoConCelleUnite(config: any): void {
    const elenco = config?.elencoCelle || [];
    if (elenco.length < 3) {
      return;
    }
    const lati = ['lato_fronte', 'lato_retro', 'lato_sn', 'lato_ds'];
    const isDivOComb = (l: any) =>
      l?.attivo &&
      (l.tipoCollegamento === 'collegateDivisorio' ||
        l.tipoCollegamento === 'combinate');

    elenco.forEach((c: any) => {
      lati.forEach((lato) => {
        const links = (c.celleCollegate || []).filter(
          (l: any) => isDivOComb(l) && l.latocollegato === lato,
        );
        if (links.length < 2) {
          return;
        }
        const others = links
          .map((l: any) => elenco.find((o: any) => o.id == l.cellaCollegataId))
          .filter(Boolean);
        if (others.length < 2) {
          return;
        }
        // almeno una coppia tra le collegate è unite ortogonalmente
        let coppiaUnite = false;
        for (let i = 0; i < others.length && !coppiaUnite; i++) {
          for (let j = i + 1; j < others.length; j++) {
            if (this.sonoUniteOrtogonaliAlLato(others[i], others[j], lato)) {
              coppiaUnite = true;
              break;
            }
          }
        }
        if (!coppiaUnite) {
          return;
        }

        // owner = cella con i due (o più) collegamenti
        links.forEach((l: any) => {
          l.latocombinato = true;
        });
        const opp = this.oppositeLatoCella(lato);
        others.forEach((o: any) => {
          (o.celleCollegate || []).forEach((l: any) => {
            if (
              isDivOComb(l) &&
              l.cellaCollegataId == c.id &&
              (l.latocollegato === opp || l.latocollegato === lato)
            ) {
              l.latocombinato = false;
            }
          });
        });
      });
    });
  }

  /**
   * Tre passate su TUTTE le celle (da chiamare prima di costruire i pannelli):
   * 1) lati con divisorio PARZIALE → compensatori sui liberi
   * 2) lati con divisorio a TUTTA lunghezza → annota compensatori già presenti (non li cancella)
   * 3) altri lati → regola lato opposto se divisorio pieno + compensatorio già noto
   */
  prepareCompensoDivisorioRegistry(config: any): void {
    this.compensoDivisorioReg = new Map();
    if (!config?.elencoCelle?.length) {
      return;
    }
    // prima: owner divisorio = sempre cella più grande sul lato collegato
    this.applicaOwnerDivisorioSuCellaPiuGrande(config);
    // poi: se un lato tocca ≥2 celle unite tra loro → owner su quella cella
    this.applicaOwnerDivisorioSuLatoConCelleUnite(config);

    const lati = ['lato_fronte', 'lato_retro', 'lato_sn', 'lato_ds'];

    // PASSATA 1: divisorio parziale / T tra più contatti (anche se l'unione copre tutto il lato).
    // Non saltare i lati "pieni" da più celle: il T va registrato e tenuto nelle passate successive.
    config.elencoCelle.forEach((c: any) => {
      lati.forEach((lato) => {
        const L = this.lunghLatoCella(c, lato);
        if (L <= 0) {
          return;
        }
        const contatti = this.getContattiDivisorioCompensoSuLato(lato, c, config, L);
        if (!contatti.length) {
          return;
        }
        const pts = this.getPuntiCompensoDivisorioSuLato(lato, c, config, L);
        if (pts.length) {
          const key = this.keyCompensoDivisorio(c.id, lato);
          this.compensoDivisorioReg.set(
            key,
            this.mergePuntiCompenso(this.compensoDivisorioReg.get(key) || [], pts, L),
          );
        }
      });
    });

    // PASSATA 2: divisorio a tutta lunghezza — tiene i punti già in registro (non cancella)
    config.elencoCelle.forEach((c: any) => {
      lati.forEach((lato) => {
        const L = this.lunghLatoCella(c, lato);
        if (L <= 0) {
          return;
        }
        const contatti = this.getContattiDivisorioSuLato(lato, c, config, L);
        if (!contatti.length || !this.divisorioCopreInteroLato(contatti, L)) {
          return;
        }
        const key = this.keyCompensoDivisorio(c.id, lato);
        const prev = this.compensoDivisorioReg.get(key) || [];
        const daGrande = this.collectCompensoDaGrandeSuContatto(c, lato, config, L);
        // merge: prev (es. T dalla passata 1) non viene mai cancellato
        if (prev.length || daGrande.length) {
          this.compensoDivisorioReg.set(key, this.mergePuntiCompenso(prev, daGrande, L));
        }
      });
    });

    // PASSATA 3: lato corrente senza divisorio → se il lato OPPOSITO ha divisorio a tutta
    // lunghezza E lì c'è già un compensatorio, lo copia qui.
    // Eccezione: se questa cella è la "grande" sul divisorio (ha creato liberi/T),
    // i pannelli restano SOLO sul divisorio — non sul lato opposto (es. cima cella lunga).
    config.elencoCelle.forEach((c: any) => {
      lati.forEach((lato) => {
        const latoDiv = this.oppositeLatoCella(lato);
        const L = this.lunghLatoCella(c, lato);
        const Ldiv = this.lunghLatoCella(c, latoDiv);
        if (L <= 0 || Ldiv <= 0) {
          return;
        }
        const contattiQui = this.getContattiDivisorioSuLato(lato, c, config, L);
        if (contattiQui.length > 0) {
          return;
        }
        const contattiDiv = this.getContattiDivisorioSuLato(latoDiv, c, config, Ldiv);
        if (!this.divisorioCopreInteroLato(contattiDiv, Ldiv)) {
          return;
        }
        if (this.cellaEGrandeSuLatoDivisorio(c, latoDiv, config)) {
          return;
        }
        const ptsDiv = this.compensoDivisorioReg.get(this.keyCompensoDivisorio(c.id, latoDiv)) || [];
        if (!ptsDiv.length) {
          return;
        }
        const key = this.keyCompensoDivisorio(c.id, lato);
        const prev = this.compensoDivisorioReg.get(key) || [];
        this.compensoDivisorioReg.set(key, this.mergePuntiCompenso(prev, ptsDiv, L));
      });
    });

    if (config) {
      config._compensoDivisorioPrepared = true;
    }
  }

  /** Legge punti compensatorio dal registro (dopo prepareCompensoDivisorioRegistry). */
  getPuntiCompensoDaRegistro(cellaId: any, lato: string): number[] {
    return this.compensoDivisorioReg.get(this.keyCompensoDivisorio(cellaId, lato)) || [];
  }

  /** Rettangolo nodo cella sul diagramma (come updateHtmlNodesOuterBorders). */
  getDiagramRectCella(cellaId: any): { left: number; right: number; top: number; bottom: number; width: number; height: number } | null {
    const node = this.getNodoCella(cellaId);
    if (!node) {
      return null;
    }
    let left: number;
    let top: number;
    let width: number;
    let height: number;
    const bounds = node.wrapper?.bounds;
    if (bounds && bounds.width > 0 && bounds.height > 0) {
      left = bounds.x;
      top = bounds.y;
      width = bounds.width;
      height = bounds.height;
    } else {
      width = node.width || 0;
      height = node.height || 0;
      left = (node.offsetX || 0) - width / 2;
      top = (node.offsetY || 0) - height / 2;
    }
    if (width <= 0 || height <= 0) {
      return null;
    }
    return { left, right: left + width, top, bottom: top + height, width, height };
  }

  /**
   * Stessa logica di updateHtmlNodesOuterBorders: per ogni coppia unite,
   * calcola l'intervallo di contatto sul lato (in coordinate locali del lato:
   * fronte/retro da sinistra; laterali dal basso).
   * Ritorna Map cellId -> { lato_*: [{a,b,lunghAltra}] }
   */
  getUniteCoversComeBordi(config: any): Map<string, Record<string, { a: number; b: number; lunghAltra: number }[]>> {
    type Cover = { a: number; b: number; lunghAltra: number };
    const result = new Map<string, Record<string, Cover[]>>();
    const eps = 3;
    const mergeEps = 0.5;

    const ensure = (cellId: string) => {
      if (!result.has(cellId)) {
        result.set(cellId, {
          lato_fronte: [],
          lato_retro: [],
          lato_sn: [],
          lato_ds: [],
        });
      }
      return result.get(cellId)!;
    };

    const findUniteLink = (cellaAId: string, cellaBId: string): any => {
      const cella = (config?.elencoCelle || []).find((c: any) => c.id == cellaAId);
      if (!cella?.celleCollegate) {
        return null;
      }
      return (
        cella.celleCollegate.find(
          (c: any) =>
            c.attivo === true &&
            c.tipoCollegamento === 'unite' &&
            c.cellaCollegataId == cellaBId,
        ) || null
      );
    };

    const sidesTouch = (gap: number): boolean => gap >= -eps && gap <= eps;

    const overlap1D = (a1: number, a2: number, b1: number, b2: number): { a: number; b: number } | null => {
      const a = Math.max(a1, b1);
      const b = Math.min(a2, b2);
      if (b - a > mergeEps) {
        return { a, b };
      }
      return null;
    };

    const rects: { cellId: string; left: number; right: number; top: number; bottom: number; width: number; height: number }[] = [];
    if (!this.diagram?.nodes) {
      return result;
    }
    (this.diagram as Diagram).nodes.forEach((node: any) => {
      if (node?.addInfo?.type !== 'cella' || !node.addInfo?.id) {
        return;
      }
      const r = this.getDiagramRectCella(node.addInfo.id);
      if (!r) {
        return;
      }
      rects.push({ cellId: node.addInfo.id, ...r });
    });

    for (let i = 0; i < rects.length; i++) {
      for (let j = i + 1; j < rects.length; j++) {
        const ra = rects[i];
        const rb = rects[j];
        const linkAB = findUniteLink(ra.cellId, rb.cellId);
        const linkBA = findUniteLink(rb.cellId, ra.cellId);
        if (!linkAB && !linkBA) {
          continue;
        }

        let ov: { a: number; b: number } | null = null;
        let latoA = '';
        let latoB = '';

        // lati da geometria (latocollegato è spesso lo stesso su entrambe le celle)
        const gapALeftOfB = rb.left - ra.right;
        const gapBLeftOfA = ra.left - rb.right;
        if (sidesTouch(gapALeftOfB) || Math.abs(gapALeftOfB) <= eps * 5) {
          ov = overlap1D(ra.top, ra.bottom, rb.top, rb.bottom);
          latoA = 'lato_ds';
          latoB = 'lato_sn';
        } else if (sidesTouch(gapBLeftOfA) || Math.abs(gapBLeftOfA) <= eps * 5) {
          ov = overlap1D(ra.top, ra.bottom, rb.top, rb.bottom);
          latoA = 'lato_sn';
          latoB = 'lato_ds';
        } else {
          const gapAAboveB = rb.top - ra.bottom;
          const gapBAboveA = ra.top - rb.bottom;
          if (sidesTouch(gapAAboveB) || Math.abs(gapAAboveB) <= eps * 5) {
            ov = overlap1D(ra.left, ra.right, rb.left, rb.right);
            latoA = 'lato_fronte';
            latoB = 'lato_retro';
          } else if (sidesTouch(gapBAboveA) || Math.abs(gapBAboveA) <= eps * 5) {
            ov = overlap1D(ra.left, ra.right, rb.left, rb.right);
            latoA = 'lato_retro';
            latoB = 'lato_fronte';
          }
        }

        if (!ov || !latoA || !latoB) {
          continue;
        }

        // converte overlap assoluto → distanza locale sul lato (come distSnPorta)
        const toLocal = (
          rect: typeof ra,
          lato: string,
          abs: { a: number; b: number },
        ): { a: number; b: number } | null => {
          if (lato === 'lato_fronte' || lato === 'lato_retro') {
            // da sinistra
            return {
              a: Math.max(0, abs.a - rect.left),
              b: Math.min(rect.width, abs.b - rect.left),
            };
          }
          // laterali: da basso
          return {
            a: Math.max(0, rect.bottom - abs.b),
            b: Math.min(rect.height, rect.bottom - abs.a),
          };
        };

        const locA = toLocal(ra, latoA, ov);
        const locB = toLocal(rb, latoB, ov);
        const lunghLatoA = latoA === 'lato_sn' || latoA === 'lato_ds' ? ra.height : ra.width;
        const lunghLatoB = latoB === 'lato_sn' || latoB === 'lato_ds' ? rb.height : rb.width;

        if (locA && locA.b > locA.a) {
          ensure(ra.cellId)[latoA].push({ a: locA.a, b: locA.b, lunghAltra: lunghLatoB });
        }
        if (locB && locB.b > locB.a) {
          ensure(rb.cellId)[latoB].push({ a: locB.a, b: locB.b, lunghAltra: lunghLatoA });
        }
      }
    }

    return result;
  }

  /**
   * Segmenta un lato in normale / fittizio / salta usando i covers dei bordi.
   */
  getSegmentiLatoConUnite(
    cellaDati: any,
    latoCella: string,
    lunghLato: number,
    covers: Map<string, Record<string, { a: number; b: number; lunghAltra: number }[]>> | null,
  ): { a: number; b: number; tipo: 'normale' | 'fittizio' | 'salta' }[] {
    type Mark = { a: number; b: number; tipo: 'fittizio' | 'salta' };
    const marks: Mark[] = [];
    const cellCovers = covers?.get(cellaDati?.id)?.[latoCella] || [];

    cellCovers.forEach((c) => {
      if (lunghLato < c.lunghAltra) {
        marks.push({ a: 0, b: lunghLato, tipo: 'salta' });
        return;
      }
      if (lunghLato === c.lunghAltra) {
        if (c.a <= 0 && c.b >= lunghLato) {
          marks.push({ a: 0, b: lunghLato, tipo: 'salta' });
        } else {
          marks.push({ a: c.a, b: c.b, tipo: 'salta' });
        }
        return;
      }
      marks.push({ a: c.a, b: c.b, tipo: 'fittizio' });
    });

    marks.sort((x, y) => x.a - y.a || (x.tipo === 'salta' ? -1 : 1));

    const points = new Set<number>([0, lunghLato]);
    marks.forEach((m) => {
      if (m.b > m.a) {
        points.add(m.a);
        points.add(m.b);
      }
    });
    const sorted = Array.from(points).sort((x, y) => x - y);
    const segs: { a: number; b: number; tipo: 'normale' | 'fittizio' | 'salta' }[] = [];

    for (let i = 0; i < sorted.length - 1; i++) {
      const sa = sorted[i];
      const sb = sorted[i + 1];
      if (sb <= sa) {
        continue;
      }
      const mid = (sa + sb) / 2;
      let tipo: 'normale' | 'fittizio' | 'salta' = 'normale';
      marks.forEach((m) => {
        if (mid >= m.a && mid < m.b) {
          if (m.tipo === 'salta') {
            tipo = 'salta';
          } else if (tipo !== 'salta') {
            tipo = 'fittizio';
          }
        }
      });
      const last = segs[segs.length - 1];
      if (last && last.tipo === tipo && last.b === sa) {
        last.b = sb;
      } else {
        segs.push({ a: sa, b: sb, tipo });
      }
    }

    return segs;
  }

  /**
   * Se più celle unite formano una parete collineare continua (es. fronte basso),
   * restituisce lunghTot e la catena. Solo la prima cella della catena (più a sn / più in basso) è owner.
   * Popola anche angoliDaCanc (per disegnaAngolo / disegnaAngolariVert2) quando calcAngoliDaCanc.
   */
  risolviPareteContinuaUnite(
    latoCella: string,
    lunghLatoDefault: number,
    cellaDati: any,
    config: any,
  ): { skip: boolean; lunghLato: number; celleUnite: any[] | null } {
    if (!config?.elencoCelle) {
      return { skip: false, lunghLato: lunghLatoDefault, celleUnite: null };
    }

    let chainInfo = this.getCatenaPareteContinua(latoCella, cellaDati, config);
    if (!chainInfo) {
      const calc = this.calcolaCelleUniteSulLato(config, latoCella);
      chainInfo = {
        chain: calc.celleUniteSulLato || [],
        lunghTot: calc.lunghTot || 0,
      };
    }

    const chain = chainInfo.chain || [];
    if (chain.length <= 1) {
      return { skip: false, lunghLato: lunghLatoDefault, celleUnite: null };
    }

    // serve a disegnaAngolariVert2 → disegnaAngolo: salta gli spigoli interni della parete continua
    this.registraAngoliDaCancPareteContinua(config, latoCella, cellaDati, chain, chainInfo.lunghTot);

    // solo la prima cella della catena calcola i pannelli su tutta la lunghezza
    if (chain[0].id != cellaDati.id) {
      return { skip: true, lunghLato: 0, celleUnite: chain };
    }
    return { skip: false, lunghLato: chainInfo.lunghTot || lunghLatoDefault, celleUnite: chain };
  }

  /** Registra catena continua in angoliDaCanc (usato da disegnaAngolo nel viewer). */
  registraAngoliDaCancPareteContinua(
    config: any,
    latoCella: string,
    cellaDati: any,
    chain: any[],
    lunghTot: number,
  ): void {
    if (!config?.calcAngoliDaCanc || !chain || chain.length <= 1) {
      return;
    }
    if (!config.angoliDaCanc) {
      config.angoliDaCanc = [];
    }
    // una sola entry per lato+owner (evita duplicati dal passaggio calcAngoliDaCanc)
    const ownerId = chain[0].id;
    const already = config.angoliDaCanc.some(
      (a: any) => a.lato === latoCella && a.id == ownerId && (a.celleUniteSulLato?.length || 0) === chain.length,
    );
    if (already) {
      return;
    }
    config.angoliDaCanc.push({
      id: ownerId,
      celleUniteSulLato: chain,
      lunghTot,
      lato: latoCella,
    });
  }

  /**
   * Catena di celle collineari sul lato (diagramma se disponibile, altrimenti elencoCelle):
   * fronte: stesso bottom, x2 ≈ x1 successivo, unite su sn/ds.
   */
  getCatenaPareteContinua(
    latoCella: string,
    cellaDati: any,
    config: any,
  ): { chain: any[]; lunghTot: number } | null {
    if (!cellaDati?.id) {
      return null;
    }
    const eps = 3;
    const isOrizz = latoCella === 'lato_fronte' || latoCella === 'lato_retro';

    type Edge = {
      id: any;
      left: number;
      right: number;
      top: number;
      bottom: number;
      width: number;
      height: number;
      ortho: number;
      lungh: number;
    };

    const edges: Edge[] = [];

    const pushEdge = (id: any, left: number, right: number, top: number, bottom: number) => {
      const width = right - left;
      const height = bottom - top;
      if (width <= 0 || height <= 0) {
        return;
      }
      let ortho = 0;
      let lungh = 0;
      if (latoCella === 'lato_fronte') {
        ortho = bottom;
        lungh = width;
      } else if (latoCella === 'lato_retro') {
        ortho = top;
        lungh = width;
      } else if (latoCella === 'lato_sn') {
        ortho = left;
        lungh = height;
      } else if (latoCella === 'lato_ds') {
        ortho = right;
        lungh = height;
      } else {
        return;
      }
      edges.push({ id, left, right, top, bottom, width, height, ortho, lungh });
    };

    // 1) preferisci rettangoli diagramma
    let fromDiagram = false;
    if (this.diagram?.nodes) {
      (this.diagram as Diagram).nodes.forEach((node: any) => {
        if (node?.addInfo?.type !== 'cella' || node.addInfo?.id == null) {
          return;
        }
        const r = this.getDiagramRectCella(node.addInfo.id);
        if (!r) {
          return;
        }
        fromDiagram = true;
        pushEdge(node.addInfo.id, r.left, r.right, r.top, r.bottom);
      });
    }

    // 2) fallback: elencoCelle (model-viewer senza diagram)
    if (!fromDiagram && config?.elencoCelle) {
      config.elencoCelle.forEach((cel: any) => {
        if (cel?.id == null || cel.ingombroX == null || cel.ingombroY == null) {
          return;
        }
        const left = Math.round(cel.offsetX - cel.ingombroX / 2);
        const right = Math.round(cel.offsetX + cel.ingombroX / 2);
        const top = Math.round(cel.offsetY - cel.ingombroY / 2);
        const bottom = Math.round(cel.offsetY + cel.ingombroY / 2);
        pushEdge(cel.id, left, right, top, bottom);
      });
    }

    if (edges.length === 0) {
      return null;
    }

    const curr = edges.find((e) => e.id == cellaDati.id);
    if (!curr) {
      return null;
    }

    const overlap1D = (a1: number, a2: number, b1: number, b2: number): boolean => {
      const a = Math.max(a1, b1);
      const b = Math.min(a2, b2);
      return b - a > 0.5;
    };

    const findUniteLink = (idA: any, idB: any): any => {
      const cella = (config?.elencoCelle || []).find((c: any) => c.id == idA);
      return (
        cella?.celleCollegate?.find(
          (c: any) =>
            c.attivo === true &&
            c.tipoCollegamento === 'unite' &&
            c.cellaCollegataId == idB,
        ) || null
      );
    };

    /** True se la cella ha un divisorio attivo proprio su questo lato (niente prolungamento continua). */
    const hasDivisorioSuLato = (cellId: any): boolean => {
      const cella = (config?.elencoCelle || []).find((c: any) => c.id == cellId);
      return !!(cella?.celleCollegate || []).some(
        (c: any) =>
          c.attivo === true &&
          c.tipoCollegamento === 'collegateDivisorio' &&
          c.latocollegato === latoCella,
      );
    };

    /**
     * Lato visibile (parete esterna) vs fittizio.
     * Solo collegamento `unite` rende il lato fittizio / candidabile a parete continua.
     * `combinate` / `collegateDivisorio` restano lati visibili (niente parete unica).
     */
    const isLatoVisibile = (e: Edge): boolean => {
      for (const o of edges) {
        if (o.id == e.id) {
          continue;
        }
        const linkedUnite =
          findUniteLink(e.id, o.id) || findUniteLink(o.id, e.id);
        if (!linkedUnite) {
          continue;
        }
        if (latoCella === 'lato_ds') {
          if (Math.abs(o.left - e.right) <= eps && overlap1D(e.top, e.bottom, o.top, o.bottom)) {
            return false;
          }
        } else if (latoCella === 'lato_sn') {
          if (Math.abs(o.right - e.left) <= eps && overlap1D(e.top, e.bottom, o.top, o.bottom)) {
            return false;
          }
        } else if (latoCella === 'lato_fronte') {
          if (Math.abs(o.top - e.bottom) <= eps && overlap1D(e.left, e.right, o.left, o.right)) {
            return false;
          }
        } else if (latoCella === 'lato_retro') {
          if (Math.abs(o.bottom - e.top) <= eps && overlap1D(e.left, e.right, o.left, o.right)) {
            return false;
          }
        }
      }
      return true;
    };

    // Se il lato corrente è fittizio (unite adiacente), non cerca parete continua su questo lato
    if (!isLatoVisibile(curr)) {
      return { chain: [{ id: curr.id, edge: curr }], lunghTot: Math.round(curr.lungh) };
    }

    // Solo celle allineate IL CUI stesso lato è ancora visibile (non fittizio unite)
    const sameOrtho = edges.filter(
      (e) => Math.abs(e.ortho - curr.ortho) <= eps && isLatoVisibile(e),
    );
    if (sameOrtho.length <= 1) {
      return { chain: [{ id: curr.id, edge: curr }], lunghTot: Math.round(curr.lungh) };
    }

    const areUniteNeighbors = (ea: Edge, eb: Edge): boolean => {
      // prosecuzione solo se entrambi i lati sono visibili (già filtrati in sameOrtho)
      if (!isLatoVisibile(ea) || !isLatoVisibile(eb)) {
        return false;
      }
      // se il prosieguo (o il lato corrente) ha un divisorio su questo lato → niente parete unica
      if (hasDivisorioSuLato(ea.id) || hasDivisorioSuLato(eb.id)) {
        return false;
      }
      const linkAB = findUniteLink(ea.id, eb.id);
      const linkBA = findUniteLink(eb.id, ea.id);
      if (!linkAB && !linkBA) {
        return false;
      }
      if (isOrizz) {
        const touch =
          Math.abs(ea.right - eb.left) <= eps || Math.abs(eb.right - ea.left) <= eps;
        if (!touch) {
          return false;
        }
        const ok = (l: any) => !l || l.latocollegato === 'lato_sn' || l.latocollegato === 'lato_ds';
        return ok(linkAB) && ok(linkBA);
      }
      const touch =
        Math.abs(ea.top - eb.bottom) <= eps || Math.abs(eb.top - ea.bottom) <= eps;
      if (!touch) {
        return false;
      }
      const ok = (l: any) => !l || l.latocollegato === 'lato_fronte' || l.latocollegato === 'lato_retro';
      return ok(linkAB) && ok(linkBA);
    };

    let sorted: Edge[];
    if (isOrizz) {
      sorted = [...sameOrtho].sort((x, y) => x.left - y.left);
    } else {
      sorted = [...sameOrtho].sort((x, y) => y.bottom - x.bottom);
    }

    const idxCurr = sorted.findIndex((e) => e.id == curr.id);
    if (idxCurr < 0) {
      return null;
    }

    let start = idxCurr;
    let end = idxCurr;
    while (start > 0 && areUniteNeighbors(sorted[start - 1], sorted[start])) {
      start--;
    }
    while (end < sorted.length - 1 && areUniteNeighbors(sorted[end], sorted[end + 1])) {
      end++;
    }

    const chainEdges = sorted.slice(start, end + 1);
    const lunghTot = Math.round(chainEdges.reduce((s, e) => s + e.lungh, 0));
    const chain = chainEdges.map((e) => ({
      id: e.id,
      edge: {
        left: e.left,
        right: e.right,
        top: e.top,
        bottom: e.bottom,
        w: e.width,
        h: e.height,
      },
      p1: {
        x1: e.left,
        x2: e.right,
        y1: e.bottom,
        y2: e.bottom,
        ingombroX: e.width,
        ingombroY: e.height,
      },
    }));

    return { chain, lunghTot };
  }

  /** Blocco angolo 270°: sempre 40 = compensatorio + (spessore+3) → 27+13 oppure 31+9. */
  getBloccoAngolo270(): number {
    return 40;
  }

  /** 31 per spessore 6, 27 per spessore 10 (e simili). 0 se non applicabile. */
  getLarghezzaPannelloCompensatorio(spessore: number): number {
    if (spessore == null || spessore === 13) {
      return 0;
    }
    return spessore === 6 ? 31 : 27;
  }

  /**
   * Riempie un tratto libero con pannello compensatorio su angolo 270° (celle unite).
   * Blocco 40 = compensatorio (27/31) + fittizio (sp+3).
   * Ordine sul tratto libero:
   * - inizio: fittizio 9/13 POI compensatorio 27/31
   * - fine:   compensatorio 27/31 POI fittizio 9/13
   * Se lo (sp+3) è già sul fittizio di contatto (`spPiu3SuFittizio*`): solo 27/31
   * sul libero, budget comunque 40.
   * `treVie`: true se il tratto fa parte di un divisorio.
   */
  insertPannelliLatoConCompenso270(
    len: number,
    latoPannello: string,
    objLato: any,
    altezza: number,
    cellaDati: any,
    angoloStart: boolean,
    angoloEnd: boolean,
    spPiu3SuFittizioStart = false,
    spPiu3SuFittizioEnd = false,
    treVie = false,
  ): void {
    if (len <= 0) {
      return;
    }
    const pannello = this.getLarghezzaPannelloCompensatorio(cellaDati.spessore);
    if (!pannello || (!angoloStart && !angoloEnd)) {
      this.insertPannelliLato(len, latoPannello, objLato, altezza, false, treVie);
      return;
    }
    const blocco40 = this.getBloccoAngolo270(); // 40
    const spPiu3 = blocco40 - pannello;

    // Inizio tratto: (sp+3) prima del compensatorio; fine: (sp+3) dopo.
    // skipFollow = (sp+3) già sul pezzo fittizio di contatto unite.
    const insertCompensoStart = (skipFollow: boolean) => {
      if (!skipFollow && spPiu3 > 0) {
        this.insertPannelliLato(spPiu3, latoPannello, objLato, altezza, true, treVie);
      }
      this.insertPannello(objLato, latoPannello, pannello, altezza, false, treVie);
    };
    const insertCompensoEnd = (skipFollow: boolean) => {
      this.insertPannello(objLato, latoPannello, pannello, altezza, false, treVie);
      if (!skipFollow && spPiu3 > 0) {
        this.insertPannelliLato(spPiu3, latoPannello, objLato, altezza, true, treVie);
      }
    };

    if (len < blocco40) {
      if (len >= pannello) {
        if (angoloStart) {
          if (!spPiu3SuFittizioStart && spPiu3 > 0 && len > pannello) {
            const gap = Math.min(spPiu3, len - pannello);
            this.insertPannelliLato(gap, latoPannello, objLato, altezza, true, treVie);
            this.insertPannello(objLato, latoPannello, pannello, altezza, false, treVie);
            const rest = len - pannello - gap;
            if (rest > 0) {
              this.insertPannelliLato(rest, latoPannello, objLato, altezza, false, treVie);
            }
          } else {
            insertCompensoStart(spPiu3SuFittizioStart);
            const rest = len - pannello;
            if (rest > 0) {
              this.insertPannelliLato(rest, latoPannello, objLato, altezza, false, treVie);
            }
          }
        } else {
          const rest = len - pannello;
          if (rest > 0) {
            this.insertPannelliLato(rest, latoPannello, objLato, altezza, false, treVie);
          }
          insertCompensoEnd(spPiu3SuFittizioEnd);
        }
      } else {
        this.insertPannelliLato(len, latoPannello, objLato, altezza, false, treVie);
      }
      return;
    }

    // Budget sempre 40 per angolo: se skipFollow lo (sp+3) sta sul fittizio adiacente.
    if (angoloStart && angoloEnd) {
      const mid = len - 2 * blocco40;
      insertCompensoStart(spPiu3SuFittizioStart);
      if (mid > 0) {
        this.insertPannelliLato(mid, latoPannello, objLato, altezza, false, treVie);
      }
      insertCompensoEnd(spPiu3SuFittizioEnd);
      return;
    }
    if (angoloStart) {
      insertCompensoStart(spPiu3SuFittizioStart);
      const rest = len - blocco40;
      if (rest > 0) {
        this.insertPannelliLato(rest, latoPannello, objLato, altezza, false, treVie);
      }
      return;
    }
    // angoloEnd
    const rest = len - blocco40;
    if (rest > 0) {
      this.insertPannelliLato(rest, latoPannello, objLato, altezza, false, treVie);
    }
    insertCompensoEnd(spPiu3SuFittizioEnd);
  }

  /**
   * Lunghezza fittizio di contatto: il pezzo geometrico resta multiplo di 20 (riempiLato);
   * i (spessore+3) del blocco 40 si aggiungono come pezzi fittizi separati (9/13).
   */
  insertPannelliLatoFittizioConBlocco40(
    lenGeometrico: number,
    latoPannello: string,
    objLato: any,
    altezza: number,
    cellaDati: any,
    conCompensoPrima: boolean,
    conCompensoDopo: boolean,
  ): void {
    const pannello = this.getLarghezzaPannelloCompensatorio(cellaDati.spessore);
    const spPiu3 = pannello ? cellaDati.spessore + 3 : 0; // 9 o 13 (= 40 - compensatorio)

    // come se al posto del compensatorio ci fosse un pannello da 40:
    // i (sp+3) entrano nel fittizio come pezzo dedicato (evita 109/113 su riempiLato)
    if (conCompensoPrima && spPiu3 > 0) {
      this.insertPannelliLato(spPiu3, latoPannello, objLato, altezza, true);
    }
    if (lenGeometrico > 0) {
      this.insertPannelliLato(lenGeometrico, latoPannello, objLato, altezza, true);
    }
    if (conCompensoDopo && spPiu3 > 0) {
      this.insertPannelliLato(spPiu3, latoPannello, objLato, altezza, true);
    }
  }

  /**
   * Estremi di un lato che formano angolo 270° perché la cella è la corta
   * sul lato perpendicolare (contatto unite O divisorio con cella più lunga).
   * Esclude i giunti di parete continua (es. fronte comune in basso: niente spigolo).
   * fronte/retro: start=sn, end=ds; laterali (dal basso): start=fronte, end=retro.
   */
  getAngoli270DaCellaCorta(
    latoCella: string,
    cellaDati: any,
    covers: Map<string, Record<string, { a: number; b: number; lunghAltra: number }[]>> | null,
    config: any = null,
  ): { start: boolean; end: boolean } {
    if (!cellaDati) {
      return { start: false, end: false };
    }
    const cellCovers = covers?.get(cellaDati.id) || {};
    // corta su unite (covers)
    const isCortaUnite = (lato: string, lungh: number): boolean => {
      const arr = cellCovers[lato] || [];
      return arr.some((c) => lungh < c.lunghAltra);
    };
    // corta su divisorio VERTICALE (sn/ds): solo se la grande ha il lato tutto a contatto (T).
    // Divisorio ORIZZONTALE non deve creare compensatori sui laterali (sn/ds).
    const isCortaDivisorio = (lato: string): boolean => {
      if (lato !== 'lato_sn' && lato !== 'lato_ds') {
        return false;
      }
      const links = (cellaDati.celleCollegate || []).filter(
        (x: any) =>
          x.attivo &&
          x.tipoCollegamento === 'collegateDivisorio' &&
          x.latocollegato === lato,
      );
      return links.some((link: any) => {
        if (!this.cellaPossiedeTreVieDivisorio(link, cellaDati, config)) {
          return false;
        }
        const other = (config?.elencoCelle || []).find((c: any) => c.id == link.cellaCollegataId);
        if (!other) {
          return false;
        }
        const latoGrande = this.oppositeLatoCella(lato);
        const lunghGrande =
          latoGrande === 'lato_sn' || latoGrande === 'lato_ds'
            ? other.ingombroY || 0
            : other.ingombroX || 0;
        if (lunghGrande <= 0) {
          return false;
        }
        const contattiGrande = this.getContattiDivisorioCompensoSuLato(
          latoGrande,
          other,
          config,
          lunghGrande,
        );
        return this.divisorioCopreInteroLato(contattiGrande, lunghGrande);
      });
    };
    const isCorta = (lato: string, lungh: number): boolean =>
      isCortaUnite(lato, lungh) || isCortaDivisorio(lato);

    const rect = this.getDiagramRectCella(cellaDati?.id);
    const lunghFR = rect ? Math.round(rect.width) : Math.round(cellaDati.ingombroX || 0);
    const lunghLat = rect ? Math.round(rect.height) : Math.round(cellaDati.ingombroY || 0);

    let startCorta = false;
    let endCorta = false;
    let cornerStart = '';
    let cornerEnd = '';

    if (latoCella === 'lato_fronte') {
      startCorta = isCorta('lato_sn', lunghLat);
      endCorta = isCorta('lato_ds', lunghLat);
      cornerStart = '0';
      cornerEnd = 'd';
    } else if (latoCella === 'lato_retro') {
      startCorta = isCorta('lato_sn', lunghLat);
      endCorta = isCorta('lato_ds', lunghLat);
      cornerStart = 'w';
      cornerEnd = 'wd';
    } else if (latoCella === 'lato_sn') {
      startCorta = isCorta('lato_fronte', lunghFR);
      endCorta = isCorta('lato_retro', lunghFR);
      cornerStart = '0';
      cornerEnd = 'w';
    } else if (latoCella === 'lato_ds') {
      startCorta = isCorta('lato_fronte', lunghFR);
      endCorta = isCorta('lato_retro', lunghFR);
      cornerStart = 'd';
      cornerEnd = 'wd';
    }

    const ok = (corta: boolean, posAng: string): boolean =>
      corta &&
      !(config && this.angoloSuGiuntoPareteContinua(posAng, config, cellaDati));

    return {
      start: ok(startCorta, cornerStart),
      end: ok(endCorta, cornerEnd),
    };
  }

  /**
   * Confine normale/fittizio sul lato lungo unite: compensatorio dove il contatto
   * lascia uno spigolo 270° (adiacente a un tratto normale — già filtrato dal caller).
   * Su fronte/retro (contatto orizzontale) entrambi i capi (sn e ds) possono essere step;
   * sui laterali vale lo stesso se la corta è allineata in alto o in basso.
   */
  isCompenso270ConfineFittizio(
    latoCella: string,
    confineCoord: number,
    lunghLato: number,
    cellaDati: any,
    covers: Map<string, Record<string, { a: number; b: number; lunghAltra: number }[]>> | null,
  ): boolean {
    const cellCovers = covers?.get(cellaDati?.id)?.[latoCella] || [];
    const eps = 0.5;
    for (const c of cellCovers) {
      if (lunghLato <= c.lunghAltra) {
        continue;
      }
      // entrambi i capi del tratto di contatto: sn/ds su fronte-retro, fronte/retro sui laterali
      if (Math.abs(confineCoord - c.a) <= eps || Math.abs(confineCoord - c.b) <= eps) {
        return true;
      }
    }
    return false;
  }

  /**
   * Celle unite con lato collineare, ma sul vicino quel lato ha un divisorio
   * (niente parete continua): questa cella chiude il proprio lato con compensatorio
   * 27/31 verso il vicino (start=sn/fronte, end=ds/retro).
   */
  getCompensoTerminePerDivisorioSuVicinoUnite(
    latoCella: string,
    cellaDati: any,
    config: any,
  ): { start: boolean; end: boolean } {
    const out = { start: false, end: false };
    if (!cellaDati || !config) {
      return out;
    }
    const perp =
      latoCella === 'lato_fronte' || latoCella === 'lato_retro'
        ? ['lato_sn', 'lato_ds']
        : ['lato_fronte', 'lato_retro'];
    const uniteLinks = (cellaDati.celleCollegate || []).filter(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'unite' &&
        perp.includes(x.latocollegato),
    );
    for (const link of uniteLinks) {
      const other = (config.elencoCelle || []).find(
        (c: any) => c.id == link.cellaCollegataId,
      );
      if (!other) {
        continue;
      }
      const otherHasDivSuLato = (other.celleCollegate || []).some(
        (x: any) =>
          x.attivo &&
          x.tipoCollegamento === 'collegateDivisorio' &&
          x.latocollegato === latoCella,
      );
      if (!otherHasDivSuLato) {
        continue;
      }
      if (latoCella === 'lato_fronte' || latoCella === 'lato_retro') {
        if (link.latocollegato === 'lato_sn') {
          out.start = true;
        }
        if (link.latocollegato === 'lato_ds') {
          out.end = true;
        }
      } else {
        if (link.latocollegato === 'lato_fronte') {
          out.start = true;
        }
        if (link.latocollegato === 'lato_retro') {
          out.end = true;
        }
      }
    }
    return out;
  }

  /**
   * Compensatorio divisorio: sulla cella PIÙ GRANDE, sul lato del divisorio.
   * Uguali o più piccola → no.
   */
  cellaPossiedeCompensoDivisorio(link: any, cella: any, config: any): boolean {
    const other = (config?.elencoCelle || []).find((c: any) => c.id == link.cellaCollegataId);
    if (!other) {
      return false;
    }
    const lato = link.latocollegato;
    const lunghThis =
      lato === 'lato_sn' || lato === 'lato_ds' ? cella.ingombroY || 0 : cella.ingombroX || 0;
    const dimOther =
      lato === 'lato_sn' || lato === 'lato_ds' ? other.ingombroY || 0 : other.ingombroX || 0;
    return lunghThis > dimOther;
  }

  /**
   * Intervalli di contatto divisorio sul lato (coord. locali: laterali dal basso, FR da sn).
   * Usati per: owner (latocombinato) disegna la parete unica; l'altra cella salta il tratto.
   * Contatti verso celle unite tra loro (ortogonali) → un solo intervallo complessivo.
   */
  getContattiDivisorioSuLato(
    latoCella: string,
    cellaDati: any,
    config: any,
    lunghLato: number,
  ): { a: number; b: number }[] {
    if (!cellaDati || !config || lunghLato <= 0) {
      return [];
    }
    const links = (cellaDati.celleCollegate || []).filter(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'collegateDivisorio' &&
        x.latocollegato === latoCella,
    );
    const raw: { a: number; b: number; otherId: any }[] = [];
    links.forEach((link: any) => {
      const other = (config.elencoCelle || []).find((c: any) => c.id == link.cellaCollegataId);
      const dimOther = other
        ? latoCella === 'lato_sn' || latoCella === 'lato_ds'
          ? other.ingombroY || 0
          : other.ingombroX || 0
        : 0;
      const a = Math.max(0, link.distLato || 0);
      const span =
        link.larghezza > 0 ? link.larghezza : dimOther > 0 ? dimOther : Math.max(0, lunghLato - a);
      const b = Math.min(lunghLato, a + span);
      if (b > a + 0.5) {
        raw.push({ a, b, otherId: link.cellaCollegataId });
      }
    });
    return this.fondiContattiDivisorioCelleUnite(raw, latoCella, config, lunghLato);
  }

  /**
   * Contatti divisorio solo se questa cella è più grande (per compensatori sui tratti liberi).
   * Celle uguali → []. Contatti verso celle unite → un solo intervallo complessivo.
   */
  getContattiDivisorioCompensoSuLato(
    latoCella: string,
    cellaDati: any,
    config: any,
    lunghLato: number,
  ): { a: number; b: number }[] {
    if (!cellaDati || !config || lunghLato <= 0) {
      return [];
    }
    const links = (cellaDati.celleCollegate || []).filter(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'collegateDivisorio' &&
        x.latocollegato === latoCella &&
        this.cellaPossiedeCompensoDivisorio(x, cellaDati, config),
    );
    const raw: { a: number; b: number; otherId: any }[] = [];
    links.forEach((link: any) => {
      const other = (config.elencoCelle || []).find((c: any) => c.id == link.cellaCollegataId);
      const dimOther = other
        ? latoCella === 'lato_sn' || latoCella === 'lato_ds'
          ? other.ingombroY || 0
          : other.ingombroX || 0
        : 0;
      const a = Math.max(0, link.distLato || 0);
      const span =
        link.larghezza > 0 ? link.larghezza : dimOther > 0 ? dimOther : Math.max(0, lunghLato - a);
      const b = Math.min(lunghLato, a + span);
      if (b > a + 0.5) {
        raw.push({ a, b, otherId: link.cellaCollegataId });
      }
    });
    return this.fondiContattiDivisorioCelleUnite(raw, latoCella, config, lunghLato);
  }

  /**
   * Se più contatti divisorio sullo stesso lato puntano a celle unite tra loro
   * (ortogonalmente, tipoCollegamento === 'unite'), li fonde in un unico tratto.
   * Altrimenti restano separati — anche se adiacenti.
   */
  fondiContattiDivisorioCelleUnite(
    raw: { a: number; b: number; otherId: any }[],
    latoCella: string,
    config: any,
    lunghLato: number,
  ): { a: number; b: number }[] {
    if (!raw.length) {
      return [];
    }
    const elenco = config?.elencoCelle || [];
    type Item = { a: number; b: number; otherIds: any[] };
    const items: Item[] = raw
      .map((r) => ({ a: r.a, b: r.b, otherIds: [r.otherId] }))
      .sort((x, y) => x.a - y.a);

    const pairUnite = (idsA: any[], idsB: any[]): boolean => {
      for (const idA of idsA) {
        for (const idB of idsB) {
          const ca = elenco.find((c: any) => c.id == idA);
          const cb = elenco.find((c: any) => c.id == idB);
          if (this.sonoUniteOrtogonaliAlLato(ca, cb, latoCella)) {
            return true;
          }
        }
      }
      return false;
    };

    for (let i = 1; i < items.length; ) {
      const prev = items[i - 1];
      const cur = items[i];
      // Unisce SOLO se le celle collegate sono unite ortogonalmente.
      // Adiacenti senza unite restano contatti separati (con eventuale T).
      if (pairUnite(prev.otherIds, cur.otherIds)) {
        prev.b = Math.max(prev.b, cur.b);
        prev.a = Math.min(prev.a, cur.a);
        prev.otherIds = [...prev.otherIds, ...cur.otherIds];
        items.splice(i, 1);
      } else {
        i++;
      }
    }

    return items.map((it) => ({
      a: Math.max(0, it.a),
      b: Math.min(lunghLato, it.b),
    }));
  }

  /**
   * Punti sul lato (cella più grande) dove serve pannello compensatorio 27/31:
   * - confini libero ↔ contatto (divisorio parziale su quel lato)
   * - giunto T tra due contatti adiacenti (celle NON unite): ogni contatto è
   *   parziale rispetto all'altra cella → il pannello al giunto va tenuto anche se
   *   l'unione dei contatti copre tutto il lato
   * - contatti verso celle unite → già fusi in un unico tratto: niente T al giunto
   * - un solo contatto a tutta lunghezza → nessun compensatorio
   */
  getPuntiCompensoDivisorioSuLato(
    latoCella: string,
    cellaDati: any,
    config: any,
    lunghLato: number,
  ): number[] {
    const contatti = this.getContattiDivisorioCompensoSuLato(latoCella, cellaDati, config, lunghLato);
    if (!contatti.length) {
      return [];
    }
    const eps = 0.5;
    const pts: number[] = [];
    const add = (p: number) => {
      if (p <= eps || p >= lunghLato - eps) {
        return;
      }
      if (!pts.some((x) => Math.abs(x - p) <= eps)) {
        pts.push(p);
      }
    };
    // contatti già fusi se celle unite → merge semplice senza T al giunto
    const merged = contatti.map((c) => ({ a: c.a, b: c.b })).sort((x, y) => x.a - y.a);
    for (let i = 1; i < merged.length; ) {
      if (merged[i].a <= merged[i - 1].b + eps) {
        // T solo se non erano già un unico contatto (celle non-unite adiacenti)
        // Dopo fondiContattiDivisorioCelleUnite i tratti unite sono già uno solo,
        // quindi qui restano solo giunti tra contatti verso celle NON unite → T sì
        add(merged[i - 1].b);
        merged[i - 1].b = Math.max(merged[i - 1].b, merged[i].b);
        merged.splice(i, 1);
      } else {
        i++;
      }
    }
    // un solo contatto che copre tutto e nessun T → niente
    if (
      merged.length === 1 &&
      merged[0].a <= eps &&
      merged[0].b >= lunghLato - eps &&
      pts.length === 0
    ) {
      return [];
    }
    // giunti libero ↔ contatto (prima o dopo il divisorio, stesso lato)
    merged.forEach((c) => {
      if (c.a > eps) {
        add(c.a);
      }
      if (c.b < lunghLato - eps) {
        add(c.b);
      }
    });
    return pts.sort((x, y) => x - y);
  }

  /** True se l'unione dei contatti copre l'intero lato [0, lunghLato]. */
  divisorioCopreInteroLato(contatti: { a: number; b: number }[], lunghLato: number): boolean {
    if (!contatti.length || lunghLato <= 0) {
      return false;
    }
    const eps = 0.5;
    const merged = [...contatti].sort((x, y) => x.a - y.a);
    for (let i = 1; i < merged.length; ) {
      if (merged[i].a <= merged[i - 1].b + eps) {
        merged[i - 1].b = Math.max(merged[i - 1].b, merged[i].b);
        merged.splice(i, 1);
      } else {
        i++;
      }
    }
    return merged.length === 1 && merged[0].a <= eps && merged[0].b >= lunghLato - eps;
  }

  /**
   * True se su `latoDiv` questa cella è più grande di almeno un vicino divisorio
   * (è lei che crea compensatori su liberi/T di quel lato).
   */
  cellaEGrandeSuLatoDivisorio(cellaDati: any, latoDiv: string, config: any): boolean {
    return (cellaDati?.celleCollegate || []).some(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'collegateDivisorio' &&
        x.latocollegato === latoDiv &&
        this.cellaPossiedeCompensoDivisorio(x, cellaDati, config),
    );
  }

  /**
   * Regola lato opposto (in costruzione del lato corrente):
   * se il lato OPPOSITO ha un divisorio che lo occupa tutto E in quel divisorio
   * c'è già un compensatorio (nel divisorio, non sul libero della cella grande)
   * → stessi punti sul lato corrente.
   * Es. cella sotto a destra con solo contatto parziale sulla lunga: il compensatorio
   * sta sul libero della lunga → niente specchio sul basso della cella corta.
   */
  getPuntiCompensoSpecchioLatoOpposto(
    latoCella: string,
    cellaDati: any,
    config: any,
    lunghLato: number,
  ): number[] {
    const latoDiv = this.oppositeLatoCella(latoCella);
    if (!latoDiv || !cellaDati || !config || lunghLato <= 0) {
      return [];
    }
    const Ldiv = this.lunghLatoCella(cellaDati, latoDiv);
    if (Ldiv <= 0) {
      return [];
    }
    const contattiDiv = this.getContattiDivisorioSuLato(latoDiv, cellaDati, config, Ldiv);
    if (!this.divisorioCopreInteroLato(contattiDiv, Ldiv)) {
      return [];
    }
    // grande sul divisorio → pannelli solo lì, non sul lato che stiamo costruendo
    if (this.cellaEGrandeSuLatoDivisorio(cellaDati, latoDiv, config)) {
      return [];
    }
    // solo punti NEL divisorio (lato opposto), non sul lato corrente
    const fromDiv = this.getPuntiCompensoDaRegistro(cellaDati.id, latoDiv);
    if (fromDiv.length) {
      return fromDiv;
    }
    return this.collectCompensoDaGrandeSuContatto(cellaDati, latoDiv, config, Ldiv);
  }

  /**
   * @deprecated sostituito dal registro multi-passata (prepareCompensoDivisorioRegistry).
   */
  getPuntiCompensoStessoCellaLatoOpposto(
    _latoCella: string,
    _cellaDati: any,
    _config: any,
    _lunghLato: number,
  ): number[] {
    return [];
  }

  /**
   * Tratti liberi sul lato divisorio della cella più grande (fuori dal contatto).
   * Compensatorio al confine col divisorio (angolo sul tratto successivo al punto).
   */
  getTrattiLiberiDivisorioConCompenso(
    latoCella: string,
    cellaDati: any,
    config: any,
    lunghLato: number,
  ): { a: number; b: number; angoloStart: boolean; angoloEnd: boolean }[] {
    const contatti = this.getContattiDivisorioCompensoSuLato(latoCella, cellaDati, config, lunghLato);
    if (!contatti.length) {
      return [];
    }
    const punti = this.getPuntiCompensoDivisorioSuLato(latoCella, cellaDati, config, lunghLato);
    // merge contatti (unione geometrica)
    const merged = [...contatti].sort((x, y) => x.a - y.a);
    for (let i = 1; i < merged.length; ) {
      if (merged[i].a <= merged[i - 1].b + 0.5) {
        merged[i - 1].b = Math.max(merged[i - 1].b, merged[i].b);
        merged.splice(i, 1);
      } else {
        i++;
      }
    }
    const eps = 0.5;
    const free: { a: number; b: number; angoloStart: boolean; angoloEnd: boolean }[] = [];
    let cursor = 0;
    merged.forEach((c) => {
      if (c.a > cursor + eps) {
        free.push({
          a: cursor,
          b: c.a,
          angoloStart: punti.some((p) => Math.abs(p - cursor) <= eps),
          angoloEnd: punti.some((p) => Math.abs(p - c.a) <= eps),
        });
      }
      cursor = Math.max(cursor, c.b);
    });
    if (cursor < lunghLato - eps) {
      free.push({
        a: cursor,
        b: lunghLato,
        angoloStart: punti.some((p) => Math.abs(p - cursor) <= eps),
        angoloEnd: false,
      });
    }
    return free.filter((t) => t.b - t.a > eps);
  }

  /** @deprecated usata solo come start/end a filo lato; preferire getTrattiLiberiDivisorioConCompenso */
  getAngoliTreVieDivisorioSuLato(
    latoCella: string,
    cellaDati: any,
    config: any,
  ): { start: boolean; end: boolean } {
    return { start: false, end: false };
  }

  /**
   * Riempie un lato intercalando porte; sui tratti unite usa i covers dei bordi.
   * Se config indica una parete collineare continua, i pannelli sono su lunghTot (owner only).
   * Su tratti liberi che finiscono/iniziano su angolo 270°: pannello compensatorio 27/31.
   */
  insertPannelliLatoConPorte2(
    latoCella: string,
    latoPannello: string,
    objLato: any,
    lunghLatoDefault: number,
    altezza: number,
    cellaDati: any,
    covers: Map<string, Record<string, { a: number; b: number; lunghAltra: number }[]>> | null = null,
    config: any = null,
  ): void {
    // Divisorio: solo la cella più grande disegna i pannelli sul lato collegato.
    // L'altra lascia pannelli=[] (niente spacer fittizi).
    const hasDivSuLato = (cellaDati?.celleCollegate || []).some(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'collegateDivisorio' &&
        x.latocollegato === latoCella,
    );
    if (
      hasDivSuLato &&
      config &&
      !this.cellaPossiedePareteDivisorioSuLato(cellaDati, latoCella, config)
    ) {
      objLato.pannelli = [];
      objLato.fittizio = true;
      return;
    }

    // Set accoppiamento (combinate): la cella senza pavimento ha latocombinato=false
    // e deve perdere la parete sul contatto; l'altra (con pavimento) la mantiene.
    const hasCombinateSenzaParete = (cellaDati?.celleCollegate || []).some(
      (x: any) =>
        x.attivo &&
        x.tipoCollegamento === 'combinate' &&
        x.latocollegato === latoCella &&
        !x.latocombinato,
    );
    if (hasCombinateSenzaParete) {
      objLato.pannelli = [];
      objLato.fittizio = true;
      return;
    }

    const continuo = this.risolviPareteContinuaUnite(latoCella, lunghLatoDefault, cellaDati, config);
    if (continuo.skip) {
      return;
    }
    const lunghLato = continuo.lunghLato;
    const celleUnite = continuo.celleUnite;

    const segmenti = this.getSegmentiLatoConUnite(cellaDati, latoCella, lunghLato, covers);

    if (segmenti.length === 0 || segmenti.every((s) => s.tipo === 'salta')) {
      return;
    }

    // porte + freeblock (come getObj / getElementiLato): stessi gap, pannello dedicato in posizione
    type ElemLato = { distanzaSn: number; larghezza: number; porta?: any; fb?: any };
    let elementi: ElemLato[];

    if (celleUnite && celleUnite.length > 1 && config) {
      elementi = this.getElementiLato(latoCella, config, cellaDati, null, celleUnite)
        .filter((el: any) => el.porta || el.fb)
        .map((el: any) => ({
          porta: el.porta,
          fb: el.fb,
          distanzaSn: el.distanzaSn || 0,
          larghezza: el.larghezza || 0,
        }))
        .sort((a: any, b: any) => a.distanzaSn - b.distanzaSn);
    } else {
      elementi = (cellaDati.elencoPorte || [])
        .filter((p: any) => !p.portaDivisorio && p.lato_porta === latoCella)
        .map((p: any) => {
          let distanzaSn = p.distSnPorta || 0;
          const larghezza = p.larghporta || 0;
          if (distanzaSn + larghezza > lunghLato) {
            distanzaSn = distanzaSn - (distanzaSn + larghezza - lunghLato);
          }
          return { porta: p, distanzaSn, larghezza } as ElemLato;
        });

      (config?.elencoFreeBlocks || [])
        .filter((x: any) => x.cellaId == cellaDati.id && x.lato === latoCella)
        .forEach((fb: any) => {
          const distanzaSn = fb.distLato || 0;
          const larghezza = fb.width || 0;
          const same = elementi.find((e) => e.distanzaSn === distanzaSn);
          if (same) {
            same.fb = fb;
            if (!same.larghezza && larghezza) {
              same.larghezza = larghezza;
            }
          } else {
            elementi.push({ fb, distanzaSn, larghezza });
          }
        });

      elementi.sort((a, b) => a.distanzaSn - b.distanzaSn);
    }

    const angoliCorta = this.getAngoli270DaCellaCorta(latoCella, cellaDati, covers, config);
    // lato proprio che non prosegue (vicino unite ha divisorio su questo lato) → compensatorio in chiusura
    const compensoDivUnite = this.getCompensoTerminePerDivisorioSuVicinoUnite(
      latoCella,
      cellaDati,
      config,
    );
    const contattiDiv = this.getContattiDivisorioSuLato(latoCella, cellaDati, config, lunghLato);
    // registro: tiene anche i T se l'unione dei contatti è "piena" (non cancellare in passata 2)
    const fromReg =
      contattiDiv.length > 0 ? this.getPuntiCompensoDaRegistro(cellaDati.id, latoCella) : [];
    const puntiCompensoDiv = fromReg.length
      ? fromReg
      : this.getPuntiCompensoDivisorioSuLato(latoCella, cellaDati, config, lunghLato);
    // altri lati: regola opposto solo se divisorio a tutta lunghezza + compensatorio già noto
    const puntiSpecchioOpp =
      contattiDiv.length > 0
        ? []
        : this.getPuntiCompensoSpecchioLatoOpposto(latoCella, cellaDati, config, lunghLato);

    segmenti.forEach((seg, segIdx) => {
      const len = seg.b - seg.a;
      if (len <= 0) {
        return;
      }
      if (seg.tipo === 'salta') {
        return;
      }

      const prev = segIdx > 0 ? segmenti[segIdx - 1] : null;
      const next = segIdx < segmenti.length - 1 ? segmenti[segIdx + 1] : null;

      if (seg.tipo === 'fittizio') {
        // pezzo fittizio: pensa come se al posto del compensatorio ci fosse un pannello da 40
        // → contatto geometrico (multiplo 20) + pezzi (sp+3) separati, non 109/113 su riempiLato
        // blocco 40 ai capi adiacenti a tratto normale (spigolo 270°), non ai giunti a filo 0/lungh
        const conCompensoPrima =
          prev?.tipo === 'normale' &&
          this.isCompenso270ConfineFittizio(latoCella, seg.a, lunghLato, cellaDati, covers);
        const conCompensoDopo =
          next?.tipo === 'normale' &&
          this.isCompenso270ConfineFittizio(latoCella, seg.b, lunghLato, cellaDati, covers);
        this.insertPannelliLatoFittizioConBlocco40(
          len,
          latoPannello,
          objLato,
          altezza,
          cellaDati,
          !!conCompensoPrima,
          !!conCompensoDopo,
        );
        return;
      }

      // divisorio: una sola parete sul contatto — la disegna la cella con latocombinato;
      // l'altra salta. Sul lato lungo (cella più grande): compensatorio 27/31 sui tratti
      // liberi e al giunto T tra due contatti adiacenti (es. 3 celle).
      if (contattiDiv.length > 0 && seg.tipo === 'normale') {
        const possiedePareteDivisorio = this.cellaPossiedePareteDivisorioSuLato(
          cellaDati,
          latoCella,
          config,
        );
        type Sub = { a: number; b: number; contatto: boolean; angoloStart: boolean; angoloEnd: boolean };
        const subs: Sub[] = [];
        const eps = 0.5;
        // merge contatti per classificare i tratti
        const merged = [...contattiDiv].sort((x, y) => x.a - y.a);
        for (let i = 1; i < merged.length; ) {
          if (merged[i].a <= merged[i - 1].b + eps) {
            merged[i - 1].b = Math.max(merged[i - 1].b, merged[i].b);
            merged.splice(i, 1);
          } else {
            i++;
          }
        }
        const cuts: number[] = [seg.a, seg.b];
        const addCut = (p: number) => {
          if (p < seg.a - eps || p > seg.b + eps) {
            return;
          }
          const clamped = Math.max(seg.a, Math.min(seg.b, p));
          if (!cuts.some((x) => Math.abs(x - clamped) <= eps)) {
            cuts.push(clamped);
          }
        };
        merged.forEach((c) => {
          addCut(c.a);
          addCut(c.b);
        });
        puntiCompensoDiv.forEach((p) => addCut(p));
        cuts.sort((x, y) => x - y);

        for (let i = 0; i < cuts.length - 1; i++) {
          const sa = cuts[i];
          const sb = cuts[i + 1];
          if (sb - sa <= eps) {
            continue;
          }
          const mid = (sa + sb) / 2;
          const contatto = merged.some((c) => mid >= c.a && mid < c.b);
          const prevContatto =
            i > 0 ? merged.some((c) => {
              const pmid = (cuts[i - 1] + sa) / 2;
              return pmid >= c.a && pmid < c.b;
            }) : false;
          const atStart = puntiCompensoDiv.some((p) => Math.abs(p - sa) <= eps);
          const atEnd = puntiCompensoDiv.some((p) => Math.abs(p - sb) <= eps);
          // compensatorio sul tratto libero (come 2 celle); se due contatti si toccano (T a 3 celle)
          // sul lato lungo, un compensatorio al giunto sul tratto successivo
          subs.push({
            a: sa,
            b: sb,
            contatto,
            angoloStart: atStart && (!contatto || prevContatto),
            angoloEnd: atEnd && !contatto,
          });
        }

        let anyDrawn = false;
        subs.forEach((sub) => {
          const subLen = sub.b - sub.a;
          if (subLen <= 0) {
            return;
          }
          // contatto: solo la cella owner (latocombinato) disegna la parete = divisorio.
          // Se salta, inserisce comunque uno spacer fittizio così i tratti liberi successivi
          // partono alla quota corretta (altrimenti il libero parte da 0 = spostato).
          if (sub.contatto && !possiedePareteDivisorio) {
            this.insertPannelliLato(subLen, latoPannello, objLato, altezza, true);
            anyDrawn = true;
            return;
          }
          anyDrawn = true;
          // pannelli del tratto di contatto divisorio → treVie=true
          const treVie = !!sub.contatto && possiedePareteDivisorio;
          const elementiSub = elementi.filter(
            (el) => el.distanzaSn >= sub.a && el.distanzaSn + el.larghezza <= sub.b,
          );
          const angoloStart = sub.angoloStart;
          const angoloEnd = sub.angoloEnd;
          if (elementiSub.length === 0) {
            if (angoloStart || angoloEnd) {
              this.insertPannelliLatoConCompenso270(
                subLen,
                latoPannello,
                objLato,
                altezza,
                cellaDati,
                angoloStart,
                angoloEnd,
                false,
                false,
                treVie,
              );
            } else {
              this.insertPannelliLato(subLen, latoPannello, objLato, altezza, false, treVie);
            }
            return;
          }
          let startLeft = sub.a;
          elementiSub.forEach((el) => {
            const gap = el.distanzaSn - startLeft;
            if (gap > 0) {
              const gapStart = angoloStart && startLeft === sub.a;
              if (gapStart) {
                this.insertPannelliLatoConCompenso270(
                  gap,
                  latoPannello,
                  objLato,
                  altezza,
                  cellaDati,
                  true,
                  false,
                  false,
                  false,
                  treVie,
                );
              } else {
                this.insertPannelliLato(gap, latoPannello, objLato, altezza, false, treVie);
              }
            }
            if (el.porta) {
              const pannPorta: any = this.setPannello(
                latoPannello,
                el.porta.modelloPorta,
                el.porta.altezza,
                el.larghezza,
                el.porta,
              );
              pannPorta.treVie = treVie;
              objLato.pannelli.push(pannPorta);
              const hSopra = this.objCella.h - el.porta.altezza - (el.fb ? 40 : 0);
              if (hSopra > 0) {
                let codice: string = this.getCodice(latoPannello, cellaDati);
                codice +=
                  '' +
                  cellaDati.spessore.toString().padStart(2, '0') +
                  hSopra.toString().padStart(3, '0') +
                  el.larghezza.toString().padStart(3, '0');
                const pann: any = this.setPannello(latoPannello, codice, hSopra, el.larghezza, null);
                pann.fittizio = true;
                pann.sopraporta = true;
                pann.treVie = treVie;
                objLato.pannelli.push(pann);
              }
            } else if (el.fb) {
              const hFb = altezza - 40;
              if (hFb > 0 && el.larghezza > 0) {
                let codice: string = this.getCodice(latoPannello, cellaDati);
                codice +=
                  '' +
                  cellaDati.spessore.toString().padStart(2, '0') +
                  el.larghezza.toString().padStart(3, '0') +
                  hFb.toString().padStart(3, '0');
                const pann: any = this.setPannello(latoPannello, codice, hFb, el.larghezza, null);
                pann.fb = true;
                pann.fbCode = el.fb.descFreeBlock || '';
                pann.treVie = treVie;
                objLato.pannelli.push(pann);
              }
            }
            startLeft = el.distanzaSn + el.larghezza;
          });
          if (startLeft < sub.b) {
            const tailLen = sub.b - startLeft;
            if (angoloEnd) {
              this.insertPannelliLatoConCompenso270(
                tailLen,
                latoPannello,
                objLato,
                altezza,
                cellaDati,
                false,
                true,
                false,
                false,
                treVie,
              );
            } else {
              this.insertPannelliLato(tailLen, latoPannello, objLato, altezza, false, treVie);
            }
          }
        });
        if (!anyDrawn) {
          objLato.fittizio = true;
        }
        return;
      }

      // cella piccola: lato opposto al divisorio a tutta lunghezza → stessi compensatori del divisorio
      if (puntiSpecchioOpp.length > 0 && seg.tipo === 'normale') {
        const eps = 0.5;
        const cuts: number[] = [seg.a, seg.b];
        puntiSpecchioOpp.forEach((p) => {
          if (p < seg.a - eps || p > seg.b + eps) {
            return;
          }
          const clamped = Math.max(seg.a, Math.min(seg.b, p));
          if (!cuts.some((x) => Math.abs(x - clamped) <= eps)) {
            cuts.push(clamped);
          }
        });
        cuts.sort((x, y) => x - y);

        for (let i = 0; i < cuts.length - 1; i++) {
          const sa = cuts[i];
          const sb = cuts[i + 1];
          if (sb - sa <= eps) {
            continue;
          }
          const subLen = sb - sa;
          const angoloStart = puntiSpecchioOpp.some((p) => Math.abs(p - sa) <= eps);
          const angoloEnd = puntiSpecchioOpp.some((p) => Math.abs(p - sb) <= eps);
          const elementiSub = elementi.filter(
            (el) => el.distanzaSn >= sa && el.distanzaSn + el.larghezza <= sb,
          );
          if (elementiSub.length === 0) {
            if (angoloStart || angoloEnd) {
              this.insertPannelliLatoConCompenso270(
                subLen,
                latoPannello,
                objLato,
                altezza,
                cellaDati,
                angoloStart,
                angoloEnd,
                false,
                false,
              );
            } else {
              this.insertPannelliLato(subLen, latoPannello, objLato, altezza);
            }
            continue;
          }
          let startLeft = sa;
          elementiSub.forEach((el) => {
            const gap = el.distanzaSn - startLeft;
            if (gap > 0) {
              const gapStart = angoloStart && startLeft === sa;
              if (gapStart) {
                this.insertPannelliLatoConCompenso270(
                  gap,
                  latoPannello,
                  objLato,
                  altezza,
                  cellaDati,
                  true,
                  false,
                  false,
                  false,
                );
              } else {
                this.insertPannelliLato(gap, latoPannello, objLato, altezza);
              }
            }
            if (el.porta) {
              objLato.pannelli.push(
                this.setPannello(latoPannello, el.porta.modelloPorta, el.porta.altezza, el.larghezza, el.porta),
              );
              const hSopra = this.objCella.h - el.porta.altezza - (el.fb ? 40 : 0);
              if (hSopra > 0) {
                let codice: string = this.getCodice(latoPannello, cellaDati);
                codice +=
                  '' +
                  cellaDati.spessore.toString().padStart(2, '0') +
                  hSopra.toString().padStart(3, '0') +
                  el.larghezza.toString().padStart(3, '0');
                const pann: any = this.setPannello(latoPannello, codice, hSopra, el.larghezza, null);
                pann.fittizio = true;
                pann.sopraporta = true;
                objLato.pannelli.push(pann);
              }
            } else if (el.fb) {
              const hFb = altezza - 40;
              if (hFb > 0 && el.larghezza > 0) {
                let codice: string = this.getCodice(latoPannello, cellaDati);
                codice +=
                  '' +
                  cellaDati.spessore.toString().padStart(2, '0') +
                  el.larghezza.toString().padStart(3, '0') +
                  hFb.toString().padStart(3, '0');
                const pann: any = this.setPannello(latoPannello, codice, hFb, el.larghezza, null);
                pann.fb = true;
                pann.fbCode = el.fb.descFreeBlock || '';
                objLato.pannelli.push(pann);
              }
            }
            startLeft = el.distanzaSn + el.larghezza;
          });
          if (startLeft < sb) {
            const tailLen = sb - startLeft;
            if (angoloEnd) {
              this.insertPannelliLatoConCompenso270(
                tailLen,
                latoPannello,
                objLato,
                altezza,
                cellaDati,
                false,
                true,
                false,
                false,
              );
            } else {
              this.insertPannelliLato(tailLen, latoPannello, objLato, altezza);
            }
          }
        }
        return;
      }

      // 270° unite: compensatorio 27/31 vicino allo spigolo
      // se il confine è col fittizio di contatto, lo (sp+3) sta già lì → non ridoppiarlo qui
      const confineFittizioStep = (coord: number, adiacenteFittizio: boolean): boolean =>
        adiacenteFittizio &&
        this.isCompenso270ConfineFittizio(latoCella, coord, lunghLato, cellaDati, covers);
      const startDaFittizio = confineFittizioStep(seg.a, prev?.tipo === 'fittizio');
      const endDaFittizio = confineFittizioStep(seg.b, next?.tipo === 'fittizio');
      const angoloStart =
        startDaFittizio ||
        (seg.a <= 0 && angoliCorta.start) ||
        (seg.a <= 0 && compensoDivUnite.start);
      const angoloEnd =
        endDaFittizio ||
        (seg.b >= lunghLato && angoliCorta.end) ||
        (seg.b >= lunghLato && compensoDivUnite.end);

      const elementiSeg = elementi.filter(
        (el) => el.distanzaSn >= seg.a && el.distanzaSn + el.larghezza <= seg.b,
      );
      let startLeft = seg.a;

      if (elementiSeg.length === 0) {
        this.insertPannelliLatoConCompenso270(
          len,
          latoPannello,
          objLato,
          altezza,
          cellaDati,
          angoloStart,
          angoloEnd,
          startDaFittizio,
          endDaFittizio,
        );
        return;
      }

      elementiSeg.forEach((el) => {
        const gap = el.distanzaSn - startLeft;
        if (gap > 0) {
          const gapStart = angoloStart && startLeft === seg.a;
          this.insertPannelliLatoConCompenso270(
            gap,
            latoPannello,
            objLato,
            altezza,
            cellaDati,
            gapStart,
            false,
            gapStart && startDaFittizio,
            false,
          );
        }

        if (el.porta) {
          objLato.pannelli.push(
            this.setPannello(latoPannello, el.porta.modelloPorta, el.porta.altezza, el.larghezza, el.porta),
          );

          const hSopra = this.objCella.h - el.porta.altezza - (el.fb ? 40 : 0);
          if (hSopra > 0) {
            let codice: string = this.getCodice(latoPannello, cellaDati);
            codice +=
              '' +
              cellaDati.spessore.toString().padStart(2, '0') +
              hSopra.toString().padStart(3, '0') +
              el.larghezza.toString().padStart(3, '0');
            const pann: any = this.setPannello(latoPannello, codice, hSopra, el.larghezza, null);
            pann.fittizio = true;
            pann.sopraporta = true;
            objLato.pannelli.push(pann);
          }
        } else if (el.fb) {
          // freeblock = come porta: un pannello nella sua posizione, altezza = cella - 40
          const hFb = altezza - 40;
          if (hFb > 0 && el.larghezza > 0) {
            let codice: string = this.getCodice(latoPannello, cellaDati);
            codice +=
              '' +
              cellaDati.spessore.toString().padStart(2, '0') +
              el.larghezza.toString().padStart(3, '0') +
              hFb.toString().padStart(3, '0');
            const pann: any = this.setPannello(latoPannello, codice, hFb, el.larghezza, null);
            pann.fb = true;
            pann.fbCode = el.fb.descFreeBlock || '';
            objLato.pannelli.push(pann);
          }
        }

        startLeft = el.distanzaSn + el.larghezza;
      });

      if (startLeft < seg.b) {
        const tailLen = seg.b - startLeft;
        this.insertPannelliLatoConCompenso270(
          tailLen,
          latoPannello,
          objLato,
          altezza,
          cellaDati,
          false,
          angoloEnd,
          false,
          angoloEnd && endDaFittizio,
        );
      }
    });
  }

  getObj(config:any=null){
   
   

    let lunghezzeModuli:any={};
    // =================
    // SOFFITTO
    // =================
    let currW=0;
    let currD=0;
    let cx=0;
    let cz=0;
    let pannello:any=null;
    let lunghezzeSoffitto= [20,40,60,80,100,120,140,160,180,200,220,240,260,280,300,320];

    let lunghezzePavimento= [60,80,100,120,140,160,180,200,220,240,260,280,320];
    let combPannelli:any={}; 
    if(this.cellaDati.soffittoMAXI){
      lunghezzeSoffitto.push(340);
      lunghezzeSoffitto.push(360);
      lunghezzeSoffitto.push(380);
      lunghezzeSoffitto.push(400);
      lunghezzeSoffitto.push(420);
      lunghezzeSoffitto.push(440);
    }
    if(this.cellaDati.ruotasoffitto){
      currW=this.objCella.d;
      currD=this.objCella.w;
      lunghezzeModuli=this.riempiLato(this.objCella.d);
      combPannelli=this.riempiLatoCombFisse(this.objCella.w,'soffitto');
      if(combPannelli.length==0){
        combPannelli=this.riempiLato3(this.objCella.w,lunghezzeSoffitto);
      }
    
    } else {
      currW=this.objCella.w;
      currD=this.objCella.d;
      lunghezzeModuli=this.riempiLato(this.objCella.w);
      
      combPannelli=this.riempiLatoCombFisse(this.objCella.d,'soffitto');
      if(combPannelli.length==0){
        combPannelli=this.riempiLato3(this.objCella.d,lunghezzeSoffitto);
      }
    }
    if(!combPannelli){
      return;
    }
    this.cellaDati.combPannelliSoffitto=combPannelli;
    this.objSoffitto={
      x:0,
      y:this.objCella.h-this.cellaDati.spessore,
      z:0,
      pannelli:[]
    };

    for(let j:number=0;j<lunghezzeModuli.d120;j++){
      cx=0;
      cz=0;
      combPannelli.forEach((curp:any)=>{
        currD=curp.segment;
        for(let q:number=0;q<curp.count;q++){
          let codice:string=this.getCodice('soffitto',this.cellaDati);
          codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+'120'+currD.toString().padStart(3,"0");
          if(!this.cellaDati.ruotasoffitto){
            pannello=this.setPannello('soffitto',codice,currD,120);
            pannello.z=cz;
            cz+=currD;
            this.objSoffitto.pannelli.push(pannello);
          } else {
            pannello=this.setPannello('soffitto',codice,120,currD);
            pannello.z=cz;
            cz+=currD;
            this.objSoffitto.pannelli.push(pannello);
          }
        }
      });
    }
    for(let j:number=0;j<lunghezzeModuli.d100;j++){
      cx=0;
      cz=0;
      combPannelli.forEach((curp:any)=>{
        currD=curp.segment;
        for(let q:number=0;q<curp.count;q++){
          let codice:string=this.getCodice('soffitto',this.cellaDati);
          codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+'100'+currD.toString().padStart(3,"0");
          if(!this.cellaDati.ruotasoffitto){
            pannello=this.setPannello('soffitto',codice,currD,100);
            pannello.z=cz;
            cz+=currD;
            this.objSoffitto.pannelli.push(pannello);
          } else {
            pannello=this.setPannello('soffitto',codice,100,currD);
            pannello.z=cz;
            cz+=currD;
            this.objSoffitto.pannelli.push(pannello);
          }
        }
      });
    }
    for(let j:number=0;j<lunghezzeModuli.d80;j++){
      cx=0;
      cz=0;
      combPannelli.forEach((curp:any)=>{
        currD=curp.segment;
        for(let q:number=0;q<curp.count;q++){
          let codice:string=this.getCodice('soffitto',this.cellaDati);
          codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+'080'+currD.toString().padStart(3,"0");
          if(!this.cellaDati.ruotasoffitto){
            pannello=this.setPannello('soffitto',codice,currD,80);
            pannello.z=cz;
            cz+=currD;
            this.objSoffitto.pannelli.push(pannello);
          } else {
            pannello=this.setPannello('soffitto',codice,80,currD);
           pannello.z=cz;
           cz+=currD;
            this.objSoffitto.pannelli.push(pannello);
          }
        }
      });
    }
    for(let j:number=0;j<lunghezzeModuli.d60;j++){
      cx=0;
      cz=0;
      combPannelli.forEach((curp:any)=>{
      currD=curp.segment;
      for(let q:number=0;q<curp.count;q++){
        let codice:string=this.getCodice('soffitto',this.cellaDati);
        codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+'060'+currD.toString().padStart(3,"0");
        if(!this.cellaDati.ruotasoffitto){
          pannello=this.setPannello('soffitto',codice,currD,60);
          pannello.z=cz;
          cz+=currD;
          this.objSoffitto.pannelli.push(pannello);
        } else {
          pannello=this.setPannello('soffitto',codice,60,currD);
          pannello.z=cz;
           cz+=currD;
          this.objSoffitto.pannelli.push(pannello);
          }
        }
      });
    }
    for(let j:number=0;j<lunghezzeModuli.d40;j++){
      cx=0;
      cz=0;
      combPannelli.forEach((curp:any)=>{
      currD=curp.segment;
        for(let q:number=0;q<curp.count;q++){
          let codice:string=this.getCodice('soffitto',this.cellaDati);
          codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+'040'+currD.toString().padStart(3,"0");
          if(!this.cellaDati.ruotasoffitto){
            pannello=this.setPannello('soffitto',codice,currD,40);
            pannello.z=cz;
            cz+=currD;
            this.objSoffitto.pannelli.push(pannello);
          } else {
            pannello=this.setPannello('soffitto',codice,40,currD);
            pannello.z=cz;
            cz+=currD;
            this.objSoffitto.pannelli.push(pannello);
          }
        }
      });
    }
    for(let j:number=0;j<lunghezzeModuli.d20;j++){
      cx=0;
      cz=0;
      combPannelli.forEach((curp:any)=>{
        currD=curp.segment;
        for(let q:number=0;q<curp.count;q++){
          let codice:string=this.getCodice('soffitto',this.cellaDati);
          codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+'020'+currD.toString().padStart(3,"0");
          if(!this.cellaDati.ruotasoffitto){
            pannello=this.setPannello('soffitto',codice,currD,20);
            pannello.z=cz;
            cz+=currD;
            this.objSoffitto.pannelli.push(pannello);
          } else {
            pannello=this.setPannello('soffitto',codice,20,currD);
            pannello.z=cz;
           cz+=currD;
            this.objSoffitto.pannelli.push(pannello);           
          }
        }
      });
    }

    

   
    // =================
    // VESPAIO
    // =================
    if(this.cellaDati.vespaio){
      this.getObjVespaio();
    } else {
      this.objVespaio={
        pannelli:[]
      }
    }

    // =================
    // PAVIMENTO
    // =================
 

    this.objPavimento={
      x:0,
      y:0,
      z:0,
      pannelli:[]
    };
    

  if(this.cellaDati.pavimenti){
    if(this.cellaDati.ruotaPavimento){
      lunghezzeModuli=this.riempiLato(this.objCella.d);
      currW=this.objCella.d;
      currD=this.objCella.w;
      combPannelli=this.riempiLatoCombFisse(this.objCella.w,'pavimento');
      if(combPannelli.length==0){
          combPannelli=this.riempiLato3(this.objCella.w,lunghezzePavimento);
      }
    } else {
      lunghezzeModuli=this.riempiLato(this.objCella.w);
      currW=this.objCella.w;
      currD=this.objCella.d;
      combPannelli=this.riempiLatoCombFisse(this.objCella.d,'pavimento');
      if(combPannelli.length==0){
          combPannelli=this.riempiLato3(this.objCella.d,lunghezzePavimento);
      }
    }
    
     
    if(!combPannelli){
      return;
    }
    
    for(let j:number=0;j<lunghezzeModuli.d120;j++){
      cx=0;
      cz=0;
      combPannelli.forEach((curp:any)=>{
        currD=curp.segment;
        for(let q:number=0;q<curp.count;q++){
          let codice:string=this.getCodice('pavimento',this.cellaDati);
          codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+'120'+currD.toString().padStart(3,"0");
          if(!this.cellaDati.ruotaPavimento){
            pannello=this.setPannello('pavimento',codice,currD,120);
          } else {
            pannello=this.setPannello('pavimento',codice,120,currD);
          }
          pannello.z=cz;
          cz+=currD;
          this.objPavimento.pannelli.push(pannello);
        }
      });
    }
    for(let j:number=0;j<lunghezzeModuli.d100;j++){
      cx=0;
      cz=0;
      combPannelli.forEach((curp:any)=>{
        currD=curp.segment;
        for(let q:number=0;q<curp.count;q++){
          let codice:string=this.getCodice('pavimento',this.cellaDati);
          codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+'100'+currD.toString().padStart(3,"0");
          if(!this.cellaDati.ruotaPavimento){
            pannello=this.setPannello('pavimento',codice,currD,100);
          } else {
            pannello=this.setPannello('pavimento',codice,100,currD);
          }
          pannello.z=cz;
          cz+=currD;
          this.objPavimento.pannelli.push(pannello);
        }
      });
    }
    for(let j:number=0;j<lunghezzeModuli.d80;j++){
      cx=0;
      cz=0;
      combPannelli.forEach((curp:any)=>{
        currD=curp.segment;
        for(let q:number=0;q<curp.count;q++){
          let codice:string=this.getCodice('pavimento',this.cellaDati);
          codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+'080'+currD.toString().padStart(3,"0");
          if(!this.cellaDati.ruotaPavimento){
            pannello=this.setPannello('pavimento',codice,currD,80);
          } else {
            pannello=this.setPannello('pavimento',codice,80,currD);
          }
          pannello.z=cz;
          cz+=currD;
          this.objPavimento.pannelli.push(pannello);
        }
      });
    }
    for(let j:number=0;j<lunghezzeModuli.d60;j++){
      cx=0;
      cz=0;
      combPannelli.forEach((curp:any)=>{
        currD=curp.segment;
        for(let q:number=0;q<curp.count;q++){
          let codice:string=this.getCodice('pavimento',this.cellaDati);
          codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+'060'+currD.toString().padStart(3,"0");
        
          if(!this.cellaDati.ruotaPavimento){
            pannello=this.setPannello('pavimento',codice,currD,60);
          } else {
            pannello=this.setPannello('pavimento',codice,60,currD);
          }
          pannello.z=cz;
          cz+=currD;
          this.objPavimento.pannelli.push(pannello);
        }
      });
    }
    for(let j:number=0;j<lunghezzeModuli.d40;j++){
      cx=0;
      cz=0;
      combPannelli.forEach((curp:any)=>{
        currD=curp.segment;
        for(let q:number=0;q<curp.count;q++){
          let codice:string=this.getCodice('pavimento',this.cellaDati);
          codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+'040'+currD.toString().padStart(3,"0");
          if(!this.cellaDati.ruotaPavimento){
            pannello=this.setPannello('pavimento',codice,currD,40);
          } else {
            pannello=this.setPannello('pavimento',codice,40,currD);
          }
          pannello.z=cz;
          cz+=currD;
          this.objPavimento.pannelli.push(pannello);
        }
      });
    }
    for(let j:number=0;j<lunghezzeModuli.d20;j++){
      cx=0;
      cz=0;
      combPannelli.forEach((curp:any)=>{
        currD=curp.segment;
        for(let q:number=0;q<curp.count;q++){
          let codice:string=this.getCodice('pavimento',this.cellaDati);
          codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+'020'+currD.toString().padStart(3,"0");
          if(!this.cellaDati.ruotaPavimento){
            pannello=this.setPannello('pavimento',codice,currD,20);
          } else {
            pannello=this.setPannello('pavimento',codice,20,currD);
          }
          pannello.z=cz;
          cz+=currD;
          this.objPavimento.pannelli.push(pannello);
        }
      });
    }
  }
  

    // =================
    // FRONTE
    // =================
    let lungh=this.objCella.d;
    this.objFronte={
      x:0,
      y:0,
      z:0,
      pannelli:[]
    };
    
    this.startLeft=0;
    /*
    elementiLato: comprende freblock porte e celle unite
      distanzaSn: distanza da sinistra o dal basso 
      larghezza= larghezza dell'elemento
      porta: oggetto porta se è una porta
      fb: freeblock
    */
    let celleUniteSulLato=[];
    let lunghTot=0;
    let elementiFiltered:any=null;
    let elementiLato:any=null;
    let cellaCollLatoComb:any=null;
    let cellaCollLato:any=null;
    let esistePortaNonComb:any=null;
    let esistePortaLtoComb:any=null;

    let calcCelle=this.calcolaCelleUniteSulLato(config,'lato_fronte');
    celleUniteSulLato=calcCelle.celleUniteSulLato;
    if(celleUniteSulLato.length==0 || (celleUniteSulLato.length>0 && celleUniteSulLato[0].id==this.cellaDati.id)){
   
      lunghTot=calcCelle.lunghTot;
      elementiLato=this.getElementiLato('lato_fronte',config,this.cellaDati,null,celleUniteSulLato);
      elementiFiltered=elementiLato.filter((x:any)=>x.larghezza>0 || x.distanzaSn>0);
      cellaCollLatoComb=this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_fronte' && x.latocombinato).length>0;
      cellaCollLato=this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_fronte').length>0;
      esistePortaNonComb=this.esistePortaLatoNonCombinato('lato_fronte',config);
      esistePortaLtoComb=this.esistePortaLatoNonCombinato('lato_retro',config);
      if(celleUniteSulLato && celleUniteSulLato.length>0 && ( !cellaCollLato || (cellaCollLato && !esistePortaNonComb) || (  (!cellaCollLato  && esistePortaLtoComb) ))){
        elementiFiltered.forEach((p:any)=>{     
          if(p.distanzaSn>0){
              if(!this.angoloNovanta(config,'lato_fronte',this.cellaDati,this.startLeft,p.distanzaSn)){
                this.insertPannelliLato(p.distanzaSn-this.startLeft,'fronte_retro',this.objFronte,this.cellaDati.altezza);
              }
          }
          if(p.porta){
            this.startLeft=p.distanzaSn+p.larghezza; 
            this.objFronte.pannelli.push(this.setPannello('fronte_retro',p.porta.modelloPorta,p.porta.altezza,p.larghezza,p.porta));
            if(this.objCella.h-p.porta.altezza-(p.fb?40:0)>0){
              let codice:string=this.getCodice('fronte_retro',this.cellaDati);
              codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+(this.objCella.h-p.porta.altezza-(p.fb?40:0)).toString().padStart(3,"0")+p.larghezza.toString().padStart(3,"0");
              let pann:any=this.setPannello('fronte_retro',codice,this.objCella.h-p.porta.altezza-(p.fb?40:0),p.larghezza,null);
              pann.fittizio=true;
              pann.sopraporta=true;
              this.objFronte.pannelli.push(pann);
            }
      
          } else { // freeblock o celle unite
            if(!p.fb){ 
            this.startLeft=p.distanzaSn+p.larghezza;
              this.insertPannelliLato(p.larghezza,'fronte_retro',this.objFronte,this.cellaDati.altezza,p.tipoCollegamento=='unite',true);
            } else {
              this.startLeft=p.distanzaSn+p.larghezza;
              this.insertPannelliLato(p.larghezza,'fronte_retro',this.objFronte,this.cellaDati.altezza-40);
              this.objFronte.pannelli[this.objFronte.pannelli.length-1].fb=true;
              this.objFronte.pannelli[this.objFronte.pannelli.length-1].fbCode=p.fb.descFreeBlock;
            }
          }
        });

        if(this.startLeft<lunghTot && (elementiLato.length==0 || elementiFiltered.length>0)){
          if(!this.angoloNovanta(config,'lato_fronte',this.cellaDati,this.startLeft,lunghTot)){
            this.insertPannelliLato(lunghTot-this.startLeft,'fronte_retro',this.objFronte,this.cellaDati.altezza);
          }

        }
      } else {
        this.objFronte.fittizio=true;
      }
    }

   
        
    // =================
    // RETRO
    // =================
    lungh=this.objCella.d;
  
    this.objRetro={
      x:this.objCella.w,
      y:0,
      z:0,
      pannelli:[]
    };
    
    celleUniteSulLato=[];
    lunghTot=0;

    calcCelle=this.calcolaCelleUniteSulLato(config,'lato_retro');
    celleUniteSulLato=calcCelle.celleUniteSulLato;
    if(celleUniteSulLato.length>0 && celleUniteSulLato[0].id==this.cellaDati.id){
      lunghTot=calcCelle.lunghTot;
      
      this.startLeft=0;
      elementiLato=this.getElementiLato('lato_retro',config,this.cellaDati,null,celleUniteSulLato);

      elementiFiltered=elementiLato.filter((x:any)=>x.larghezza>0 || x.distanzaSn>0);
      cellaCollLatoComb=this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_retro' && x.latocombinato).length>0;
      cellaCollLato=this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_retro').length>0; 
      esistePortaNonComb=this.esistePortaLatoNonCombinato('lato_retro',config);
      esistePortaLtoComb=this.esistePortaLatoNonCombinato('lato_fronte',config);

      if(celleUniteSulLato && celleUniteSulLato.length>0 && ( !cellaCollLato || (cellaCollLato && !esistePortaNonComb) || (  (!cellaCollLato  && esistePortaLtoComb) ))){
          elementiFiltered.forEach((p:any)=>{
          if(p.distanzaSn>0){
            if(!this.angoloNovanta(config,'lato_retro',this.cellaDati,this.startLeft,p.distanzaSn)){
              this.insertPannelliLato(p.distanzaSn-this.startLeft,'fronte_retro',this.objRetro,this.cellaDati.altezza);
            }
          }
          if(p.porta){
            this.startLeft=p.distanzaSn+p.larghezza;
          
            this.objRetro.pannelli.push(this.setPannello('fronte_retro',p.porta.modelloPorta,p.porta.altezza,p.larghezza,p.porta));
            if(this.objCella.h-p.porta.altezza-(p.fb?40:0)>0){
              let codice:string=this.getCodice('fronte_retro',this.cellaDati);
              codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+(this.objCella.h-p.porta.altezza-(p.fb?40:0)).toString().padStart(3,"0")+p.larghezza.toString().padStart(3,"0");
              let pann:any=this.setPannello('fronte_retro',codice,this.objCella.h-p.porta.altezza-(p.fb?40:0),p.larghezza,null);
              pann.fittizio=true;
              pann.sopraporta=true;
              this.objRetro.pannelli.push(pann);
            }
          } else { // freeblock o celle unite
            if(!p.fb){ // cella unita
              this.startLeft=p.distanzaSn+p.larghezza;
              this.insertPannelliLato(p.larghezza,'fronte_retro',this.objRetro,this.cellaDati.altezza,p.tipoCollegamento=='unite',true);
            } else {
              this.startLeft=p.distanzaSn+p.larghezza;
              this.insertPannelliLato(p.larghezza,'fronte_retro',this.objRetro,this.cellaDati.altezza-40);
              this.objRetro.pannelli[this.objRetro.pannelli.length-1].fb=true;
              this.objRetro.pannelli[this.objRetro.pannelli.length-1].fbCode=p.fb.descFreeBlock;
            }
          }
        });
        if(this.startLeft<lunghTot && (elementiLato.length==0 || elementiFiltered.length>0)){
          if(!this.angoloNovanta(config,'lato_retro',this.cellaDati,this.startLeft,lunghTot)){
            this.insertPannelliLato(lunghTot-this.startLeft,'fronte_retro',this.objRetro,this.cellaDati.altezza);
          }
        }
      } else {
        this.objRetro.fittizio=true;
      }
    } 

    
    // =================
    // LAT SIN
    // =================
    lungh=this.objCella.w;
    this.objLatSin={
      x:0,
      y:0,
      z:0,
      pannelli:[]
    };
   
     
    celleUniteSulLato=[];
    lunghTot=0;
    calcCelle=this.calcolaCelleUniteSulLato(config,'lato_sn');
    celleUniteSulLato=calcCelle.celleUniteSulLato;

    if(celleUniteSulLato.length>0 && celleUniteSulLato[0].id==this.cellaDati.id){
      lunghTot=calcCelle.lunghTot;

      this.startLeft=0;
      elementiLato=this.getElementiLato('lato_sn',config,this.cellaDati,null,celleUniteSulLato);
      

      elementiFiltered=elementiLato.filter((x:any)=>x.larghezza>0 || x.distanzaSn>0);
      cellaCollLatoComb=this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_sn' && x.latocombinato).length>0;
      cellaCollLato=this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_sn' ).length>0;
      esistePortaNonComb=this.esistePortaLatoNonCombinato('lato_sn',config);
      esistePortaLtoComb=this.esistePortaLatoNonCombinato('lato_ds',config);

      if(celleUniteSulLato && celleUniteSulLato.length>0 && ( !cellaCollLato || (cellaCollLato && !esistePortaNonComb) || (  (!cellaCollLato  && esistePortaLtoComb) ))){
        
          elementiFiltered.forEach((p:any)=>{
          if(p.distanzaSn>0){
            if(!this.angoloNovanta(config,'lato_sn',this.cellaDati,this.startLeft,p.distanzaSn)){
              this.insertPannelliLato(p.distanzaSn-this.startLeft,'laterale',this.objLatSin,this.cellaDati.altezza);
            }
          }
          if(p.porta){
            this.startLeft=p.distanzaSn+p.larghezza;
            this.objLatSin.pannelli.push(this.setPannello('laterale',p.porta.modelloPorta,p.porta.altezza,p.larghezza,p.porta));
            if(this.objCella.h-p.porta.altezza-(p.fb?40:0)>0){
              let codice:string=this.getCodice('laterale',this.cellaDati);
              codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+(this.objCella.h-p.porta.altezza-(p.fb?40:0)).toString().padStart(3,"0")+p.larghezza.toString().padStart(3,"0");
              let pann:any=this.setPannello('laterale',codice,this.objCella.h-p.porta.altezza-(p.fb?40:0),p.larghezza,null);
              pann.fittizio=true;
              pann.sopraporta=true;
              this.objLatSin.pannelli.push(pann);
            }
          } else { // freeblock o celle unite
            if(!p.fb){ // cella unita
              this.startLeft=p.distanzaSn+p.larghezza;
              this.insertPannelliLato(p.larghezza,'laterale',this.objLatSin,this.cellaDati.altezza,p.tipoCollegamento=='unite',true);
            } else {
              this.startLeft=p.distanzaSn+p.larghezza;
              this.insertPannelliLato(p.larghezza,'laterale',this.objLatSin,this.cellaDati.altezza-40);
              this.objLatSin.pannelli[this.objLatSin.pannelli.length-1].fb=true;
              this.objLatSin.pannelli[this.objLatSin.pannelli.length-1].fbCode=p.fb.descFreeBlock;
            }
          }
        });
        if(this.startLeft<lunghTot && (elementiLato.length==0 || elementiFiltered.length>0)){
          if(!this.angoloNovanta(config,'lato_sn',this.cellaDati,this.startLeft,lunghTot)){
            this.insertPannelliLato(lunghTot-this.startLeft,'laterale',this.objLatSin,this.cellaDati.altezza);
        }
        }
      } else {
        this.objLatSin.fittizio=true;
      }
    }
      
     // =================
    // LAT DS
    // =================
    lungh=this.objCella.w;
    
    this.objLatDs={
      x:0,
      y:0,
      z:this.objCella.d,
      pannelli:[]
    };
 

    celleUniteSulLato=[];
    lunghTot=0;
    calcCelle=this.calcolaCelleUniteSulLato(config,'lato_ds');
    celleUniteSulLato=calcCelle.celleUniteSulLato;
    if(celleUniteSulLato.length>0 && celleUniteSulLato[0].id==this.cellaDati.id){
      lunghTot=calcCelle.lunghTot;
    
      this.startLeft=0;
      elementiLato=this.getElementiLato('lato_ds',config,this.cellaDati,null,celleUniteSulLato);
    

      elementiFiltered=elementiLato.filter((x:any)=>x.larghezza>0 || x.distanzaSn>0);
      cellaCollLatoComb=this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_ds' && x.latocombinato).length>0;
      cellaCollLato=this.cellaDati.celleCollegate.filter((x:any)=>x.attivo && x.latocollegato=='lato_ds' ).length>0;
      esistePortaNonComb=this.esistePortaLatoNonCombinato('lato_ds',config);
      esistePortaLtoComb=this.esistePortaLatoNonCombinato('lato_sn',config);

      // non sono collegate 
      // collegate lato combinato guardo se esiste porta dall'altro lato
      if(celleUniteSulLato && celleUniteSulLato.length>0 && ( !cellaCollLato || (cellaCollLato && !esistePortaNonComb) || (  (!cellaCollLato  && esistePortaLtoComb) ))){

        elementiFiltered.forEach((p:any,ind:number)=>{
          if(p.distanzaSn>0){
            if(!this.angoloNovanta(config,'lato_ds',this.cellaDati,this.startLeft,p.distanzaSn)){
                this.insertPannelliLato(p.distanzaSn-this.startLeft,'laterale',this.objLatDs,this.cellaDati.altezza);
            }
          }
          if(p.porta){
            this.startLeft=p.distanzaSn+p.larghezza;
            this.objLatDs.pannelli.push(this.setPannello('laterale',p.porta.modelloPorta,p.porta.altezza,p.larghezza,p.porta));
            if(this.objCella.h-p.porta.altezza-(p.fb?40:0)>0){
              let codice:string=this.getCodice('laterale',this.cellaDati);
              codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+(this.objCella.h-p.porta.altezza-(p.fb?40:0)).toString().padStart(3,"0")+p.larghezza.toString().padStart(3,"0");
              let pann:any=this.setPannello('laterale',codice,this.objCella.h-p.porta.altezza-(p.fb?40:0),p.larghezza,null);
              pann.fittizio=true;
              pann.sopraporta=true;
              this.objLatDs.pannelli.push(pann);
            }
          } else { // freeblock o celle unite
            if(!p.fb){ // cella unita
              this.startLeft=p.distanzaSn+p.larghezza;
              this.insertPannelliLato(p.larghezza,'laterale',this.objLatDs,this.cellaDati.altezza,p.tipoCollegamento=='unite',true);
            } else {
              this.startLeft=p.distanzaSn+p.larghezza;
              this.insertPannelliLato(p.larghezza,'laterale',this.objLatDs,this.cellaDati.altezza-40);
              this.objLatDs.pannelli[this.objLatDs.pannelli.length-1].fb=true;
              this.objLatDs.pannelli[this.objLatDs.pannelli.length-1].fbCode=p.fb.descFreeBlock;
            }
          }
        });
        if(this.startLeft<lunghTot && (elementiLato.length==0 || elementiFiltered.length>0)){
          if(!this.angoloNovanta(config,'lato_ds',this.cellaDati,this.startLeft,lunghTot)){
            this.insertPannelliLato(lunghTot-this.startLeft,'laterale',this.objLatDs,this.cellaDati.altezza);
          }
        }
      } else {
        this.objLatDs.fittizio=true;
      }
    }  
    
    
       
  // =================
  // DIVISORI
  // =================
    this.objDivisori=[];
    lungh=this.objCella.d;

    this.cellaDati.divisori.forEach((divisorio:any)=>{
      let objDivisoriCurr:any={
              x:divisorio.type=='divisorioorizz' ?  divisorio.distLato:0,
              y:0,
              z:divisorio.type!='divisorioorizz' ?  divisorio.distLato:0,
              w:divisorio.w,
              type:divisorio.type,
              pannelli:[]
            };

      this.startLeft=0;
      let latodiv='';
      if(divisorio.type=='divisorioorizz'){
        elementiLato=this.getElementiLato('lato_fronte',config,this.cellaDati,divisorio,null);
        latodiv='fronte_retro';
      } else {
        elementiLato=this.getElementiLato('lato_sn',config,this.cellaDati,divisorio,null);
        latodiv='laterale';
      }
      

      elementiFiltered=elementiLato.filter((x:any)=>x.larghezza>0 || x.distanzaSn>0);
      elementiFiltered.forEach((p:any)=>{
        if(p.distanzaSn>0){
            this.insertPannelliLato(p.distanzaSn-this.startLeft,latodiv,objDivisoriCurr,this.cellaDati.altezza);
        }
        if(p.porta){
          this.startLeft=p.distanzaSn+p.larghezza;
          objDivisoriCurr.pannelli.push(this.setPannello(latodiv,p.porta.modelloPorta,p.porta.altezza,p.larghezza,p.porta));
        } else { // freeblock o celle unite
          if(!p.fb){ 
            this.startLeft=p.distanzaSn+p.larghezza;
            this.insertPannelliLato(p.larghezza,latodiv,objDivisoriCurr,this.cellaDati.altezza,true);
          } else {
            this.startLeft=p.distanzaSn+p.larghezza;
            this.insertPannelliLato(p.larghezza,latodiv,objDivisoriCurr,this.cellaDati.altezza);
          }
        }
      });

      if(this.startLeft<this.objCella.d && (elementiLato.length==0 || elementiFiltered.length>0)){
          this.insertPannelliLato(divisorio.w-this.startLeft,latodiv,objDivisoriCurr,this.cellaDati.altezza);
      }

      
      this.objDivisori.push(objDivisoriCurr);
    });
   

   
      this.getObj2(this.objCella, this.cellaDati, config);
   //   this.objCella.objRetro=this.objRetro;
   //   this.objCella.objFronte=this.objFronte;
   //   this.objCella.objLatSin=this.objLatSin;
   //   this.objCella.objLatDs=this.objLatDs;

      this.objCella.objSoffitto=this.objSoffitto;
      this.objCella.objPavimento=this.objPavimento;
      this.objCella.objSoffitto=this.objSoffitto;
      
      this.objCella.objVespaio=this.objVespaio;
      this.objCella.objDivisori=this.objDivisori;
  
    return;
  }
  
  insertPannello(latoObj:any,lato:string,largp:number,altezza:number,fittizio=false,treVie=false){
      let codice:string=this.getCodice(lato,this.cellaDati);
      codice+=''+this.cellaDati.spessore.toString().padStart(2,"0")+largp.toString().padStart(3,"0")+altezza.toString().padStart(3,"0");
      let p:any=this.setPannello(lato,codice,this.objCella.h,largp);
      p.fittizio=fittizio;
      p.treVie=treVie;
      latoObj.pannelli.push(p);
    
  }

  setPannello(lato:string,codice:string,h:number,w:number,objp=null){
    if(objp){ // porta
      return {
                side:lato,
                name:codice,
                porta:objp,
                text:w+'x'+h,
                w:w,
                h:h,
                d:this.cellaDati.spessore,
                treVie:false
              }
    } else {
      return {
          side:lato,
          name:codice,
          text:w+'x'+h,
          w:w,
          h:h,
          d:this.cellaDati.spessore,
          treVie:false
        }
    }
   
  
  }

  setPannelloContent(finitura:string){
    if(finitura=='STANDARD'){
      return this.pannelloPlasticContent;
    } else {
      return this.pannelloInoxContent;
    }

  }

  
  setCellaContent(cella:any,elencoCelle:any,nodo1:any=null,nodo2:any=null){
    let cellacolLeft=false;
    let cellacoRight=false;
    let cellacolTop=false;
    let cellacoBottom=false;

    let colortop=this.pannelloPanna;
    let colorbottom=this.pannelloPanna;
    let colorleft=this.pannelloPanna;
    let colorright=this.pannelloPanna;
    let style=''
    let margin='height:calc(100% + '+(2*cella.spessore)+'px);width:calc(100% + '+(2*cella.spessore)+'px);;margin-top:-'+cella.spessore+'px;margin-left:-'+cella.spessore+'px;';

    if(cella.finitura!='STANDARD'){
      colortop=this.pannelloAzzurro;
      colorbottom=this.pannelloAzzurro;
      colorleft=this.pannelloAzzurro;
      colorright=this.pannelloAzzurro;
    }
 
    cella.celleCollegate.filter((x:any)=>x.attivo).forEach((cc:any)=>{
       if((cc.tipoCollegamento=='collegateDivisorio' || cc.tipoCollegamento=='combinate')){

   //   if((cc.tipoCollegamento=='collegateDivisorio' || cc.tipoCollegamento=='combinate') && !cc.latocombinato){
        switch (cc.latocollegato) {
          case 'lato_retro':
              colortop='transparent';
              cellacolTop=true;
              break;
          case 'lato_fronte':
              colorbottom='transparent';
              cellacoBottom=true;
              break;
          case 'lato_ds':
              colorright='transparent';
              cellacoRight=true;
              break;
          case 'lato_sn':
              colorleft='transparent';
              cellacolLeft=true;
              break;               
        }
      }
      if((cc.tipoCollegamento=='collegateDivisorio' || cc.tipoCollegamento=='combinate') && !cc.latocombinato){
        switch (cc.latocollegato) {
          case 'lato_retro':
       //       margin='height:calc(100% + '+(2*cella.spessore)+'px);width:calc(100% + '+(2*cella.spessore)+'px);;margin-top:0px;margin-left:-'+cella.spessore+'px;';
              break;
          case 'lato_fronte':
        //      margin='height:100%;width:calc(100% + '+(2*cella.spessore)+'px);;margin-top:0px;margin-left:-'+cella.spessore+'px;';
              break;
          case 'lato_ds':
        //       margin='height:calc(100% + '+(2*cella.spessore)+'px);width:100%;margin-top:-'+cella.spessore+'px;margin-left:0px;';
              break;
          case 'lato_sn':
         //      margin='height:calc(100% + '+(2*cella.spessore)+'px);width:calc(100% + '+(2*cella.spessore)+'px);;margin-top:-'+cella.spessore+'px;margin-left:0px;';
          
              break;               
        }
      }

      if(cc.tipoCollegamento=='unite' ){
        if(cc.latocollegato=='lato_sn' || cc.latocollegato=='lato_ds'){
          if(nodo1.height>nodo2.height){

          } else {

          }
        }

        switch (cc.latocollegato) {
          case 'lato_retro':
              colortop='transparent';
              break;
          case 'lato_fronte':
              colorbottom='transparent';
              break;
          case 'lato_ds':
              colorright='transparent';
              break;
          case 'lato_sn':
              colorleft='transparent';
              break;               
        }
      }
     }); 

     
    let stringaClasse="";
    if(cellacolLeft || cellacoRight || cellacolTop || cellacoBottom ){
      stringaClasse='bordo'+cella.spessore;
    }

    if(cellacolLeft ){
      stringaClasse+='L';
    }
    if(cellacoRight ){
      stringaClasse+='R';
    }
    if(cellacolTop ){
      stringaClasse+='T';
    }
    if(cellacoBottom ){
      stringaClasse+='B';
    }
    return `<div class="`+stringaClasse+`" style="background-color:`+this.coloreSfondoCella+`;`+margin+`
      border-top:`+cella.spessore+`px solid `+colortop+`;
      border-bottom:`+cella.spessore+`px solid `+colorbottom+`;
      border-left:`+cella.spessore+`px solid `+colorleft+`;background-clip: padding-box; 
      border-right:`+cella.spessore+`px solid `+colorright+`;`+style+`
      "></div>`; 
    
     /*
    return `<div style="background-color:`+this.coloreSfondoCella+`;`+margin+`
      border-top:`+cella.spessore+`px solid `+colortop+`;
      border-bottom:`+cella.spessore+`px solid `+colorbottom+`;
      border-left:`+cella.spessore+`px solid `+colorleft+`;
      border-right:`+cella.spessore+`px solid `+colorright+`;`+style+`
      "></div>`; 
       */
  }

  checkCellaPerlatoTrasp(cella1:any,cella2:any,latoCollegato:string){
   
  }

  
  changedivisorioCella(event:any,cellaDati:any,prev:any){
    if(cellaDati.divisorioCella==''){
      return;
    }
    if(cellaDati.divisorioCella=='conPorta'){
      this.onChangeSpessore(cellaDati,prev.lang);
      cellaDati.portaDivisorio.lato_porta=cellaDati.lato_raccordo;
      this.changeModelloPorta(null,cellaDati,cellaDati.portaDivisorio,'divisorio');
    }
  }

  calcIngombri(diagram:Diagram){
     let minX=-1;
      let maxX=-1;
      let minY=-1;
      let maxY=-1;

      // calcola ingombro massimo
      (diagram as Diagram).nodes.forEach((c:any)=>{
          if(c.addInfo.type=='cella' && (minX==-1 || Math.round(c.offsetX-c.width/2)<minX)){
          minX=Math.round(c.offsetX-c.width/2);
          }
          if(c.addInfo.type=='cella' && (maxX==-1 || Math.round(c.offsetX+c.width/2)>maxX)){
          maxX=Math.round(c.offsetX+c.width/2);
          }
          if(c.addInfo.type=='cella' && (minY==-1 || Math.round(c.offsetY-c.height/2)<minY)){
          minY=Math.round(c.offsetY-c.height/2);
          }
        if(c.addInfo.type=='cella' && (maxY==-1 || Math.round(c.offsetY+c.height/2)>maxY)){
          maxY=Math.round(c.offsetY+c.height/2);
          }
      });
      return {
        minX:minX,
        maxX:maxX,
        minY:minY,
        maxY:maxY,
        
      };
  }

  userCellePreConf(){

    if((this.globalService.getUser().role=='AGENTE' || this.globalService.getUser().role=='UTENTE')  
      && this.globalService.getUser().organization=='DAGARD'){
      return true;
    } else {
      return false;
    }
    
  }
  
  saveAsExcelFile(buffer: any, fileName: string): void {
      let EXCEL_TYPE =
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE,
      });
      FileSaver.saveAs(
          data,
          fileName + '_' + new Date().getTime() + EXCEL_EXTENSION
      );
  }


}
